import { setExecBait } from './exec_bait'
import { setExecMortarDrip, setExecMortarMark, setExecMortarShell, setExecShout, setExecStepGlow, setExecStepWind, setExecTint } from './exec_look_1101'
import { setExecCloak, setExecCloakAlign, execCloakBladeAlignOn } from './exec_cloak'
import { setExecCannonFinisher } from './exec_cannon_finisher'
import { bladeClapSfx, bladeClapsCrossed, bladeClapSignalCrossed, setBladeFinisher } from './blade_finisher_v2'
import { setAwokenFaceRoom } from './awoken_face_room'
import { setAwokenBackWalk } from './awoken_back_walk'
import { setBladeBackStep } from './blade_back_step'
import { preloadKnightArc, setKnightArcLook } from './knight_arc_brush'
import { setAwokenFaceFront } from './awoken_face_front'
import { setMortarArc } from './exec_mortar_arc_1104'
import { setOverlapRead } from './overlap_read_1104'
import { setAwokenNeckBack } from './awoken_neck_back'
import { setAwokenBiteSpace } from './awoken_bite_space'
import { setAwokenWideStage } from './awoken_wide_stage'
import { setAwokenFaceGlow } from './awoken_face_glow'
import { setBrideVeilFx } from './bride_veil_hands'
import { setHoundRoarFx } from './hound_roar_floor'
import { setHoundGrab, setHoundMovesOld, setHoundTailPool, setHoundTriple, setHoundTriple2 } from './hound_kit'
import { setHoundPassThrough } from './hound_pass_through'
import { setHoundTempo } from './hound_tempo'
import { setHoundTune } from './hound_tune'
import { setHoundShort } from './hound_short'
import { setKnightRearmTween, setKnightRest, setKnightScrapeTurn } from './knight_rest'
import { setKnightWalkBridge } from './knight_walk_bridge'
import { setFinisherFootAnchor, finisherContactV2On, finisherReachFrontPx } from './executioner_finisher_foot'
import { EXEC_WEAPON_FIX_KEYS, execWeaponFixOn } from './executioner_weapon_fix'
import { setFinisherArtFrontOverride } from './exec_awoken_reach'
import { EXEC_PARRY, EXEC_PARRY_GLOW, execParryEnabled, execPushDustFx, setExecParryBigGain, setExecParryMode, setExecPushVersion, setStunRepress, setTutorialFinisher } from './exec_parry'
import { setStunCut, setStunCutLook, stunCutOn } from './stun_cut'
import { DEV_COLLAPSE_FOCUS, FOCUS_STEPS, currentLesson, isAssistedAttack, setTutAssistFirst, setTutFocusMode, stepTutorialFocus, tallyFocusOutcome, tutFocusMode, tutorialLessonsFor, type FocusContext } from './tut_focus'
import { setPushWeight } from './exec_push_weight'
import { execSlowCutNow, execSlowTimeScale, setExecParryFx } from './exec_parry_slow_fx'
import { setAwokenParriedArt, setExecParriedArt, setExecParryRecoil } from './exec_parry_recoil'
import { execParriedSlideDustFx, stepExecParriedSlide } from './exec_parried_slide'
/** 致命を弾いた後のゆっくりの間に、攻撃・パリィ・回避が押されたか (押したらスローを切る・1014c・A-3「少しもたつく」)。 */
const execSlowCutPressed = (input: Input): boolean => input.pressed.has('attack') || input.pressed.has('parry') || input.pressed.has('step')
import { execUniqueFaceStunned, execUniqueSignalCrossed, knightChargeDustFx, setExecHeartPx, setExecUnique, setExecUniqueBrideRise, setExecUniqueHold, setExecUniqueKnight, setExecUniqueRecover, setExecUniqueWall } from './exec_unique'
import { AWOKEN_DEVOUR_FLOOR_MOUTH_PX, awokenDevourClosesCrossed, awokenDevourSignalCrossed, setAwokenDevour, setAwokenDevourJaw } from './awoken_devour'
import { awokenPounceLandsCrossed, setPounceHopFast, setExecAuraEarly, setPounceLongFrames, setPounceNoRoom, setPounceTell } from './awoken_devour_pounce'
import { setSt6PlantFoot } from './exec_plant_foot'
import { setTweenFix } from './tween_fix'
import { setRecoverySway } from './recovery_sway'
import { setKnightLanceFx } from './knight_lance_fx'
import { setHoundTripleChase } from './hound_triple_chase'
import { braceThrustSwitched, onBraceThrustSwitch, setBraceThrustFromParams } from './exec_brace_thrust'
import { setMaulQuakeWallFromParams } from './exec_maulquake_wall'
import { setQuakeBackGapFromParams, setQuakeFrontGapFromParams } from './exec_quake_back_gap'
import { setDodgeFloorFromParams } from './dodge_floor_rule'
import { setExecJabSizeFromParams } from './exec_jab_size'
import { setExecJabSteps } from './exec_jab_steps_1028'
import { setHoundSmooth } from './hound_smooth_1028'
import { HOUND_ROAR_DEFAULT, HOUND_TRIPLE_ART_DEFAULT, setHoundRoarArt, setHoundTripleArt1031 } from './hound_road1_1031'
import { setShadeSlashSmooth } from './shade_slash_smooth_1028'
import { setKnightSmooth } from './knight_smooth_1028'
import { setExecCannonFajinSizeFromParams } from './exec_cannon_fajin_size'
import { setBrideFlurryFromParams } from './bride_flurry_trial'
import { setRoarWaveFromParams } from './exec_roar_wave'
import { setJabFixFromParams, syncJabFixDamage } from './exec_jab_fix'
import { setRoarTellFromParams } from './exec_roar_tell'
import { setRoarAirFromParams, setRoarAirRingSpeed } from './exec_roar_air'
import { setRoarCenterPathFromParams, setRoarCenterNudgeStill } from './exec_roar_center'
import { act2BlinkVisual, setAct2Blink } from './exec_act2_blink'
import { setKnightChargeHitOld } from './knight_charge_hit'
import { knightLungeDustFx } from './knight_lunge_dust'
import { execUniqueSfx, setExecUniqueSound } from './exec_unique_sound'
import { setAdvSoundTake } from './adv_sound'
import { houndActiveSfx, houndTellSfx, setHoundVoice } from './hound_voice_sound'
import { execActiveSfx, execBodySfx, execTellSfx, execTellSilent, setExecSound } from './exec_sound'
import { setBladeSfx } from './blade_sfx_v2'
import { bossSfxActive, bossSfxOn, bossSfxOwnsTell, bossSfxParried, bossSfxTellDue, setBossSfx, setTwinsRevealSfx } from './boss_sfx_v1'
import { setBrideHugSfx, setFinisherSfx } from './finisher_sound'
import { awokenActiveSfx, awokenRampageRoarSfx, awokenTellSfx, setAwokenRampageVoice, setAwokenVoice } from './awoken_voice_sound'
import { knightSweepSfx, parseKnightSweepSound, setKnightSweepSound } from './knight_sweep_sound'
import { setBossDuckDepthDb } from './sound_priority'
import { setHoundTripleRedraw } from './hound_triple_redraw'
import { knightTellSfx, parseKnightTellSound, setKnightTellSound } from './knight_telegraph_sound'
import { floorTellSfx, setFloorTellSound } from './floor_tell_sound'
import { beastBody, setBeastBodyTrial, setStanceBodyTrial } from './boss_body_envelope'
import { setAwokenPocketSpinEnabled } from './awoken_pocket_spin'
import { setBossAttackTravelMode } from './boss_attack_travel'
import { setBossNeutralMovementTrial } from './boss_neutral_movement'
import { setAwokenSpacingChoice, setAwokenHopTemporaryArt, setAwokenHopSlidePx } from './awoken_spacing_choice'
// 1tickのゲーム状態遷移オーケストレータ (Phase 4.5)。
// 順序: hitStop → 状態更新 → 戦闘解決 → 体幹回復 → 勝敗判定 → キャンペーン遷移 → シェイク。
// キャンペーン側にもイベントを反映: 攻撃目撃 / パリィ・回避・カウンター戦績 / 死亡・撃破。

import { tehonSparkFxLifeSec } from './parry_tehon_fx'
import type { CampaignState, FxEvent, GameState, ScreenShake, SfxId, SpriteKey, TutorialState } from './types'
import { beginKeyCapture, cancelKeyCapture, consume, consumeNav, keyCaptureView, setKeyBindings, type Input, type InputAction } from './input'
import { DEFAULT_KEY_BINDINGS } from './key_bindings'
import { CONTROLS_CLOSE_INDEX, CONTROLS_ITEM_COUNT, CONTROLS_RESET_INDEX, CONTROLS_ROWS, controlsHitAt, controlsInsidePanel, controlsItemRects } from './controls_panel'
import { CREDITS_PANEL, creditLines, creditsCloseRect, creditsMaxScroll, creditsPanelX } from './credits'
import { ARENA, BOSS, FIXED_DT, STAGGER_SPOT, TUTORIAL, arenaBoundsFor } from './balance'
import { setTutSix, tutSix, tutWallRoomX } from './tut_six'
import { VOICE_FOCUS, setTutVoice } from './tut_voice'
import { applyTutActs, setAdvChoiceLook, setBossHpLook } from './readability_1104'
import { hudV2, lampSnuffLifeSec, observeHudV2, setHudLook } from './hud_v2'
import { setTitleLook } from './title_v9'
import { createInitialState, createPlayer, createSoloState, noShake, bossIntroHolding, BOSS_INTRO_HOLD_MS } from './state'
import { setSwingFacing } from './swing_facing_trial'
import { updatePlayer, setStepCooldownMs, getStepCooldownMs, setCoreLandingMode, setBossCore, setCounterThrustStop, setCounterStopGap, isHeavyComboStep } from './player'
import { setExecuteSpacing, setFinisherSpacing } from './execute_spacing'
import { setMaulSetStop } from './exec_maulset_stop'
import { setMaulQuakeCharge } from './exec_quake_charge'
import { setExecFloorFx, setExecMortarLook } from './exec_floor_fx'
import { setExecCrackLook } from './quake_fx'
import { setExecFlameFx, setExecShotFx } from './exec_fx'
import { setExecAuraMode } from './exec_aura'
import { setExecStepFx } from './exec_step_dust'
import { setAwokenBrakeLook } from './awoken_rush_study'
import { setExecSwingLook } from './exec_fx_mats'
import { setRoarDustBoost, setRoarHazeLook, setRoarWaveRing, setRoarWaveWall } from './exec_roar_air_fx'
import { attackTimingOf } from './player_attack_timing'
import { updateBoss, setIdleEntryFaceFix, setDebugAltAttacks, setDebugBypassStrings, setBossApproachStopMode, setOverlapRegain, setBackAttackThresholdOverride, setBackAttackChainCap, setBossNeutralBackOff, setRetaliationEnabled } from './boss'
import { ATTACKS, getAttack, getAttackLabel } from './attacks'
import { bossPostureGainMul, parryGainHpMul, resolveExecuteHit, resolvePlayerAttack, setBossGuardEnabled } from './combat'
import { breakReadyRatio, setBossHudMode } from './boss_hud_view'
import { holdBladeQuickPracticeBoss } from './blade_quick_mannequin'
import { latestCastGroup, spawnCastProjectile, spawnMeleeHit, spawnZoneHits, updateHits } from './hits'
import { glintStarted, rampageContacts, spawnChoreoBites, spawnCue, spiritsDue } from './awoken_rampage_v5'
import { roosterGlintStarted } from './rooster_aerial_roam'
import { roosterDropGlintStarted, roosterFeatherAttack, roosterFeathersDue } from './rooster_vertical'
import { roosterRushPreTick, roosterRushAfterHits } from './rooster_rush'
import { isRoosterFrenzyAttack, roosterFrenzyAfterHits, roosterFrenzyPreTick, roosterFrenzyShape, roosterFrenzyTellSfx } from './rooster_frenzy'
import { withRoosterClawHop } from './rooster_claw_hop'
import { twinsDriveThisTick, twinsBossTick, twinsTakeHits, twinsAfterHits, twinsFilterHits, twinsFightOn, takeTwinsRevealShake } from './twins_fight'
import { staggerBoss } from './boss'
import { spawnWallHuntSpirits, wallHuntSpiritsDue } from './awoken_wall_hunt_game'
import { updateBossSpriteRuntime, setBossPoseScaleFixTrial, setSpriteFileOverride, setWalkPairOverride } from './sprites'
import { regenBossPosture, regenPlayerPosture } from './posture'
import {
  attackPoolForBoss, getBossDefinition, isFinalBossIndex, setExecutionerBladeGapMs, setBossCoreMode, type TutorialLesson,
} from './bosses'
import {
  executionerPool, mulsFor, setExecutionerDownswingChargeMs, setExecutionerMaulSetCreepPx, setExecutionerStepStyle,
  setExecutionerCannonMode, setExecutionerCannonScore, setExecutionerCannonHoldMs, setExecutionerMortarRows, executionerMorphTiming,
} from './executioner_weapon'
import {
  setExecutionerScoopVariant, setExecutionerSweepWindupTimeline, setExecutionerPierceArt, setExecutionerJabArt,
  type ExecutionerSweepWindupLook, setAwokenBiteOrder, setKnightSweepVariant, setKnightSweepWeight, getKnightSweepWeight, setKnightSweepGap, setKnightSweepLink, setKnightResetMode,
  setHoundArtOld, setExecFinisherFx, setBrideMotionArt, setBrideIssen,
} from './boss_pose_timeline'
import { setBrideKaeshi } from './bride_kaeshi'
import { setBrideRedraw } from './bride_redraw_1023'
import { setBrideHugBind } from './bride_hug_bind'
import { setBrideArtSample } from './bride_art_sample_1025'
import { emitKnightSuriEvents } from './knight_suri_gait'
import { knightStepDust } from './knight_step_dust'
import { knockSkidFx, knockSkidSound, knockSkidStarted, morphFx, morphShoveStarted } from './exec_knock_skid'
import { stepWeightDustFx } from './exec_step_weight'
import { setExecApproach } from './exec_finisher_step'
import { setKnightReachVariant } from './knight_reach'
import { parseKnightActs, setKnightActs } from './knight_acts'
import { setKnightSpacing, setKnightWallChargeEarly, setKnightBackoff, setKnightLeapOdds, setKnightLeapTell, setKnightStaleCharge, setKnightStaleRunRoom, setKnightCloseAnswer, setKnightClosePity, setKnightFinalActSingleMul } from './knight_spacing'
import { setKnightLeapFx } from './knight_spear_trail'
import { knightFloorScrape } from './knight_floor_scrape'
import { setFajinDraw, setFajinBeat, type FajinDraw, type FajinBeat } from './executioner_fajin'
import { setCannonFajinEnabled } from './executioner_cannon_fajin'
import {
  addAwakening,
  advanceToNextBoss,
  createCampaign,
  createScratchCampaign,
  hasCampaignProgress,
  isCampaignCleared,
  isDemoBoundary,
  markAttackSeen,
  markSceneSeen,
  onBossDefeat,
  onPlayerDeath,
  recordBossChoice,
  recordCounter,
  recordDodge,
  recordGuard,
  recordJustParry,
  recordParryFail,
  recordParrySuccess,
  resolveEnding,
} from './campaign'
import { startScene, tickAdv, isChoiceInputOpen, choiceRevealJustStarted, endsInBlackout, ADV_BATTLE_EXIT_MS, type AdvCue, type AdvInput, type AdvRuntime } from './adv'
import { battleEntryStep, battleExitDone, holdAdvEntry } from './battle_asset_gate'
import { SFX_CATALOG } from './audio'

// ADV の演出指示 `sfx:<id>`: 音のカタログにある id だけ鳴らす (まだ無い音は黙って飛ばす＝音の係が足せばそのまま鳴る)。
function advCueSfx(cue: AdvCue | null): SfxId[] {
  if (!cue?.startsWith('sfx:')) return []
  const id = cue.slice(4) as SfxId
  return SFX_CATALOG[id] ? [id] : []
}
import { getEndingScene, getInterludeScene, getPreBattleScene } from './adv_scripts'
import { choiceTimerOn } from './adv_fix2'
import { isSenshurakuOpen, loadCampaign, loadRecord, resetCampaign, resetEverything, saveCampaign, saveRecord, saveSettings } from './persistence'
import { foldAbandonedRunIntoRecord, foldRunIntoRecord, lifetimeTotals, markBossClearedEver, markEndingSeen } from './record'
import { achievementsOnBossCleared, achievementsOnRunCompleted, reportAchievementsToSteam, unlockAchievements } from './achievements'
import { getDifficulty, setDifficulty } from './difficulty'
import type { Difficulty } from './types'
import { finisherTimeScale, finisherDone, finisherBeat, T_SILENCE } from './finisher'
import { PIERCE, PULL, aliceBurstCrossed, lampExecLightLeadSec, lunaExecPierceOn, lunaExecSwap3On, lunaExecSwapOn, pullBossJoltPx, pullOutCrossed, setExecCrackPos, setLunaExecSwap, setNormalExecFix, setNormalExecPose, setPullBossScale } from './luna_exec_swap'
import { setBossRise, setBossRiseSmooth, setBossRiseFit } from './boss_rise'
import { CRACK } from './luna_lamp_leak_fx'
import { lunaNormalFxLifeSec, setLunaNormalFx } from './luna_unravel_fx'
import { setSparkAmount } from './luna_spark_fx'
import { setSparkMix } from './luna_spark_mix_fx'
import { execFxLifeSec, execWoundPoint, finisherClockNext, finisherCTimeScaleOfClock, finisherProfileFor, finisherV2BeatSfx, finisherV2On, setExecFxLook, setExecNormalVariant, setFinisherFxLook, setFinisherV2Mode, setFinisherV2Slow, setLunaSfxChoice } from './luna_finisher'
import { setAwokenKingPostureRecoveryPerSec, setRoosterPoolOverride, ROOSTER_POOL_OLD } from './econ'
import { tipsCardsForBoss, pendingTipsCardIndex, TIPS_CARD_HOLD_MS } from './tutorial_cards'
import { stepMenuNav, moveCursor, MENU_NAV_INITIAL } from './menu_nav'
import {
  hitIndex, titleMenuRects, titleMenuItems, newGameConfirmRects, difficultyMenuRects, pauseMainRects, pauseMainItems, pauseSettingsRects, endingChoiceRects,
} from './menu_layout'
import {
  DEFEAT_OVERLAY_TIMING_SEC,
  defeatDifficultyHintVisible,
  defeatOverlayTimeline,
} from './defeat_overlay_timing'
import { PARRY_FAMILY_FX_LIFE_SEC } from './parry_family_fx'
import { HEAVY_BAR_GHOST } from './player_combo3_power'
import { setDodgeIFrameVariant, setDodgePose, setDodgeTrail, setDodgeVariant, setWalkVariant, walkSpeedPxPerSec } from './player_locomotion_trial'
import { setLunaWalkVariant } from './player_walk_new'
import { setCounterBlend, setDodgeCounterMotion } from './dodge_counter_motion'
import { setCounterLook } from './dodge_counter_look'
import { setFinisherDamage } from './finisher_damage'
import { setEconBaseMode } from './econ_baseline'
import { setExecParrySoundVariant, setParrySoundVariant } from './parry_sound'
import { setParryPitchVariant } from './parry_pitch'
import { parsePurpleSwap, setPurpleSwap } from './purple_swap'
import { parseRedSignals, setRedSignals } from './red_signals'
import { applyBladeClap } from './blade_dancer_clap'
import { setFloorWarnMode } from './floor_warn_vis'

// 稽古の幕の玉 (src/readability_1104.ts・11-04 作者 p_acts=b): 台本へ当てるので配布版でも1回呼ぶ。開発版だけ ?tutActs=a|old で替えられる。
applyTutActs(import.meta.env.DEV && typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('tutActs') : null, FOCUS_STEPS, VOICE_FOCUS)
// URLの比較調整は開発版だけ。配布版は各モジュールの採用済み既定値を使う。
// 覚醒王の採用絵も sprites.ts の SPRITE_FILE_OVERRIDE が持つため、ここを通らなくても維持される。
let corePractice = false
if (import.meta.env.DEV && typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search)
  setHoundMovesOld(params.get('houndMoves') === 'old')
  // ?bossHud=legacy (旧 HUD) / wide60|wide70|wide80 (10-12・ボスの体幹と体力の帯を画面幅の 6〜8 割へ横に広げる比較版・src/boss_hud_view.ts)。
  //   指定なし = 今のまま (体幹の溝 440px = 画面の約 46%)。記録 = docs/research/2026-10-12-boss-hud-wide.md。
  setBossHudMode(params.get('bossHud'))
  // 11-04 初見監査の読みやすさ3件 (src/readability_1104.ts)。既定 (指定なし) = 作者の答えの版 (体力 1.5倍・2択は墨のにじみ・幕の玉は最後の致命で)。
  //   前の版は ?bossHp=old・?advChoice=old・?tutActs=old。残りの案は ?bossHp=b・?advChoice=b・?tutActs=a。
  setBossHpLook(params.get('bossHp'))
  setAdvChoiceLook(params.get('advChoice'))
  // ?knightRest=mid (旧 = 押し返し・石突・崩れの後には挟まない) / now (旧 = 足をそろえて立つ) / reach (広い構えで止まる)。
  //   既定 (指定なし) = more (足を寄せる絵を、技の後に加えて押し返し・石突・崩れの後にも挟む)（2026-10-12 ユーザー採用・配布版・試遊パック 10-10 の答え F-1・src/knight_rest.ts）。
  setKnightRest(params.get('knightRest'))
  setKnightRearmTween(params.get('knightRearmTween'))
  // 既定 (指定なし・10-15 配布版・パック 1014c C-3): 歩きの途中 (広い構え) から攻撃へ移る時、溜めの頭の立ち姿を最初の 100ms だけ揃えかけの絵へ (src/knight_walk_bridge.ts)。
  //   ?knightWalkBridge=0 = 前の版 (挟まない)。記録 = docs/research/2026-10-14-next-play-1014b.md。
  setKnightWalkBridge(params.get('knightWalkBridge'))
  // ?knightScrapeTurn=stand (10-29 昼の版: 構え直しの2枚で立つ) / idle (間の絵なしで待機の絵だけ) / rest (前の配布版 = 半分起きた構え) / now (低い構えのまま): 壁ぎわの突進の recovery の途中で向きが変わる前後の低い構え。
  //   既定 (指定なし) = plant (石突を後ろから前へ運ぶ4枚で立って待機の絵へ・10-29 作者「ok」)（2026-10-29 作者・src/knight_rest.ts・記録 docs/research/2026-10-29-knight-scrape-turn-rest-redraw.md）。
  setKnightScrapeTurn(params.get('knightScrapeTurn'))
  // 介錯の致命「執行」の4枚の置き方 (src/executioner_finisher_foot.ts)。既定 (指定なし) = mid = 足と頭の中間に置き、刃の打点は前足が見える新しい絵 (exec_contact_v2)
  //   (10-09 ユーザー採用・配布版)。?execFinisherFoot=old = 旧 (bbox の中心・旧の打点の絵・当たりの前端 100) / =foot = 後ろ足に合わせるだけ (旧の打点の絵) / =1 = 後ろ足 + 新しい絵。
  setFinisherFootAnchor(params.get('execFinisherFoot'))
  setFinisherArtFrontOverride(finisherReachFrontPx())  // 致命の当たりの前端をその版の打点の絵の刃先へ (旧は null = 表の 100)
  setSpriteFileOverride('the-executioner', 'blade', 'exec_contact', finisherContactV2On() ? 'exec_contact_v2' : null)
  // ?execWeapon=old (src/executioner_weapon_fix.ts・2026-10-19): 武器の長さと太さを待機の絵に揃えた8枚を、旧の絵へ戻して見比べる。
  //   既定 (指定なし) = 直した絵 = 配布版。体の位置・当たり・タイミングは同じ。
  if (!execWeaponFixOn(params.get('execWeapon'))) {
    for (const [v, key] of EXEC_WEAPON_FIX_KEYS) setSpriteFileOverride('the-executioner', v, key as SpriteKey, null)
  }
  // ?execParry=off (src/exec_parry.ts): 崩れた時のボスの致命をパリィで弾ける仕組みを切って、旧 (弾けない・崩れ 1800ms 固定) と見比べる。
  //   既定 (指定なし・2026-10-10 ユーザー答え exec-parry-ship「入れる」) = 弾ける = 配布版。崩れは致命まで続く・連撃の残りを捨てる・
  //   崩れ中はパリィだけ押せる (受付は普段のパリィと同じ 120ms)・合図 (紫のオーラ＋一瞬の静止)。旧の綴り just / any は既定と同じ (パリィ1種類なので分けない)。
  setExecParryMode(params.get('execParry'))
  // 介錯の FX の比較版 (2026-10-29・作者の答え exec-fx-q1〜q5)。10-30 の作者の答え: 覚醒獣のブレーキの土ぼこりと地割りのひび・床の描いた警告は「入れる」で配布版の既定 (前の版は ?awokenBrake=line・?execCrack=glow)。
  //   振り下ろし・据え・突き当て・榴弾・薙ぎ払いは「前のまま」なので配布版は前の版。咆哮の霞と弾いた時の弧は 10-30 parry2「入れる」で控えめの筆 (lite) が配布版の既定 (前の白い弧は ?execSwing=line)。
  //   ?execFx=new で下の6つを全部新しい絵にする。1つずつなら ?execAura=mist (体から立つ靄)・?execStep=dust (踏み込みの土ぼこり・11-01 から既定)・
  //   ?awokenBrake=dust (覚醒獣の突進のブレーキの土ぼこり)・?execSwing=brush (太い筆)・?execRoarHaze=mist (咆哮の靄の絵)・
  //   ?execCrack=glow (地割りの前の光る筋に戻す)・?execMortar=scorch (榴弾の焦げ跡と煙)。
  const execFxNew = params.get('execFx') === 'new'
  setExecAuraMode(execFxNew ? 'mist' : params.get('execAura'))
  setExecStepFx(execFxNew ? 'dust' : params.get('execStep'))
  setAwokenBrakeLook(execFxNew ? 'dust' : params.get('awokenBrake'))
  setExecSwingLook(params.get('execSwing'))
  setRoarHazeLook(execFxNew ? 'mist' : params.get('execRoarHaze'))
  setExecCrackLook(execFxNew ? 'crack' : params.get('execCrack'))
  setExecMortarLook(execFxNew ? 'scorch' : params.get('execMortar'))
  // 介錯の3回目の直し (11-01・src/exec_look_1101.ts)。既定 = 直した版 = 配布版。前の版は ?execMortarMark=ring (榴弾の光る輪)・
  //   ?execShout=roar (幕の切り替わりの斬りかかりの声)・?execTint=purple (紫)・?execStepWind=old (瞬歩の白い筋) / off (消した版)。
  setExecMortarMark(params.get('execMortarMark'))
  setExecShout(params.get('execShout'))
  setExecTint(params.get('execTint'))
  setExecStepWind(params.get('execStepWind'))
  // 11-01 の撮影で見つけた残り (src/exec_look_1101.ts): 榴弾の空の弾は火の尾を引く砲弾の絵が既定。前の光の玉は ?execMortarShell=orb。
  //   踏み込みの写しは土ぼこりが既定 (src/exec_step_dust.ts)。前の写しは ?execStep=ghost。
  setExecMortarShell(params.get('execMortarShell'))
  // 榴弾の溜めの砲口の赤い光の粒は 11-03 作者の答えで消した (前の粒は ?execMortarDrip=on)・一歩の足もとの銀の光る楕円は比較版 ?execStepGlow=off。
  setExecMortarDrip(params.get('execMortarDrip'))
  setExecStepGlow(params.get('execStepGlow'))
  // 外套のはためき (src/exec_cloak.ts): 既定は刃・砲とも布が流れる版 (11-04 作者 cannon＝yes)。比べる時は ?execCloak=flow (刃だけ)・off (挟まない)・settle (1枚)。
  setExecCloak(params.get('execCloak'))
  // 刃の4枚の置き位置と色を体で揃えた絵 (11-04 作者 blade＝yes で配布版の既定)。前の絵は ?execCloakAlign=off。
  setExecCloakAlign(params.get('execCloakAlign'))
  for (const key of ['step_cloak_lift', 'step_settle', 'step_cloak_fall', 'step_cloak_drop'] as const) {
    setSpriteFileOverride('the-executioner', 'blade', key as SpriteKey, execCloakBladeAlignOn() ? `${key}_align` : null)
  }
  // 砲の形の致命 (11-01 作者の答え fin = A・src/exec_cannon_finisher.ts): 砲→刃へ組み変わってから刃の執行が既定。前の代用は ?execCannonFin=old。
  setExecCannonFinisher(params.get('execCannonFin'))
  // 咆哮の衝撃波 (10-30 作者 roar4「新しい版を入れる」): 背景の歪み＋土ぼこりの絵・1100px/秒 (当たりも同じ速さ) が配布版の既定。
  //   ?execRoarWave=old で前の幕と 420px/秒 (比較用)。
  //   ?execRoarWave=wall で前縁が押す塵の帯の絵を足す (10-31 比較版・票 exec-roar-dustwall-1031)。
  { const wave = params.get('execRoarWave'); const ring = wave !== 'old'; setRoarWaveRing(ring); setRoarAirRingSpeed(ring); setRoarWaveWall(wave === 'wall') }
  //   ?execRoarDust=0|2|3 で床の土ぼこりとかけらの濃さを変える (10-31 作者の答え=濃さ1が既定・0 が前の薄い版)。
  setRoarDustBoost(params.get('execRoarDust'))
  // ?execParryGain=old (src/exec_parry.ts・2026-10-12): 致命を弾いた時のボスの体幹を旧 (普段の弾き1回と同じ量・満タンなら崩れる) へ戻す。
  //   既定 (指定なし・検収パック 10-12 K-5 のメモ「どんでん返し…ただしクリアしてしまうようなレベルにはしないで」) = 普段の弾きの3回ぶん・崩れる1歩手前まで。
  setExecParryBigGain(params.get('execParryGain'))
  // ?execBait=off|c|d (src/exec_bait.ts・2026-10-31 作者の答え): わざと崩れて致命を弾き、知らない技をやり過ごす手の対策。
  //   既定 (指定なし) = fix = C (致命を弾かれたら6割で崩した連を頭からやり直す)＋D (ガードで崩れた時の致命弾きは普段の弾き1回ぶん)。off = 前の版・c / d = 片方だけ。
  setExecBait(params.get('execBait'))
  // ?bladeFinisher=v1 (src/blade_finisher_v2.ts・2026-10-31 作者の答え): 剣舞の幕引きを前の一礼→一閃へ戻す。
  //   既定 (指定なし) = 手拍子 (拍は一定・打つ数が 2〜4 回・半分の回で一拍の休み) → V 字に開いて紫 → 斬り・返し斬りの2撃。
  setBladeFinisher(params.get('bladeFinisher'))
  // ?tutFocus=1|2|3 (src/tut_focus.ts・2026-10-11): 稽古を「止めて、照らして、教える」比較版。1 = ガードの次に「崩されて、亡霊の決め技 (紫) を弾く」課題を入れ、
  //   最初の1回だけ崩れた瞬間と当たる直前で止める (旧「パリィを2回」と入れ替え・課題は6のまま)。2 = 1 に加えてパリィの課題も止めて教える (パリィの2枚のカードは出さない)。
  //   3 = 全部の課題と仕上げを止めて教える・亡霊のカードは出さない (10-11 朝の答え tut-focus-how「C」・設計 docs/research/2026-10-11-tut-focus-all-lessons-plan.md)。
  //   10-11 から 3 が配布版の既定 (指定なしも 3)。?tutFocus=0 で旧 (カードの稽古) へ戻す (比較用)。
  setTutFocusMode(params.get('tutFocus'))
  // ?tutAssistFirst=count (src/tut_focus.ts): 稽古で止めて教える最初の1回の技の成功を数える (10-12〜10-14 の配布版)。
  //   既定 = 最初の1回も補助案内も数えない (10-14 試遊 B-3)。
  setTutAssistFirst(params.get('tutAssistFirst'))
  // ?tut6=all|1,3,5 (src/tut_six.ts・2026-10-30): 稽古の6点の比較版。指定なし = 配布版のまま。
  setTutSix(params.get('tut6'))
  // ?tutVoice=text|b|c|d|off (src/tut_voice.ts・2026-10-31): 稽古を「声」が語る。指定なし = 配布版の a 金の囁き。text・b〜d = 比較版／off = 声の入る前。
  setTutVoice(params.get('tutVoice'))
  // ?hud=v2 (src/hud_v2.ts・2026-10-31): 戦闘中の画面表示の初見点検のおすすめ案 (体幹の警戒 0.65・足元の熱を強く・声が幕の玉と崩れの紫を教える・負け画面の一言)。指定なし = 配布版のまま。
  setHudLook(params.get('hud'))
  // ?title=old (src/title_v9.ts): 前のタイトル画面。既定 = 構図9＋ロゴ案2 (10-31 作者が選び、11-01 に配布版へ)。
  setTitleLook(params.get('title'))
  // ?stunRepress=320|200 (10-09 夜・弾ける仕組みの中だけ): 崩れ中のパリィを押してから次に受け付けるまでの間 (既定 470ms) を、320 (空振りの硬直を抜く)／200 へ。
  //   覚醒王の台帳の答え「このままでいい」= 採らない (比較用に残す)。受付の長さ・当たり判定は変えない。それ以外の値・指定なし = 既定 (src/exec_parry.ts)。
  setStunRepress(params.get('stunRepress'))
  // ?stunCut=0 (src/stun_cut.ts・2026-10-12): 主人公が崩れた時、ボスが今振っている拍の当たりと戻りまで出し切ってから致命へ移る旧へ戻す
  //   (覚醒王の跳び噛みの後ろ跳び・固有のとどめ (?execUnique=1) の歩きと寄りの長さも前のまま・介錯は組み変わりを先に出す)。
  //   既定 (指定なし・10-12 ユーザー答え「どのボスも崩れてから約1.8秒以内に致命」) = 今の拍も打ち切って、戻りの絵を順に等速で少しずつ (合わせて約0.2秒) 見せてから致命の溜めへ。
  setStunCut(params.get('stunCut'))
  // ?stunCutLook=warp (src/stun_cut.ts・2026-10-12): 打ち切った技の構え直しを前の見え方 (戻りの残りを 4〜15 倍で早回しして待機の絵まで戻す) にする。
  //   既定 (指定なし・検収パック 10-12 F-1 の答え「早送りに見える」) = 戻りの絵を順に1枚ずつ等速で 67〜120ms 見せて、最後の絵の後に致命の溜めへ (絵と絵の間の保ちだけを飛ばす)。
  setStunCutLook(params.get('stunCutLook'))
  // ?awokenHopPace=fast (src/awoken_devour_pounce.ts・2026-10-12): 覚醒王の致命の前の後ろ跳びを 10-12 昼の速い拍 (宙 200〜240ms) にする。
  //   既定 (指定なし・検収パック 10-12 F-2 の答え「速すぎる」) = 前の拍の速さ (屈み 90・宙 230〜340・着地 110)。
  setPounceHopFast(params.get('awokenHopPace'))
  // ?pounceNoRoom=old (同上): 壁を背にして跳び噛み2回ぶん下がれない時、前のとおり暴噛・終 (紫が灯ってすぐ当たる別の技) へ替える。
  //   既定 (指定なし・F-2 のメモ「後ろに下がらずに直接紫を出したこともあった」) = 見せの跳びを1回・0回に減らし、下がれるだけ下がってから同じ形で跳ぶ。
  //   =1012 (10-14): 10-12 夕の版 (主人公が口の届く所より内側にいて背中の余地も 195px 未満の時だけ暴噛・終)。既定 (10-14 試遊 C-3「まだ出た」) = そこでも壁ぎわの近い形 (必ず後ろ跳び → 上へ跳んで噛み下ろす)。
  setPounceNoRoom(params.get('pounceNoRoom'))
  // ?execAura=old (src/awoken_devour_pounce.ts・2026-10-14): 覚醒王の致命の紫を前 (合図まで出さない) へ戻す。
  //   既定 (指定なし・10-14 試遊のメモ「モーションにはいった次点で紫に…覚醒王であれば下がってるタイミングで既に紫のオーラを纏わせて」) = 溜めの頭から薄く纏い、合図で強まる。
  setExecAuraEarly(params.get('execAura'))
  // ?awokenPounceFrames=old (2026-10-25 docs/research/2026-10-25-st6-measured-polish.md): 覚醒王の致命の跳び噛みを前の並び (1〜2コマだけ映る絵がある) へ戻す。
  //   既定 (指定なし・10-27 作者「OK」) = どの絵も 83ms (5コマ) 以上映す (絵の枚数は同じ・合図から当たりまでの 470ms と技の長さも同じ)。
  setPounceLongFrames(params.get('awokenPounceFrames') !== 'old')
  // ?awokenFaceGlow=old (src/awoken_face_glow.ts・2026-10-27): 覚醒王の顔の紫の溜めの光を前のとおり出す。既定 (指定なし・作者「消してほしい」) = 出さない。
  setAwokenFaceGlow(params.get('awokenFaceGlow'))
  // ?awokenFaceRoom=1 (src/awoken_face_room.ts・2026-10-27): 覚醒王が技の前に主人公から 165px まで歩いて下がり、予備動作の顔を主人公に重ねない比較版。既定 = 配布版のまま。
  setAwokenFaceRoom(params.get('awokenFaceRoom'))
  // 覚醒王が歩いて下がる間だけ絵を反転して振り向いて歩く (src/awoken_back_walk.ts・11-03 作者の答えで配布版の既定)。前の絵は ?awokenBackWalk=now。
  setAwokenBackWalk(params.get('awokenBackWalk'))
  // 剣舞が技の戻りの後に後ろへ下がる所 (src/blade_back_step.ts): 既定 = lock (爪先を床に留めた約 151px の1歩・11-04 作者 backstep=lock)。
  //   ?bladeBackStep=now = 前の版 (立ち姿のまま滑る)・walk = 約 90px をワルツの2枚で1歩踏む比較版。
  setBladeBackStep(params.get('bladeBackStep'))
  // ?awokenFaceFront=1 (src/awoken_face_front.ts・2026-10-27): 覚醒王の予備動作の間だけ主人公をボスより先 (奥) に描き、顔を主人公の上に出す比較版。既定 = 配布版のまま。
  setAwokenFaceFront(params.get('awokenFaceFront'))
  // 介錯の榴弾の弧 (src/exec_mortar_arc_1104.ts): 既定 = low (頂点より上へ出さず画面の中で割れる・11-04 作者 p_offscreen=low)。前の弧は ?mortarArc=old・頂点で一瞬止まる案は hang。
  setMortarArc(params.get('mortarArc'))
  // 戴冠獣・覚醒獣と重なった主人公 (src/overlap_read_1104.ts): 既定 = rim (月光の薄い縁・11-04 作者 p_overlap=rim)。前の版は ?overlapRead=old・獣を透かす案は thin。
  setOverlapRead(params.get('overlapRead'))
  // ?awokenNeckBack=art|1 (src/awoken_neck_back.ts・2026-10-27): 覚醒王の暴噛・溜め噛みの予備動作を、首を引いて冠を体の一番上へ上げた絵にする比較版。
  //   =art 絵だけ / =1 絵＋顔が主人公に重なるほど近い時は暴噛・溜め噛みを選ばない。既定 = 配布版のまま。
  setAwokenNeckBack(params.get('awokenNeckBack'))
  // ?awokenBiteSpace=off|pick (src/awoken_bite_space.ts・2026-10-27): 覚醒王の暴噛・溜め噛みの間合い。既定 (配布版) = keep 好みの距離 235px まで下がってから構える。
  //   =off 旧 (近くても噛む) / =pick 近い時は噛みを選ばないだけ。
  setAwokenBiteSpace(params.get('awokenBiteSpace'))
  // ?awokenStage=narrow (src/awoken_wide_stage.ts・2026-10-27): 旧の舞台。既定 (配布版) = 覚醒王の戦いだけ舞台を 1.4 倍に広げてカメラで追う。
  setAwokenWideStage(params.get('awokenStage'))
  // ?st6Polish=1: 介錯 (刃) の振り下ろし・斬り上げ・据えの一打は、絵の替わり目に踏んでいる足が跳ばないよう足で置く (src/exec_plant_foot.ts)。
  setSt6PlantFoot(params.get('st6Polish') === '1')
  setTweenFix(params.get('tweenFix') === '1')
  // ?recoverySway=1 (2026-10-25 docs/research/2026-10-25-recovery-sway.md): 止まった長い戻りに重心の沈み・引き戻しの傾き・息を足す比較版 (描くだけ)。指定なし = 配布版のまま。
  setRecoverySway(params.get('recoverySway') === '1')
  // ?finisherDmg=0|off|60|40|35|25 (src/finisher_damage.ts): 崩れた時のボスの致命の傷。既定 (指定なし・2026-10-10 ユーザー採用) = 共有の 60 の致命を主人公の最大体力の 4 割にする (千秋楽 40・初演 80・10-18 に 6 割から下げた)。
  //   0 / off / 60 = 前の決め方 (共有の 60 のまま) / 40 / 35 / 25 = その値で固定 (騎士・花嫁・介錯ほか 60 のボスだけ。戴冠獣 25・覚醒王 32 は専用の値なので動かさない)。
  //   他の技の傷・体幹・致命の演出の時間は変えない。千秋楽・初演どちらにも効く。
  setFinisherDamage(params.get('finisherDmg'))
  // ?lunaFinisher=new (src/luna_finisher.ts・2026-10-12): 主人公の致命の新しい版 (普段 = 刺す→押し込む→抜く／最後 = 刺した姿で止めて背景だけ沈め、抜いて光の柱)。
  //   指定なし = 今の版 (配布版)。?lunaFinisherSlow=double = 新しい版のまま撃破までのゆっくりを今の長さ (二重掛け・約6秒) にする。
  setFinisherV2Mode(params.get('lunaFinisher'))
  setFinisherV2Slow(params.get('lunaFinisherSlow'))
  // ?lunaExec= (src/luna_exec_swap.ts・2026-10-19 作者の答え): 普段の致命 = 深く一突き／止め = アリスの技を手本にした駆け抜け。
  //   指定なし = 配布版 lamp (swap3 の重み＋常夜燈の光が漏れるひびとガラス・10-20)・old = 入れ替える前・swap|swap2|swap3 = 比べる前の版。
  setLunaExecSwap(params.get('lunaExec'))
  setPullBossScale(params.get('pullBoss'))  // 両手で刺して引き抜く版のボスの受けの大きさ (?pullBoss=1.5 / 2・11-04)
  setNormalExecPose(params.get('normalExecPose'))  // 普段の致命 (指定なし = 両手で刺して引き抜く・11-05)。前の形: execute = 11-05 までの配布版・pullGouge = 11-04 のえぐる版・push = 10-30 の両手の押し込み
  setBossRise(params.get('bossRise'))  // 崩れから立ち上がる2枚 (10-30・?bossRise=off で前の、崩れからすぐ構え)
  setBossRiseSmooth(params.get('bossRiseSmooth'))  // 立ち上がりの切り替え (10-30・既定 both・比べる時は off|ease|blend)
  setBossRiseFit(params.get('bossRiseFit'))  // 立ち上がりの絵の大きさ・高さの合わせ (10-30・?bossRiseFit=off で合わせる前)
  setNormalExecFix(params.get('normalExecFix'))  // 普段の致命の刺した後 (10-29・?normalExecFix=old で前の配布版・src/luna_exec_swap.ts LAMP_EXEC)
  setExecCrackPos(params.get('execCrackPos'))  // 止めの裂け目の中心 (10-21・?execCrackPos=old で前の位置・src/luna_exec_swap.ts)
  // ?lunaNormalFx=ribbon|crack (src/luna_unravel_fx.ts・10-21): 普段の致命の光の比較。指定なし = 刺した点から青白い火花が散る (A案・src/luna_spark_fx.ts)、
  //   ribbon = 傷口から光がほどけて抜ける (10-21 朝)、crack = 10-20 の「光が漏れるひび」。
  setLunaNormalFx(params.get('lunaNormalFx'))
  // ?lunaSparkAmount=low|mid|high (src/luna_spark_fx.ts・10-22): A案の粒の量の比較。指定なし = 大量 (60 粒の 6 倍・10-23 作者「大量だけ」で配布版)、low = 前の 60 粒。
  // ?lunaSparkMix=ash|ribbon (src/luna_spark_mix_fx.ts・10-23): A案の粒に灰の欠片／細い光の帯を混ぜる比較。10-23 どちらも不採用 (灰「灰に見えない」・帯「リボンに見える」)。開発版の印として残す。
  setSparkMix(params.get('lunaSparkMix'))
  setSparkAmount(params.get('lunaSparkAmount'))
  // &lunaExecSfx=p|q|r|m|n|o|j|k|l|g|h|i|d|e|f|a|b|c|synth・&lunaFinSfx=v4g|v4h|v4i|v3d|v3e|v3f|v2|v1 (src/luna_finisher.ts LUNA_EXEC_SFX_SETS・2026-10-13 音の4版目): 新しい版の致命の音の組の比較。既定 = 普段 g・最後 v4g。
  // &lunaFinBell=on (10-13): 最後の一撃の名前の鐘を鳴らす (組の鐘・4版目は 3版目の鐘)。指定なし = 鳴らさない (ユーザー「鐘は要らない」)。
  setLunaSfxChoice(params.get('lunaExecSfx'), params.get('lunaFinSfx'), params.get('lunaFinBell'))
  // ?lunaFinisherNormal=v2 (10-12c): 新しい版の普段の致命を 10-12 の版 (execute_v2・v2 の光) に戻す比較。指定なし = 3 版目 (execute_v3・src/luna_exec_fx_v3.ts)。
  setExecNormalVariant(params.get('lunaFinisherNormal'))
  // &lunaExecFx=a (10-12d): 普段の致命の光を A「光の血煙」(src/luna_exec_fx_v3.ts) に戻す比較。指定なし = C「火花の爆ぜ」(src/luna_exec_fx_c.ts)。
  // &lunaFinFx=v2 (10-12d): 最後の一撃を前の版 (飛沫 v2・控えめな柱・魔法陣と灰と霧・撃破まで 4.17 秒) に戻す比較。指定なし = C (刺し傷 1 か所から・約 6 秒)。
  setExecFxLook(params.get('lunaExecFx'))
  setFinisherFxLook(params.get('lunaFinFx'))
  // ?econBase=0|off|1|2 (src/econ_baseline.ts): 全ボス共通の「体幹と体力の基準」。既定 (指定なし = 2・2026-10-10 ユーザー採用) = 基準 + ボスの個性 (介錯 = 体幹×1.3・覚醒王 = 体力×1.3 + 体幹の溜まる量×1.3)。
  //   1 = 基準だけ (どのボスも、最高効率で戦うと幕の体力が 50〜60% 残った所で体幹が満タン・ボスの体幹の量を幕ごとに動かす・初演で合わせた) / 0 または off = 前の量 (基準なし)。崩れの条件は今どおり体幹の満タンだけ。
  setEconBaseMode(params.get('econBase'))
  // ?awokenDevour=1|2|3|4 (10-09 夜の比較版・src/awoken_devour.ts): 覚醒王の致命を案A「灰を食む」へ差し替える
  //   (床を 2〜4 回むさぼって寄り、後ろ脚の沈み直し → 口を開けて止まる所だけ紫・一瞬止まる)。1 = 回数は毎回くじ・2|3|4 = 回数固定。
  //   致命を弾ける仕組み (既定) の中で使う前提。
  //   ?awokenDevour=gladius (10-09 夜の2つ目・src/awoken_devour_pounce.ts): 前へ跳びながら噛む×2 (当たり無し) → 3回目も同じ形で跳んで宙で顎を閉じる (本命)。
  //   10-09 夜 ユーザー「この形で進める」: 弾ける仕組みが効いている時 (既定 = 配布版) は指定なしで跳び噛み。?awokenDevour=off = 暴噛・終 (前の既定)。
  //   ?execParry=off の時は暴噛・終 (跳び噛みは崩れが致命まで続く前提・src/awoken_devour.ts の注記)。
  setAwokenDevour(params.get('awokenDevour'))
  // ?awokenDevour=gladius&gladiusTell=purple|none|light (10-09 r2・src/awoken_devour_pounce.ts): 3回目の合図の比較。
  //   purple = 紫が灯って一瞬止まる (既定 = 今のまま) / none = 紫も止まりも無し / light = 3回目の跳びの頭から紫をほんのり (止まり無し)。
  setPounceTell(params.get('gladiusTell'))
  // ?awokenDevour=1&devourJaw=1 (10-09 夜・もう1段): 見せの噛みの「顎を閉じる」拍を、床に頭を突っ込んで顎を閉じた新しい絵 (floorbite_closed_1009) にする。
  //   縦の潰しは掛けない。?awokenDevour が無い時は効かない。既定 (指定なし) = 今の比較版のまま (frenzy_bite2 を縦に潰して見せる)。
  setAwokenDevourJaw(params.get('devourJaw'))
  // ?execUnique=1|0 (src/exec_unique.ts): 騎士と花嫁の固有の致命 (騎士「突進」・花嫁「おかえりの抱擁」)。弾ける仕組みが効いている時 (既定) だけ効く。
  //   2026-10-12 (検収パック 10-12 K-5「直してから」→ K-3 光の尾・K-4 壁ぎわの駆け抜けを直した) から、騎士は指定なし (配布版) で固有の致命。
  //   2026-10-14 (試遊 next-play-1014 F-1〜F-4 よい) から花嫁も指定なし (配布版) で固有の致命。=knight = 10-14 までの配布版 (騎士だけ)・
  //   =1 = 既定と同じ・=0 = 前の既定 (どちらも固有の致命なし)。?execUniqueHold=300|400|500 = 騎士の紫の止まりの長さ (既定 400)・
  //   ?execHeartPx=12|14|16 = 花嫁の♡の大きさ (既定 16・10-12 ユーザー A-3)。指定なし = 今のまま。
  setExecUnique(params.get('execUnique'))
  setExecUniqueHold(params.get('execUniqueHold'))
  setExecHeartPx(params.get('execHeartPx'))
  // ?execUniqueKnight=band (10-12): 騎士の前の版 (離れた所で振り抜いて光の帯が飛ぶ)。既定 = 突進 (槍を構えて一気に詰め、穂先が届いた所で当たる)。
  setExecUniqueKnight(params.get('execUniqueKnight'))
  // ?execUniqueBrideRise=glide|old (10-12): 弾かれた花嫁の前の版 (glide = 寄っていく絵のままゆっくり起きる / old = 上体を大きく後ろへ反らす)。既定 snap = 弾かれた専用の絵で速く跳ね返る (B-2)。
  setExecUniqueBrideRise(params.get('execUniqueBrideRise'))
  // ?execUniqueRecover=guard|turn (10-09 夜): 騎士の振り抜いた後の戻り。既定 guard = 槍を向けたまま構えを引いて待機 / turn = 前の版 (扉の方へ背を向け直す)。
  setExecUniqueRecover(params.get('execUniqueRecover'))
  // ?execUniqueWall=pass (10-12 K-4): 騎士の背中が壁ぎわの時、主人公の脇を駆け抜けて内側から突っ込む版。
  //   既定 = 駆け抜けない (10-14 試遊 E-2「前のほうが良い」・その場で背を向けて短く突っ込む)。
  setExecUniqueWall(params.get('execUniqueWall'))
  // ?execUniqueSound=b|old (10-12・src/exec_unique_sound.ts): 固有のとどめの音。既定 a = 配布版 / b = 別テイク / old = 前の音 (この音を足さない)。
  setExecUniqueSound(params.get('execUniqueSound'))
  // ?houndVoice=a|off (10-13・src/hound_voice_sound.ts): 戴冠獣の予備動作の声。既定 b 獅子寄り (配布版) / a 狼寄り / off 前の音 (共通の唸り)。
  setHoundVoice(params.get('houndVoice'))
  // ?execSound=b|c|d|off (10-29・src/exec_sound.ts): 請われぬ介錯の技の音。既定 a = 配布版 / b = 別テイク / c = シンセの試作 (4役) / d = 手本に寄せたシンセ (2役・予告2つは無音) / e = 残りの役もシンセでそろえた比較版 (11-03) / off = 前の音 (共通の唸りと足音)。
  setExecSound(params.get('execSound'))
  // ?floorTell=old (11-03・src/floor_tell_sound.ts): 床技4つの予告音。既定 = 新しい音 (配布版) / old = 前の共通の whirr。
  setFloorTellSound(params.get('floorTell'))
  // ?bossSfx=v1|off (10-31・src/boss_sfx_v1.ts): 鶏・剣舞・軍配者たちの技の音。既定 = 三体とも (配布版・11-01 鶏も採用) / v1 = 既定と同じ / off = 前の音。
  setBossSfx(params.get('bossSfx'))
  // ?bladeSfx=v1 (11-04・src/blade_sfx_v2.ts): 剣舞の技の音と拍手2つ。既定 = v2 (配布版・11-04 作者採用・暗器だけ v1 の音) / v1 = 前の版 (10-31 の v1 と借り物の拍手)。
  setBladeSfx(params.get('bladeSfx'))
  // ?twinsRevealSfx=off (11-01・src/boss_sfx_v1.ts): 軍配者たち3部屋目の現れ方 C の音 (吸い込み・着地)。既定 = 鳴る (配布版) / off = 前の形 (吸い込みは無音・着地は仮の重い一音)。
  setTwinsRevealSfx(params.get('twinsRevealSfx'))
  // ?finisherSfx=off (11-01・src/finisher_sound.ts): 致命固有の音 (介錯・覚醒獣・亡霊・戴冠獣・花嫁・先代)。既定 = 鳴る (配布版) / off = 前 (被弾音だけ)。
  setFinisherSfx(params.get('finisherSfx'))
  // ?brideHugSfx=a|b|c|v1 (11-01・src/finisher_sound.ts): 花嫁の抱擁が決まった時の「ぎゅーっ」。既定 = C「重い愛」(作者が選んだ) / a・b = 他の案 / v1 = 1版目 / off = 無音。
  setBrideHugSfx(params.get('brideHugSfx'))
  // ?advSound=b|c (10-27・src/adv_sound.ts): 会話場面の物音の別案。既定 a = 配布版。
  setAdvSoundTake(params.get('advSound'))
  // ?awokenVoice=deep|haunt (10-13・src/awoken_voice_sound.ts): 覚醒王の予備動作の声 (低く大きく / ＋怨念の声)。既定 off = 共通の唸りのまま (配布版)。
  setAwokenVoice(params.get('awokenVoice'))
  // ?awokenRampageVoice=bark|roar (10-17・src/awoken_voice_sound.ts): 大暴れ (第5案) の声の比較。既定 off = 今のまま (溜めで共通の唸り)。
  setAwokenRampageVoice(params.get('awokenRampageVoice'))
  // ?execPush=old|new|sekiro (10-09 夜): 致命を弾いた時の押し戻し。old = 前の版 / 既定 new (配布版) = 遠くへ踏ん張って滑る / sekiro = SEKIRO の動画に合わせた小さい押し。
  setExecPushVersion(params.get('execPush'))
  // ?execPushWeight=off|a|b (10-09 夜・?execPush=new に重ねる・src/exec_push_weight.ts): 致命を弾いた時の押し戻しの重さを
  //   カメラの寄り・フラッシュ・揺れ・止めで出す。既定 (指定なし・10-10 ユーザー答え push-weight) = c ボスの重さで段 (配布版)。
  //   off = 重ねない (new だけ) / a = 寄って止める / b = 白く飛ばして沈む。
  setPushWeight(params.get('execPushWeight'))
  // ?execParryFx=old (10-14・src/exec_parry_slow_fx.ts): 致命を弾いた時の演出。既定 new (配布版) = 白黒＋接点へ寄る＋スロー / old = 前の配布版 (金の光)。
  setExecParryFx(params.get('execParryFx'))
  // ?execParryRecoil=old (10-20・src/exec_parry_recoil.ts): 致命技を弾いた時のボスの絵。既定 new (配布版) = 弾いたコマから弾かれの姿 / old = 前の版 (スローの途中・後まで技の絵のまま)。
  setExecParryRecoil(params.get('execParryRecoil'))
  // ?execParriedArt=old (10-21・src/exec_parry_recoil.ts): 介錯・覚醒王・剣舞の致命を弾いた時の絵。既定 new (配布版) = 描いた弾かれの絵 / old = 当たりの絵を反らす前の版。
  setExecParriedArt(params.get('execParriedArt'))
  // ?awokenParried=c|d|e (10-31・src/exec_parry_recoil.ts): 覚醒獣の弾かれの絵を元の絵 (bite_contact_up_0910) だけをお手本に描き直した3案。指定なし = 配布版 d・=now で 10-21 の絵。
  setAwokenParriedArt(params.get('awokenParried'))
  // ?parrySound=now|a|b|c / ?execParrySound=now|a|b|c (10-09・src/parry_sound.ts): 普段のパリィの音 / ボスの致命を弾いた時の音の比較。
  //   指定なし = 配布版と同じ (a 柳の型 / b 押し返しの二段・10-09 ユーザー採用)。now = 旧の音。b・c・A・C の素材は git 外 (public/sfx/candidates/)。
  setParrySoundVariant(params.get('parrySound'))
  setExecParrySoundVariant(params.get('execParrySound'))
  // ?parryPitch=p|q|r (10-13・src/parry_pitch.ts): 普段のパリィの音を連続で弾いた段と技の重さで変える候補。指定なし = 配布版と同じ (今の柳の型)。
  setParryPitchVariant(params.get('parryPitch'))
  setKnightLanceFx(params.get('knightButtFx'), params.get('knightThrustFx'))  // 石突・突きの光 (石突の既定＝10-20 走るひび rift・?knightButtFx=crack3 で前の配布版・now でもっと前 / 突きは ?knightThrustFx=now で旧・src/knight_lance_fx.ts)
  setBrideVeilFx(params.get('brideVeilFx'))  // 花嫁「ヴェールの招待」の見た目 (既定＝10-20 影の手 hands・?brideVeilFx=wall で前の婚礼ヴェールの壁・cloth/cloth2 で布のヴェールの比較版・tsunami/tsunami-high/tsunami-heavy/tsunami-float で両側から挟む津波の比較版・rise/rise-topple/rise-cloth で床から生えて落ちる比較版・wall-cloth で前の壁の動きのまま一枚布・hands-veil で影の手の作り方のままヴェールの布・sides で両側から押し寄せて内へ巻くヴェール 10-23・sides-tulle で同じ動きのまま貼る絵だけ透けるヴェールの大きな一枚布 (片側3枚)・src/bride_veil_hands.ts)
  setHoundRoarFx(params.get('houndRoarFx'))  // 戴冠獣「灰の咆哮」の見た目 (既定＝10-20 めくれる床 floor・?houndRoarFx=line で前の儀式の境界線・src/hound_roar_floor.ts)
  setExecFloorFx(params.get('execFloorFx'))  // 介錯の地割りと榴弾の見た目 (既定＝10-20 石柱・照準の輪 parts・?execFloorFx=old で前の光の舌と光の粒の面・src/exec_floor_fx.ts)
  setExecFlameFx(params.get('execFlame'))  // 介錯の執行の刃の紫の炎と発勁 (既定＝10-21 から配布版も手描きの絵を取り込んだ版 sprite・?execFlame=code で前の配布版＝手本 prevA・j4 をコードで描く版・v1 で最初の版・old で炎なし・src/exec_fx.ts と src/exec_fx_sprites.ts)
  setExecShotFx(params.get('execShot'))  // 介錯の砲の弾 (既定＝10-20 手本 C 紫の残り火・?execShot=old で前の紫の光の玉)
  setExecApproach(params.get('execApproach'))  // 介錯の執行の寄り方 (既定＝10-20 前ステップを1歩・?execApproach=old で掲げたまま等速で寄る・src/exec_finisher_step.ts)
  setExecFinisherFx(params.get('execFinisherFx'))  // 介錯の致命「執行」の動き (既定＝10-20 据え斬り sue・?execFinisherFx=old で前の紫の振り下ろし・src/boss_pose_timeline.ts)
  // 戴冠獣 (10-08 ユーザー採用): 三連の3段は踏み込みあり (検収 H-4「こちらが良い」)。?houndTripleChase=off で旧 (踏み込みなし・src/hound_triple_chase.ts)。
  setHoundTripleChase(params.get('houndTripleChase') !== 'off')
  // 戴冠獣の掴み (houndGrab・赤) は技から外した (10-08 ユーザー判断 H-1「なくす」)。?houndGrab=on で幕2の連へ戻す (src/hound_kit.ts)。
  setHoundGrab(params.get('houndGrab') === 'on')
  // ?knightChargeHit=old: 騎士の壁ぎわの突進を旧 (走り出しの短い間だけ当たる) へ戻す比較。既定 = 走り終わりまで当たる (10-08 ユーザー採用・src/knight_charge_hit.ts)。
  setKnightChargeHitOld(params.get('knightChargeHit') === 'old')
  if (import.meta.env.DEV) {
    setBossNeutralMovementTrial(params.get('neutralMove') === 'actions')
    // ?spacing=old (覚醒王だけ): 攻撃していない間の間合いを旧の動き (追従の歩き・09-18 の立て直し) へ戻す比較。
    //   既定 (指定なし・?spacing=choice) は 09-27 採用の「技の選び方と区切りのある一手」= 本番と同じ。
    //   覚醒王は既定で neutralMove=actions よりこちらが優先 (?spacing=old&neutralMove=actions で旧の actions 試作)。
    //   票 = docs/handoffs/2026-09-26-awoken-spacing-choice.md
    setAwokenSpacingChoice(params.get('spacing') !== 'old')
    setAwokenHopTemporaryArt(params.get('awokenHopArt') === 'temp')
    // ?awokenHopSlide=0|10|20|30 (2026-10-05 比較): 後ろ跳びの着地の滑り (px)。既定は awoken_spacing_choice.ts の hopSlidePx。
    if (params.has('awokenHopSlide')) setAwokenHopSlidePx(Number(params.get('awokenHopSlide')))
    setBossNeutralBackOff(params.get('bossBackStep') === 'on')
    setAwokenPocketSpinEnabled(params.get('pocketSpin') !== 'off')
    setStanceBodyTrial(params.get('stanceBody') === '1' && params.get('fight') === 'crowned-king-awoken' && params.get('soloAttack') === 'feralBite')
    setBeastBodyTrial(params.get('bodyModel') === 'beast' && params.get('fight') === 'crowned-king-awoken')
    // ?bodyModel=ghost (2026-09-18 全ボス共通の比較案): 身体判定を持たない。歩き・回避・見切り突進の
    //   どれも通り抜け、内側からの滑り出しも無い (= DEV の B キーで芯を切った状態を URL で固定する)。
    //   ボス側の「主人公の手前で止まる」(clampToBossCoreFront) はそのまま = 変えるのは主人公の移動だけ。
    // 2026-09-18 採用: 通常起動は身体判定なし (BOSS_CORE.enabled=false)。ここは比較用。
    //   ghost = 採用版を明示 (&thrustStop=1 で突進だけ芯で止める案) / core = 旧・芯あり / beast・stanceBody = 旧比較 (芯あり前提)。
    const bodyModel = params.get('bodyModel')
    if (bodyModel === 'ghost') {
      setBossCore(false)
      setCounterThrustStop(params.get('thrustStop') === '1')
    } else if (bodyModel === 'core' || bodyModel === 'beast' || params.get('stanceBody') === '1') {
      setBossCore(true)
    }
    // ?counterStop=off|<px> (2026-10-06〜07・既定＝bosses.ts lungeStopGapPx を持つボス＝騎士 110・亡霊 120・花嫁 130・戴冠獣 185): 見切り反撃・連撃3段目の踏み込みの止まり位置。
    //   off = 旧 (120px 滑って騎士に重なる)、数字 = その距離 (全ボス) で止める。
    const counterStop = params.get('counterStop')
    // ?dodgeLen=b|c・?walkPace=a|c (2026-10-06 比較): 主人公の回避の長さ (260→360/460ms) と歩きの足運び。 回避の既定 a = 今・歩きの既定 b (10-06 採用・旧 = a)。
    //   中身 = src/player_locomotion_trial.ts
    //   ?dodgeLen=d (10-06 実在の回避 D1/D6/D4 から): 0.2 s で一気に滑り、低く止まって立つ (全体 0.56 s)。 10-07 に D＋黒い影の残像を既定へ (旧 = ?dodgeLen=a&dodgeTrail=0)。
    setDodgeVariant(params.get('dodgeLen'))
    // ?dodgeIFrame=c|b (10-07 比較): 回避の無敵 既定 a 200ms (10-14 に戻した) → c 100ms (10-07〜10-14 の既定) / b 150 ms。 中身 = src/player_locomotion_trial.ts
    setDodgeIFrameVariant(params.get('dodgeIFrame'))
    setDodgePose(params.get('dodgePose'))   // 回避 d の姿: 既定 lop (10-07 採用)・zzz・plain (最初の d)
    setDodgeTrail(params.get('dodgeTrail'))   // 既定 = 黒い影 (10-07 採用)・0 = 消す・plain / violet / white / blue (色の見比べ)
    setWalkVariant(params.get('walkPace'))
    // ?lunaWalk=new|newslow|newspeed|v2 (2026-10-12・src/player_walk_new.ts): 主人公の歩きを作り直した比較版。 new = 速さ 160・新しい絵 (上体・腕・頭・剣・髪が歩きに合わせて動く)・
    //   動き出しの加速・止まる時の1歩・足の滑りなし / newslow = 絵だけ (速さ 120 のまま) / newspeed = 速さだけ 160。 指定なし = 7 版目 a (配布版の既定・2026-10-13 ユーザー採用・騎士 164・亡霊 140)・旧の歩きに戻す = ?lunaWalk=old
    //   v2 = new の上半身を大きく動かした 2 版目 (前のめり・胴のひねり・肩と胸の上下・空いた腕・頭)＋騎士と亡霊の歩く速さ (騎士 設定 215＝歩きの本当の速さ 170・亡霊 180px/秒・docs/research/2026-10-12-lunaire-walk-v2.md)
    //   v3 = 軽い小走り (2026-10-13・速さ 160・両足が浮く運び・腰は踏んだ所で低い・上体と手は ZZZ の武器を持った走りを見本に・騎士と亡霊は v2 と同じ・docs/research/2026-10-13-lunaire-walk-v3.md)
    //   v4run / v4walk = 4 版目 (2026-10-13・見本のコマから読んだ鍵の姿勢を滑らかにつなぐ・src/player_walk_v4.ts)。 v4run = 腰を立てた走り (速さ 160・騎士と亡霊は v3 と同じ)・
    //     v4walk = 歩き (速さ 110・騎士と亡霊は主人公との比を v3 と同じに)。 docs/research/2026-10-13-lunaire-walk-v4.md
    //   v5 = 5 版目の歩き (2026-10-13・速さ 110・膝の曲げを鍵にして膝のカクつきを直した版・src/player_walk_v5.ts)。 docs/research/2026-10-13-lunaire-walk-v5.md
    //   v6a / v6b / v6c = 6 版目の歩き (2026-10-13・「足だけで歩いてる感じ」を受けて上半身を脚に合わせる 3 案・src/player_walk_v6.ts)。 docs/research/2026-10-13-lunaire-walk-v6.md
    //   v7a / v7b = 7 版目の歩き (2026-10-13・速さ 130・v7a 空いた手を体の横で振る／v7b 剣を構えて空いた手を腰の後ろへ・src/player_walk_v7.ts)。 docs/research/2026-10-13-lunaire-walk-v7.md
    setLunaWalkVariant(params.get('lunaWalk'))
    // ?counterFromDodge=0 (10-09 夜・src/dodge_counter_motion.ts): 見切り反撃のアニメを旧の counter (素立ちから・混ぜ 0.12 s) へ戻す比較。
    //   既定 (指定なし・=1) = 回避の低い止まり姿から直接伸び上がる counter_from_dodge (混ぜ 0・10-09 ユーザー採用「直す」)。描くだけ (当たりの時間・距離は同じ)。
    setDodgeCounterMotion(params.get('counterFromDodge'))
    // ?counterBlend=0 (10-09 夜・src/dodge_counter_motion.ts): 回避の止まり姿から外れた時刻で押した時の混ぜ (2〜3 コマ) を外す = 直す前と比べる。
    //   既定 (指定なし・=1) = 混ぜる (早めに押すと剣を持たない腕と髪が1コマで跳んだ破綻の修正・配布版)。 描くだけ (当たりの時間・受付・ダメージは同じ)。
    setCounterBlend(params.get('counterBlend'))
    // ?counterLook=shadow (10-09 夜・src/dodge_counter_look.ts): 回避反撃の見た目「影抜き」= 見切った所に黒い影が1体残り、反撃の光は銀白 (金をやめる)、
    //   「いま反撃できる」合図をレイピアに出す (Spine で描く時も)。 描くだけ (当たりの時間・受付・ダメージは同じ)。 既定 (指定なし) = 今の見た目。
    setCounterLook(params.get('counterLook'))
    // ?swingFacing=lock (2026-10-18・src/swing_facing_trial.ts): 主人公の攻撃を背中側に当てない比較版 (振り始めの向きで固定・背中側のボスには当たらない)。
    setSwingFacing(params.get('swingFacing'))
    if (counterStop === 'off') setCounterStopGap('off')
    else if (counterStop !== null && Number.isFinite(Number(counterStop)) && Number(counterStop) > 0) setCounterStopGap(Number(counterStop))
    // ?execGap (2026-10-10・src/execute_spacing.ts): 途中の致命でも近すぎる時は外へ寄せる (寄せる量が大きい時は「間合いを取る1拍」を挟む)。
    //   既定 (指定なし) = 寄せる (2026-10-10 ユーザー採用・配布版もこの動き)。=0 で旧 (寄せない)・=ease は1拍を挟まず寄せる時間だけ延ばす比較。
    //   出所 docs/research/2026-10-10-exec-gap-status.md
    setExecuteSpacing(params.get('execGap'))
    // ?finisherGap=0 (2026-10-18・src/execute_spacing.ts): 旧へ戻す比較。既定 (指定なし) = 最後の致命でも、内側から大きく外へ寄せる時は「間合いを取る1拍」を挟む
    //   (2026-10-18 ユーザー採用「配布版へ入れる」・配布版もこの動き)。=0 / off で旧 (いつでも 0.12 秒で刺し距離へ寄せる)。
    //   出所 docs/research/2026-10-18-finisher-gap-trial.md
    setFinisherSpacing(params.get('finisherGap'))
    // ?maulSetGap=0 (2026-10-10・src/exec_maulset_stop.ts): 旧へ戻す比較。既定は新 (ユーザー採用「新を採る」) = 介錯の据えの一打の3連で、主人公の手前 65px (体が触れる所) より内側へは寄らない。
    //   近すぎる時はその場で振る (下がらない)。=<px> (40〜160) で止まり幅だけ替える。当たり・時間・ダメージは同じ。
    //   出所 docs/research/2026-10-10-maulset-gap-status.md
    setMaulSetStop(params.get('maulSetGap'))
    // ?maulQuakeCharge=old (2026-10-10・src/exec_quake_charge.ts): 旧へ戻す比較。既定は新 (ユーザー採用「1.5秒に揃える」) = 地割りの溜めはどの出方でも 1500ms。
    //   old は「振り下ろし→地割り」の連の2拍目だけ 900ms。出所 docs/research/2026-10-10-executioner-maulquake-timing.md
    setMaulQuakeCharge(params.get('maulQuakeCharge'))
    // ?bossRegain=1[&regainMs=150&regainSpeed=2&regainWait=400] (2026-09-18 比較→同日採用・既定 on＝balance.ts overlapRegain。?bossRegain=0 で旧): 芯の帯に居られ続けたら
    //   ボスが速めに後退して間合いを立て直す。?backMs= は背後応手のしきい値を全ボスで上書き (覚醒王だけ 700ms)。
    const overlapRegainParam = params.get('bossRegain')
    if (overlapRegainParam === '1' || overlapRegainParam === '0') {
      const regainMs = Number(params.get('regainMs'))
      const regainSpeed = Number(params.get('regainSpeed'))
      const regainWait = Number(params.get('regainWait'))
      setOverlapRegain({
        enabled: overlapRegainParam === '1',
        ...(Number.isFinite(regainMs) && regainMs > 0 ? { holdMs: regainMs } : {}),
        ...(Number.isFinite(regainSpeed) && regainSpeed > 0 ? { speedMul: regainSpeed } : {}),
        ...(Number.isFinite(regainWait) && regainWait >= 0 && params.has('regainWait') ? { deferMs: regainWait } : {}),
      })
    }
    // ?execRegain=step|walk|leap (2026-09-18 比較): 介錯の立て直しの下がり方。既定は walk (boss.ts overlapRegain.execStyle)。step = 最初の比較版。
    const execRegain = params.get('execRegain')
    if (execRegain === 'step' || execRegain === 'walk' || execRegain === 'leap') {
      setOverlapRegain({ execStyle: execRegain })
    }
    const backMs = Number(params.get('backMs'))
    if (Number.isFinite(backMs) && backMs > 0) setBackAttackThresholdOverride(backMs)
    const travel = params.get('attackTravel')
    setBossAttackTravelMode(travel === 'planted' || travel === 'settle' ? travel : 'legacy')
    const approachStop = params.get('approachStop')
    if (approachStop === 'reach' || approachStop === 'legacy') setBossApproachStopMode(approachStop)
    corePractice = params.get('corePractice') === '1'
    const landing = params.get('coreLanding')
    if (landing === 'settle' || landing === 'legacy') setCoreLandingMode(landing)
  }
  const requestedStepStyle = params.get('stepStyle')
  if (requestedStepStyle === 'shunpo' || requestedStepStyle === 'lunge') {
    setExecutionerStepStyle(requestedStepStyle)
  }
  const requestedDropCharge = Number(params.get('dropCharge'))
  if (Number.isInteger(requestedDropCharge) && requestedDropCharge >= 300 && requestedDropCharge <= 3000) {
    setExecutionerDownswingChargeMs(requestedDropCharge)
  }
  // ?awokenPosture=<n>: 覚醒王の postureRecoveryPerSec (体幹の戻る速さ) を上書きする (2026-09-01)。
  //   未指定/異常値は現状のまま (setAwokenKingPostureRecoveryPerSec 側で弾く)。
  const requestedAwokenPosture = Number(params.get('awokenPosture'))
  if (Number.isFinite(requestedAwokenPosture) && requestedAwokenPosture > 0) {
    setAwokenKingPostureRecoveryPerSec(requestedAwokenPosture)
  }
  // ?delayCharge=<ms>: 覚醒王 feralBiteDelayed (暴噛・溜め) の chargeMs を上書きする (2026-09-01)。
  //   既定=1300 (2026-09-12 検収E-2)。旧1050/1175は比較用。
  const requestedDelayCharge = Number(params.get('delayCharge'))
  if (Number.isInteger(requestedDelayCharge) && requestedDelayCharge >= 300 && requestedDelayCharge <= 3000) {
    getAttack('feralBiteDelayed').chargeMs = requestedDelayCharge
  }
  // ?bladeGap=<ms>: 刃形態の連の中の「規則拍」(gapMs) を実機で切り替える (2026-09-06・実プレイで比べる用)。
  //   既定260。900/780の「ワンテンポ」は対象外 (setExecutionerBladeGapMs 参照)。範囲外は無視。
  //   正本 = docs/candidates/2026-09-05-executioner-blade-tempo-fable-design.md §3-1
  const requestedBladeGap = Number(params.get('bladeGap'))
  if (Number.isInteger(requestedBladeGap) && requestedBladeGap >= 1 && requestedBladeGap <= 2000) {
    setExecutionerBladeGapMs(requestedBladeGap)
  }
  // ?stepCooldown=<ms>: 既定500、0で旧・連打可能へ。未指定を Number(null)=0 にしない。
  const rawStepCooldown = params.get('stepCooldown')
  const requestedStepCooldown = rawStepCooldown === null ? NaN : Number(rawStepCooldown)
  if (Number.isFinite(requestedStepCooldown) && requestedStepCooldown >= 0 && requestedStepCooldown <= 2000) {
    setStepCooldownMs(requestedStepCooldown)
  }
  // ?bossCore=real|legacy: 既定real。legacyでも芯の中からの滑り出しは有効。
  const requestedBossCore = params.get('bossCore')
  if (requestedBossCore === 'real' || requestedBossCore === 'legacy') setBossCoreMode(requestedBossCore)
  // 介錯の据えの突き (src/exec_brace_thrust.ts)。既定 (指定なし) = v3 = 切り替わった瞬間に構えを jab_coil へ1コマで替え、溜め 600ms (10-09 ユーザー採用・配布版)。
  //   ?braceThrust=old = 旧 (据えの構えのまま → sweep_slash・溜め 350) / &braceThrustCharge=500|700 = v3 の溜めの比較。4発の条件・隙・ダメージはどれも同じ。
  //   下の ?pierceCharge / ?pierceArt より先に置く = ?braceThrust=old&pierceArt=a のように旧の上で単独つまみを使える。
  setBraceThrustFromParams(params.get('braceThrust'), params.get('braceThrustCharge'))
  const requestedPierceCharge = Number(params.get('pierceCharge'))
  if (Number.isInteger(requestedPierceCharge) && requestedPierceCharge >= 300 && requestedPierceCharge <= 3000) {
    getAttack('exec_maulSetPierce').chargeMs = requestedPierceCharge
  }
  // ⚠️ 有効範囲に 0 を含むつまみは `Number(null)=0` の罠がある: パラメータ未指定でも 0 と解釈され
  //   「0=無効化」を毎回踏む。実害 = 2026-09-01 欲張り分岐が本番で一度も発火しなかった (下の setGreed)。
  //   → 0 を含むつまみは必ず「パラメータの実在」を先に確かめる。
  const rawCreep = params.get('setCreep')
  const requestedCreep = rawCreep === null ? NaN : Number(rawCreep)
  if (Number.isInteger(requestedCreep) && requestedCreep >= 0 && requestedCreep <= 300) {
    setExecutionerMaulSetCreepPx(requestedCreep)
  }
  // ?setGreed=<n>: exec_maulSet の欲張り分岐しきい値つまみ (2026-08-31)。0=分岐無効化・1〜20=hits上書き。
  //   適用先は exec_maulSet の greedSwitch だけ (票 = docs/candidates/2026-08-31-executioner-greed-branch-design.md)。
  const rawGreed = params.get('setGreed')
  const requestedGreed = rawGreed === null ? NaN : Number(rawGreed)
  if (Number.isInteger(requestedGreed) && requestedGreed >= 0 && requestedGreed <= 20) {
    const maulSet = getAttack('exec_maulSet')
    if (requestedGreed === 0) {
      maulSet.greedSwitch = undefined
    } else if (maulSet.greedSwitch) {
      maulSet.greedSwitch.hits = requestedGreed
    }
  }
  // ?scoop=<a|b|old>: 斬り上げ (exec_maulHold) の候補タイムライン切替 (2026-09-02・実プレイで見比べる用)。
  //   a3=採用 (既定・2026-09-02 夜) / a・a2=振り抜きの繋ぎ違い / b=振り抜き無し / old=08-26 版。正本 = src/boss_pose_timeline.ts の
  //   EXEC_MAULHOLD_TIMELINE_VARIANTS。プリロードより前 (この module 初期化) に差し替える。
  const requestedScoop = params.get('scoop')
  if (requestedScoop === 'a' || requestedScoop === 'a2' || requestedScoop === 'a3'
    || requestedScoop === 'b' || requestedScoop === 'old') {
    setExecutionerScoopVariant(requestedScoop)
  }
  // ?bite=now|tele|reco: 覚醒王・暴噛の並びを比較する（採用済みの既定 reco）。
  const requestedBite = params.get('bite')
  if (requestedBite === 'now' || requestedBite === 'tele' || requestedBite === 'reco') {
    setAwokenBiteOrder(requestedBite)
  }
  // ?knightSweep=0912: 騎士・境界の薙ぎを 09-12 版 (溜め末尾に turn/cut・隙に生成構え ready・穂先固定の短い尾) へ戻す比較。
  //   既定 = 09-27 キーポーズ版 (構え→振り終わりの2枚 + 軌跡の弧)。正本 = src/boss_pose_timeline.ts KNIGHT_SWEEP_TIMELINES。
  if (params.get('knightSweep') === '0912') setKnightSweepVariant('0912')
  // 騎士の薙ぎの弧 (10-31・作者の答え C・src/knight_arc_brush.ts): 既定 = 騎士だけの槍の跡の絵。
  //   ?knightArc=line = 前の光る線の三日月 / ?knightArc=brush = 介錯の筆のぶれの絵 (開発版の比較)。
  setKnightArcLook(params.get('knightArc'))
  preloadKnightArc()
  // ?houndArt=old: 戴冠獣の溜めの絵 (吠え・致命・噛み・突進) を 10-07 の描き直し前へ戻す比較用。既定＝待機を土台にした新しい絵。
  if (params.get('houndArt') === 'old') setHoundArtOld(true)
  // ?houndRoar=now|a|c・?houndTripleArt=now: 戴冠獣・道1の描き直し (10-31・src/hound_road1_1031.ts)。?houndRoar=a|b|c で吠えの案 (配布版は前の絵・11-01 作者)・三連は描き直しが配布版で now で前の絵。
  const houndRoarParam = params.get('houndRoar')
  setHoundRoarArt(houndRoarParam === 'now' ? null : houndRoarParam === 'a' || houndRoarParam === 'b' || houndRoarParam === 'c' ? houndRoarParam : HOUND_ROAR_DEFAULT)
  setHoundTripleArt1031(params.get('houndTripleArt') === 'now' ? false : HOUND_TRIPLE_ART_DEFAULT)
  // 戴冠獣の三連 (10-08 ユーザー「この技いらないな」で技から外した・src/hound_kit.ts)。
  //   ?houndTriple=on = 技に戻す＋描き直し版の絵 (10-08 T-1〜T-3「新しい方が良い」) / old = 技に戻す＋描き直し前の絵 /
  //   redraw = 絵だけ描き直し版 (技には戻さない・?altAttacks=hound-triple と組んで見る・src/hound_triple_redraw.ts)。
  const houndTripleParam = params.get('houndTriple')
  setHoundTriple(houndTripleParam === 'on' || houndTripleParam === 'old')
  if (houndTripleParam === 'on' || houndTripleParam === 'redraw') setHoundTripleRedraw(true)
  // 戴冠獣の幕2の三連 (新・10-08 ユーザー「2幕に入れてほしい／他のモーションで」・src/hound_kit.ts hound-triple2)。
  //   2026-10-08 ユーザー採用 (tune2 パック：三連・c とも はい) ＝配布版の既定オン。?houndTriple2=off で切る (比較用)。
  setHoundTriple2(params.get('houndTriple2') !== 'off')
  // 戴冠獣の尾の薙ぎ (10-08 ユーザー「背後に回った時だけ出す」・src/hound_kit.ts)。配布版は抽選から外したまま。?houndTailPool=on で普段の抽選に戻す (比較用)。
  setHoundTailPool(params.get('houndTailPool') === 'on')
  // 戴冠獣の背後の応手を続けて出さない (10-10 ユーザー「背後攻撃を連発し続ける」・boss.ts backAttackMaxChain)。配布版は1回で切る。
  //   ?houndBackChain=old で旧 (上限なし＝尾の薙ぎが背中を向けたまま続く) へ戻す (比較用)。
  setBackAttackChainCap(params.get('houndBackChain') !== 'old')
  // 戴冠獣の駆け抜け (10-10 ユーザー「移動が一方向になり続ける」→ 案1 を戴冠獣から・src/hound_pass_through.ts)。
  //   同じ向きに流れ続けた／主人公を壁へ押し込んだ時に、くじで主人公の脇を駆け抜けて向こう側で振り返る。
  //   10-11 から配布版の既定 (答えるページ hound-pass-art「この動きで配布版へ入れる」)。?houndPassThrough=0 で旧 (出さない) へ戻す (比較用)。
  setHoundPassThrough(params.get('houndPassThrough') !== '0')
  // 技の終わりで待機へ入る tick に主人公の方へ向き直る (10-11 夜・boss.ts setIdleEntryFaceFix)。10-11 朝の答え「配布版へ」で既定。?idleFaceFix=0 で旧 (次の tick の頭で向き直る) へ戻す (比較用)。
  //   駆け抜けだけは配布版で既に同じ tick に向き直っている (090d145e)。調べ = docs/research/2026-10-11-idle-entry-facing-audit.md。
  setIdleEntryFaceFix(params.get('idleFaceFix') !== '0')
  // 🔴 退役 (10-11 朝: 「紫の技」は体を包むオーラの事で、技の絵の色は替えない・src/purple_swap.ts の頭の注)。
  // 紫の技をほかの色へ替える比較版 (10-11 ユーザー「紫はボスの致命とかパリィじゃないと対処できない攻撃として使って」・答えるページ purple-attack-scope ①・src/purple_swap.ts)。
  //   ?purpleSwap=a (弾けない＝赤・弾ける＝銀) / b (赤・橙) / c (灰白・青緑)。指定なし＝今のまま (配布版はここを通らないので常に今のまま)。
  setPurpleSwap(parsePurpleSwap(params.get('purpleSwap')))
  // 画面の赤を3つの意味で見分ける比較版 (10-30・10-09 点検 R3・src/red_signals.ts)。
  //   ?redSignals=a (場所で分ける) / b (色で分ける・10-31 から配布版の既定) / c (質感で分ける) / now (前の見え方)。指定なし＝b。
  setRedSignals(params.get('redSignals') === 'now' ? null : parseRedSignals(params.get('redSignals')) ?? 'b')
  // 戴冠獣の幕ごとのテンポ (10-08・src/hound_tempo.ts): ?houndTempo=now (三連を外しただけ) / a (10-08 採用＝配布版の既定) / b (差を大きく)。
  //   開発版で指定なしは a。配布版はここを通らず、hound_tempo.ts の既定 a のまま (10-08 に既定を now→a へ変えた)。
  setHoundTempo(params.get('houndTempo') ?? 'a')
  // 戴冠獣の体力・崩しのゲージの比較の段 (10-08・src/hound_tune.ts): ?houndTune=now (旧・〜10-08) / a / b / c (a と b の間・弾く人ほど楽＝配布版の既定)。
  //   2026-10-08 ユーザー採用 (tune2 パック：三連・c とも はい) ＝配布版の既定は c (econ.ts の bossPools['dream-hound'])。指定なし = c。now = 旧 (〜10-08)。
  setHoundTune(params.get('houndTune') ?? 'c')
  // 戴冠獣の「致命までの長さ」を縮める比較の段 (10-18・src/hound_short.ts): ?houndShort=a (体幹 254/254・戻り 8/秒) / b (215・8) / c (160・6)。
  //   作者の答え (10-18 C-1)「難しい」「致命までが長いと思う」。指定なし = 配布版のまま (体幹 290/427・戻り 20/秒)。houndTune の値の上に重ねるので後に呼ぶ。
  setHoundShort(params.get('houndShort'))
  const knightReset = params.get('knightReset')
  // 既定は on (boss_pose_timeline.ts)。指定がある時だけ切り替える (off = 09-30 までの既定)。
  if (knightReset === 'on' || knightReset === 'single' || knightReset === 'prev' || knightReset === 'off') setKnightResetMode(knightReset)
  // ?sweepWeight=a|b|c: 騎士・境界の薙ぎの「重さ」候補 (2026-09-27 夜・S-1「重さはもっと欲しい」)。既定 = なし (いまの版)。
  //   a = 当たった瞬間の手応え / b = 溜めを長く深く / c = 振り抜いた後の流れ+砂ぼこり / bc = b+c (09-28 S-7)。攻撃の時間・判定は変えない。
  //   正本 = src/boss_pose_timeline.ts KNIGHT_SWEEP_WEIGHT_TIMELINES / 描画 = src/knight_sweep_weight.ts。
  const requestedSweepWeight = params.get('sweepWeight')
  if (requestedSweepWeight === 'a' || requestedSweepWeight === 'b' || requestedSweepWeight === 'c' || requestedSweepWeight === 'bc' || requestedSweepWeight === 'scrape' || requestedSweepWeight === 'sound') setKnightSweepWeight(requestedSweepWeight)
  // ?sweepSound=adopted|off|now|a〜o: 騎士の薙ぎ・跳び下がり薙ぎの当たりの始まりに鳴らす音の候補 (2026-09-28)。既定 adopted = 採用した l (09-29)。
  //   正本 = src/knight_sweep_sound.ts。候補の音は public/sfx/candidates/ (git 外・main.ts が先読み)。
  const requestedSweepSound = parseKnightSweepSound(params.get('sweepSound'))
  if (requestedSweepSound) setKnightSweepSound(requestedSweepSound)
  // ?duck=off|<dB>: プレイヤーの音が鳴った瞬間にボスの技の音を下げる深さ (2026-09-29・既定 -9dB)。off = 下げない (聞き比べ用)。
  //   正本 = src/sound_priority.ts。
  const requestedDuck = params.get('duck')
  if (requestedDuck === 'off') setBossDuckDepthDb(null)
  else if (requestedDuck !== null && Number.isFinite(Number(requestedDuck)) && Number(requestedDuck) <= 0) setBossDuckDepthDb(Number(requestedDuck))
  // ?knightTell=now|a|b|c: 騎士の予告音 (構えの音) の候補 (2026-09-29)。既定 now = 共通の唸り。正本 = src/knight_telegraph_sound.ts。
  const requestedKnightTell = parseKnightTellSound(params.get('knightTell'))
  if (requestedKnightTell) setKnightTellSound(requestedKnightTell)
  // ?sweepGap=holdOn|hold: 連の払いの拍間 (S-4「固まって見える」の直し) の比較。既定 = follow
  //   (頭上から振り下ろした後は振り終わりのまま / ?sweepLink=low の2拍目以降の後は穂先が前上へ抜ける)。holdOn = どの拍の後も同じ絵。
  //   hold = 拍間ずっと振り終わり。lanceSweep_release は 09-29 使用禁止 (「疲れている絵」)。正本 = src/boss_pose_timeline.ts knightSweepGapImage。
  const requestedSweepGap = params.get('sweepGap')
  if (requestedSweepGap === 'hold' || requestedSweepGap === 'holdOn') setKnightSweepGap(requestedSweepGap)
  // ?sweepLink=low: 連の2拍目以降を旧既定の深い低姿勢 (linkWindup) + 前で振り上げる短い弧に戻す (比較用)。
  //   既定 (2026-09-29〜) = 単発と同じ構え (後ろ上に担ぐ) + 頭上を越える弧。正本 = src/boss_pose_timeline.ts KnightSweepLink。
  if (params.get('sweepLink') === 'low') setKnightSweepLink('low')
  // ?knightReach=old: 騎士の突き・薙ぎの当たりの前端と間合い (250/200・好み230/攻撃開始280) を 09-27 より前へ戻す比較。
  //   既定 = 描かれた穂先まで (128/95・175/215)。正本 = src/knight_reach.ts。
  if (params.get('knightReach') === 'old') setKnightReachVariant('old')
  // Knight spear-distance prototype; the previous movement remains available for comparison.
  if (params.get('knightSpacing') === 'old') setKnightSpacing('old')
  // ?knightWallCross=late: 壁ぎわ突進を2部屋目からに戻す比較。既定 = 1部屋目から (09-29 W-3「1部屋目から出す」)。
  if (params.get('knightWallCross') === 'late') setKnightWallChargeEarly(false)
  // ?knightBackoff=leap|walk: 近すぎる時の旧の動き。leap = 80px 以内なら必ず跳び下がり薙ぎ (09-29 午前・1部屋目から)、
  //   walk = 歩いて下がる 09-28 版 (跳び下がりは4割・2部屋目から)。既定 = mix (歩いて下がらず、跳び下がりは薙ぎのくじで混ぜる)。
  const knightBackoff = params.get('knightBackoff')
  if (knightBackoff === 'walk' || knightBackoff === 'leap') setKnightBackoff(knightBackoff)
  // ?knightLeapOdds=<0..1>: 近い時の単発の薙ぎが跳び下がり薙ぎになる確率 (既定 1/3)。1 = 必ず (見比べ用)。
  const knightLeapOdds = params.get('knightLeapOdds')
  if (knightLeapOdds !== null && Number.isFinite(Number(knightLeapOdds))) setKnightLeapOdds(Number(knightLeapOdds))
  // ?knightLeapTell=deep|none: 跳び下がり薙ぎの構えの見分け。既定 sink (5px 沈む)・deep (10px)・none (違いなし)。
  const knightLeapTell = params.get('knightLeapTell')
  if (knightLeapTell === 'deep' || knightLeapTell === 'none' || knightLeapTell === 'sink') setKnightLeapTell(knightLeapTell)
  // ?knightStaleCharge=off: 位置関係のマンネリで出す突進を止める (壁ぎわの突進は残る)。
  if (params.get('knightStaleCharge') === 'off') setKnightStaleCharge(false)
  // ?knightStaleRunRoom=<px>: マンネリの突進に要る「主人公の向こうに走り抜ける床」(既定 300px)。150 で比べる用。
  const knightStaleRunRoom = params.get('knightStaleRunRoom')
  if (knightStaleRunRoom !== null && Number.isFinite(Number(knightStaleRunRoom))) setKnightStaleRunRoom(Number(knightStaleRunRoom))
  // ?knightLeapFx=sweep|crescent: 切り下がりの見せ方を旧 (10-01 昼の薙ぎの弧 / 09-30 の槍の弧＋剣圧の三日月) へ。既定 = 槍の軌跡の帯 (10-01 夜)。
  const knightLeapFx = params.get('knightLeapFx')
  if (knightLeapFx) setKnightLeapFx(knightLeapFx)
  // ?knightClose=cross: 近い時の薙ぎの差し替えを、突き飛ばし (既定・10-01) から詰めて払って跳び下がる切り下がりへ戻す。
  if (params.get('knightClose') === 'cross') setKnightCloseAnswer('cross')
  // ?knightClose=shove: 10-01 夜〜10-02 の既定 (近い時は押し返しだけ・切り下がりは出ない)。
  if (params.get('knightClose') === 'shove') setKnightCloseAnswer('shove')
  // ?knightClosePity=<n>: 近くで n 回続けて選んだら次は近い時の技 (既定 4)。0 = なし (10-02 朝の版)。
  const knightClosePity = params.get('knightClosePity')
  if (knightClosePity !== null && Number.isFinite(Number(knightClosePity))) setKnightClosePity(Number(knightClosePity))
  // ?knightAct3Singles=<倍率>: 幕3の単発の突き・払いの重み (既定 0.2 = 連が主体)。1 = 10-02 までの配分。
  const knightAct3Singles = params.get('knightAct3Singles')
  if (knightAct3Singles !== null && Number.isFinite(Number(knightAct3Singles))) setKnightFinalActSingleMul(Number(knightAct3Singles))
  // ?knightActs=3: 騎士を旧の3幕へ戻す比較 (src/knight_acts.ts)。既定 (指定なし) = 2幕 (2026-10-10 ユーザー採用・配布版もこの形)。
  //   幕1 = 単発＋短い連＋近い時の技、幕2 = 長い連 (五連など) が主体。体力・体幹は econ.ts の KNIGHT_TWO_ACT_POOL。
  setKnightActs(parseKnightActs(params.get('knightActs')))
  // ?roosterHp=old: 鶏の体力を 10-31 の数値合わせの前 (388・幕は均等) へ戻す比較。指定なし = 配布版 (180・45:55・src/econ.ts)。
  setRoosterPoolOverride(params.get('roosterHp') === 'old' ? ROOSTER_POOL_OLD : null)
  // ?retaliation=on: 殴られ続けた時の割り込み反撃 (騎士=払い・介錯=踏み込みの突き・覚醒王=噛み) を戻す。10-02 に全ボスで既定 off。
  if (params.get('retaliation') === 'on') setRetaliationEnabled(true)
  // ?bossGuard=on: 待機中のボスが主人公の斬撃を受ける旧仕様 (09-29 全ボスで廃止) へ戻す比較。
  if (params.get('bossGuard') === 'on') setBossGuardEnabled(true)
  // ?sweepWindup=<low_a|low_b|twist_a|twist_b|mortar>: 砲身薙ぎ (exec_cannonSweep) の構えの絵の候補切替
  //   (2026-09-03 第8便・実プレイで見比べる用)。既定 = twist_a (第8便 採用)。mortar = 旧仮 (榴弾の構え流用・比較用)。
  //   プリロードより前 (この module 初期化) に差し替える。正本 = src/boss_pose_timeline.ts の
  //   EXEC_CANNONSWEEP_TIMELINE_VARIANTS / 絵ファイルの差し替え = src/sprites.ts の SPRITE_FILE_OVERRIDE。
  // ?cannonMode=<shove|duel> / ?cannonScore=<composed|single>: 砲形態の噛み合わせ案の切替 (2026-09-04・実プレイで比べる用)。
  //   🔵 2026-09-06 ユーザー裁定: 既定 = duel + composed (旧既定 shove は比較用にこのまま選べる)。
  //   正本 = docs/candidates/2026-09-04-executioner-cannon-tempo-design.md
  const requestedCannonMode = params.get('cannonMode')
  if (requestedCannonMode === 'shove' || requestedCannonMode === 'duel') setExecutionerCannonMode(requestedCannonMode)
  const requestedCannonScore = params.get('cannonScore')
  // Adopted by default. DEV retains the previous repertoire for comparison.
  if (import.meta.env.DEV) setCannonFajinEnabled(params.get('cannonFajin') !== '0')
  // 床の技の予告の見せ方 (src/floor_warn_vis.ts)。既定 = 配布版 (割れ目・裾払いの刃の先)。DEV ?floorVis=crack で割れ目だけの前の版・off で足さない版・d1|d2 で榴弾の比較版 (2026-11-02)
  if (import.meta.env.DEV) setFloorWarnMode(params.get('floorVis'))
  if (requestedCannonScore === 'composed' || requestedCannonScore === 'single') setExecutionerCannonScore(requestedCannonScore)
  // ?fajinDraw=<short|mid|long> / ?fajinBeat=<shallow|mid|deep|deeper|deepest>: 発勁の突きの
  //   溜め3択/一拍5択切替 (2026-09-08 拍のダイヤル続き・実機で比べる用)。既定 短い/深い。
  //   正本 = src/executioner_fajin.ts
  const requestedFajinDraw = params.get('fajinDraw')
  if (requestedFajinDraw === 'short' || requestedFajinDraw === 'mid' || requestedFajinDraw === 'long') {
    setFajinDraw(requestedFajinDraw as FajinDraw)
  }
  const requestedFajinBeat = params.get('fajinBeat')
  if (
    requestedFajinBeat === 'shallow' || requestedFajinBeat === 'mid' || requestedFajinBeat === 'deep' ||
    requestedFajinBeat === 'deeper' || requestedFajinBeat === 'deepest'
  ) {
    setFajinBeat(requestedFajinBeat as FajinBeat)
  }
  // ?cannonHold=<秒>: 砲形態に変わった直後、刃へ戻る判定を止める「時間の床」の長さ (2026-09-05・既定20秒)。
  //   秒で受けて内部はミリ秒。正本 = src/executioner_weapon.ts の EXECUTIONER.transform.cannonHoldMs。
  const rawCannonHold = params.get('cannonHold')
  const requestedCannonHold = rawCannonHold === null ? NaN : Number(rawCannonHold)
  if (Number.isFinite(requestedCannonHold) && requestedCannonHold >= 0) {
    setExecutionerCannonHoldMs(requestedCannonHold * 1000)
  }
  // ?mortarRows=<3|5>: 榴弾 (exec_cannonMortar) の落下列数の切替 (2026-09-05・実プレイで比べる用)。既定3列（5列は 2026-09-05 に試して不採用＝壁際で逃げ切れない。比較用にだけ残す）。
  //   正本 = src/executioner_weapon.ts の EXECUTIONER_MORTAR_ROW_OFFSETS。
  const rawMortarRows = params.get('mortarRows')
  const requestedMortarRows = rawMortarRows === null ? NaN : Number(rawMortarRows)
  if (requestedMortarRows === 3 || requestedMortarRows === 5) {
    setExecutionerMortarRows(requestedMortarRows)
  }
  // ?pierceArt=<a|b|old>: 据えの突きの絵の候補切替 (2026-09-04)。既定 old (ユーザー裁定「元のやつで問題ない」)。
  const requestedPierceArt = params.get('pierceArt')
  if (requestedPierceArt === 'a' || requestedPierceArt === 'b' || requestedPierceArt === 'old') setExecutionerPierceArt(requestedPierceArt)
  // ?maulQuakeWall=a|b|c (2026-10-09・src/exec_maulquake_wall.ts): 介錯の地割りの壁ぎわの逃げ道の比較版。
  //   a = いちばん外の帯 (±390) を出さない / b = 帯を壁の手前 60px で止める / c = 帯を全部 250ms 遅らせる。既定 (指定なし) = 今のまま。
  setMaulQuakeWallFromParams(params.get('maulQuakeWall'))
  // ?quakeBack=old|40 (2026-10-23・src/exec_quake_back_gap.ts): 地割りの後ろ側の最初の帯。配布版は 10-23 Q-1 で 20px 外 (-170)。old = 元の -150・40 = -190。
  setQuakeBackGapFromParams(params.get('quakeBack'))
  // ?quakeFront=20 (2026-10-23・同じファイル): 前側の最初の帯を 20px 外へ (+170)。背中側から出した反撃の突きが体を抜けて前の帯に入る件の直し方の案B。
  setQuakeFrontGapFromParams(params.get('quakeFront'))
  // ?dodgeFloor=now|counter|spend (2026-10-23・src/dodge_floor_rule.ts): 回避・見切りと床の帯の比較版。指定なし = 配布版 (地割りだけ・10-24)。
  setDodgeFloorFromParams(params.get('dodgeFloor'))
  // ?execJabSize=old|blade (2026-10-23・src/exec_jab_size.ts): 突き当て・据えの突きの溜めと刺しの2枚。配布版は 10-23 Q-2 で 1.20。old = 旧 1.08・blade = 1.29。
  setExecJabSizeFromParams(params.get('execJabSize'))
  // ?execCannonFajinSize=old (2026-10-23・src/exec_cannon_fajin_size.ts): 大砲の発勁の振りと振り抜きの2枚を旧の大きさ (待機の 82〜83%) へ戻す。配布版は待機にそろえた大きさ。
  setExecCannonFajinSizeFromParams(params.get('execCannonFajinSize'))
  // ?brideFlurry=now|a|b|c (src/bride_flurry_trial.ts): 花嫁の裾乱れの直し方。既定 (指定なし) = a (2026-10-10 ユーザー採用・配布版もこの形) = 速い連を軽く (体力 8→4・体幹 14→7)。
  //   now (または 0 / off) = 前のまま / b = 速い連の当たりの間 250→320ms / c = 速い連を3つずつに区切る (間の1か所だけ 500ms)。拍の数・絵・初撃と本命は変えない。
  setBrideFlurryFromParams(params.get('brideFlurry'))
  // ?roarParry=1[&roarKnock=200|300|400][&roarEscape=keep|none][&roarKnockDir=roomy|away] (2026-10-09・src/exec_roar_wave.ts):
  //   介錯の執行の咆哮の波3つを弾けるようにし、1つ弾いたら場の広い方へ吹き飛ばす (残りの波は当たらない)。既定 (指定なし) = 今のまま。
  setRoarWaveFromParams(params.get('roarParry'), params.get('roarKnock'), params.get('roarEscape'), params.get('roarKnockDir'))
  // ?jabFix=now|charge|early|light[&jabFixCharge=500|600|700] (src/exec_jab_fix.ts): 介錯の「振り下ろし×2→突き当て」の3拍目の直し方。既定 (指定なし) = charge 600ms (2026-10-10 ユーザー採用・配布版もこの形)。now (または 0 / off) = 前のまま。
  //   charge = 溜め 420→600ms (中身は据えの突き v3 と同じ沈み) / early = 当たりの時刻は今のまま、ワンテンポの最後 300ms で構えを先に見せる /
  //   light = 千秋楽だけ突き当ての重さを初演と同じ割合 (体力 16→8・体幹 22→15)。拍の数は変えない。
  //   charge に &jabFixScope=pair を足すと、突き当て×2 の2発目 (溜め 380) にも同じ直しを入れる。
  setJabFixFromParams(params.get('jabFix'), params.get('jabFixCharge'), params.get('jabFixScope'))
  // ?roarTell=v2[&roarTellLevel=1|2|3][&roarRing=off|keep] (2026-10-09・src/exec_roar_tell.ts): 咆哮の波の合図を見本の絵 (roar_tell_v2＋薄いほこり) どおりに。
  //   波の帯の内だけ、噴く 600ms 前から目地の銀白の光・帯の真上の熱かげろう・足首より低いほこり。roarRing=off (既定) = 今の音波の輪を出さない。
  //   描くだけ (当たり・時刻は変えない)。?roarParry=1 と一緒に使える。既定 (指定なし) = 今のまま。
  setRoarTellFromParams(params.get('roarTell'), params.get('roarTellLevel'), params.get('roarRing'))
  // 咆哮の3つの波は、ボスから外へ広がる空気の衝撃波が既定 (案B 420px/秒・溜め 3565ms・2026-10-12 ユーザー採用・配布版・試遊パック 10-10 の答え B-1「足りる」・src/exec_roar_air.ts)。
  //   旧 (床の帯の波) は ?roarAir=0。その時だけ ?roarParry・?roarTell などの床の帯の比較版が意味を持つ。
  //   前縁が触れた一瞬に当たる・弾ける (1つ弾いたら広い方へ飛び、残りは当たらない)・ガードで受けられる。?roarParry・?roarTell より後に読む (それらを外して当てる)。
  //   10-10: 既定で、幕2の頭に介錯が部屋の真ん中へ移ってから吠える (src/exec_roar_center.ts)・弾いた時は介錯から離れる向きへ飛ぶ。
  //   &roarAirCenter=0 で真ん中へ移らない (10-09 夜の版・飛ぶ向きの既定 roomy = 壁までの余白が大きい方)。&roarAirDir=roomy|away で向きだけ上書き。
  setRoarAirFromParams(params.get('roarAir'), params.get('roarAirDir'), params.get('roarAirCenter'))
  // ?execAct2Path=walk = 真ん中が介錯の後ろの時は歩いて下がる旧の道筋 (10-23 Q-4 で配布版は常に前ステップへ・src/exec_roar_center.ts)。
  setRoarCenterPathFromParams(params.get('execAct2Path'))
  // 11-04 作者「一瞬細い絵が挟まってる」: 真ん中への一歩の着地の後、不感帯 (16px) の残りを歩きの絵で詰めて2コマ細い横歩きが出る。
  //   その残りを立ち絵のまま詰める版を、砲の外套の比較版 ?execCloak=cannon に一緒に入れる (配布版はまだ変えない)。
  setRoarCenterNudgeStill(params.get('execCloak') === 'cannon')
  // ?execAct2Open=blink (10-23 作者「瞬間移動で、花嫁の瞬間移動と同じような風に、真ん中に移動して」): 幕2の頭に歩かず宵渡りで真ん中へ移り、
  //   咆哮の溜めの頭 700ms を削る (src/exec_act2_blink.ts)。setRoarAirFromParams の後に当てる (その版の上でだけ効く)。
  setAct2Blink(params.get('execAct2Open') === 'blink')
  // ?jabArt=<old|thrust|lunge>: 突き当ての絵の候補切替 (2026-09-04)。既定 = lunge (2026-09-22・boss_pose_timeline.ts の exec_maulJab)。
  //   thrust の専用絵は絵として壊れているので比較用だけ。
  const requestedJabArt = params.get('jabArt')
  if (requestedJabArt === 'old' || requestedJabArt === 'thrust' || requestedJabArt === 'lunge') setExecutionerJabArt(requestedJabArt)
  // ?execJabSteps= (2026-10-28・src/exec_jab_steps_1028.ts): 突き当ての段の絵の版。配布版は出だしを2段にした版 1028e。
  //   old = 前の配布版・1028/1028b/1028c/1028d = 途中の比較版 (開発版だけ)。?jabArt= と並べる時は &execJabSteps=old を添える。
  setExecJabSteps(params.get('execJabSteps'))
  // ?houndSmooth=1028 (2026-10-28・src/hound_smooth_1028.ts): 戴冠獣の突進と跳びかかりを位置と傾きで繋いだ比較版 (開発版だけ)。
  setHoundSmooth(params.get('houndSmooth'))
  // ?shadeSlashSmooth=old|1028 (2026-10-29・src/shade_slash_smooth_1028.ts): 亡霊の斬りを前の版へ戻す (開発版だけ・old＝段の絵なし・1028＝止まった段の絵3枚)。配布版は 1029。
  setShadeSlashSmooth(params.get('shadeSlashSmooth'))
  // ?knightSmooth= (2026-10-28・src/knight_smooth_1028.ts): 騎士の突き・薙ぎの足を床に留める版。配布版は old (10-30 作者・1028 は溜めで反る・跳ぶ)。1028 = 比較版 (開発版だけ)。
  //   ?sweepWeight= / ?knightSweep=0912 より後に呼ぶ (薙ぎは配布版の並びの時だけ替える)。
  setKnightSmooth(params.get('knightSmooth'))
  // ?brideMotion=old: 花嫁の横薙ぎ・返しの一閃・三重の返礼を 10-21 の手本合わせより前の絵の流れへ戻す (比べる用)。
  setBrideMotionArt(params.get('brideMotion') === 'old' ? 'old' : 'a')
  // ?brideIssen=1: 一閃を動画の見本に寄せた比較版 (振り上げ・振り下ろし・沈みの3枚を足す・2026-10-22)。配布版は URL を読まない。
  setBrideIssen(params.get('brideIssen'))
  // ?brideKaeshi=new|slow|blade: 返しの一閃を祈り→払い→ハートを1つ飛ばす技にした比較版 (2026-10-23・src/bride_kaeshi.ts)。slow = 届くまで約 0.3 秒。blade = 布の刃で三日月に振り下ろす版 (src/bride_kaeshi_blade.ts)。
  setBrideKaeshi(params.get('brideKaeshi'))
  // ?brideRedraw=hug|floor|exec|all: 抱擁を両腕で・裾を床に着けた剣舞・描き直した固有の致命の比較版 (2026-10-23・src/bride_redraw_1023.ts)。
  setBrideRedraw(params.get('brideRedraw'))
  // 抱擁が当たったら少しの間抱きとめ、♡を浮かべるのが既定 (10-27・src/bride_hug_bind.ts)。開発版だけ ?brideHug=old で前の配布版 (抱きとめず返しの一閃が続く)。
  setBrideHugBind(params.get('brideHug'))
  // 花嫁の絵は騎士の線・案A が既定 (10-26・src/bride_art_sample_1025.ts)。開発版だけ ?brideArt=old で元の絵、b|c で立ち姿の別案。
  setBrideArtSample(params.get('brideArt'))
  const requestedSweepWindup = params.get('sweepWindup')
  if (requestedSweepWindup === 'low_a' || requestedSweepWindup === 'low_b'
    || requestedSweepWindup === 'twist_a' || requestedSweepWindup === 'twist_b' || requestedSweepWindup === 'mortar') {
    const look = requestedSweepWindup as ExecutionerSweepWindupLook
    setExecutionerSweepWindupTimeline(look)
    setSpriteFileOverride('the-executioner', 'cannon', 'sweep_windup', look === 'mortar' ? null : `sweep_windup_${look}`)
  }
  // ?awokenArt=v2: 覚醒王の描き直しキー絵2枚 (walk_reach_v2 / extend_coil_v2) を試すつまみ (2026-09-07)。
  //   既定 (未指定・v2以外) は今までどおり walk_reach / extend_coil のまま何も変わらない。
  if (params.get('awokenArt') === 'v2') {
    setSpriteFileOverride('crowned-king-awoken', '', 'walk_reach', 'walk_reach_v2')
    // extend_coil は SpriteKey の網羅union外 (覚醒王タイムライン専用ポーズの既存パターン。sprites.ts の他所と同じ cast)。
    setSpriteFileOverride('crowned-king-awoken', '', 'extend_coil' as SpriteKey, 'extend_coil_v2')
  }
  // 覚醒王の歩きの試験 (2026-09-07・DEV 専用。既定 = 未指定 = 補正なしの旧の見た目。表と経緯は sprites.ts POSE_SCALE_FIX_TRIAL):
  //   ?awokenWalk=mid  = 旧の絵のまま walk_reach を 0.93 (3部位の折衷)
  //   ?awokenWalk=v2   = walk_reach を描き直し候補 walk_reach_v2 に差し替えて 0.88 (3部位の折衷)
  //   ?awokenWalk=idle = 歩きの相方を walk_reach から idle へ (絵を増やさない候補)
  //   ?awokenScale=crown = 🔴 不合格の冠基準29枚表 (記録用)
  {
    const walk = params.get('awokenWalk')
    if (walk === 'mid') setBossPoseScaleFixTrial('crowned-king-awoken', 'walk-mid')
    if (walk === 'v2') {
      setSpriteFileOverride('crowned-king-awoken', '', 'walk_reach', 'walk_reach_v2')
      setBossPoseScaleFixTrial('crowned-king-awoken', 'walk-v2')
    }
    if (walk === 'idle') setWalkPairOverride('crowned-king-awoken', ['walk_passing', 'idle'])
    if (params.get('awokenScale') === 'crown') setBossPoseScaleFixTrial('crowned-king-awoken', 'crown')
  }
  // ?awokenStep=off: 噛み技の「前脚が前へ着く」コマ (bite_step) を、直前と同じ bite_contact に戻す
  //   = 2026-09-08 より前の配布版と1画素も変わらない見た目。候補と現状を同じラボで見比べるためのつまみ。
  //   経緯 = ユーザー実機指摘「暴噛・暴連噛は距離を詰めながら攻撃するのに、溜と攻撃で足が同じままで滑って見える」。
  //   直し方の決定 = 前脚が1歩前へ出て着く (2026-09-08 ユーザー裁定)。当たり判定は contact 印のコマへ同期するので
  //   (hits.ts spawnMeleeHit)、印の付いた 0.0 は動かさず、滑っている後半 (at 0.55) だけ差し替えてある。
  if (params.get('awokenStep') === 'off') {
    setSpriteFileOverride('crowned-king-awoken', '', 'bite_step' as SpriteKey, 'bite_contact')
  }
  // ?biteArt=new: 2026-09-10 夜・暴噛の並び3案を実物の絵で比べる候補。既定は不変。
  //   tele だけ前脚が着いた当たりの絵 (down)、他は片あし上げ (up)。
  if (params.get('biteArt') !== 'old') {
    setSpriteFileOverride('crowned-king-awoken', '', 'bite_follow' as SpriteKey, 'bite_follow_0910')
    setSpriteFileOverride('crowned-king-awoken', '', 'bite_recover' as SpriteKey, 'bite_recover_0910')
    setSpriteFileOverride('crowned-king-awoken', '', 'bite_step' as SpriteKey, 'bite_step_0910')
    setSpriteFileOverride(
      'crowned-king-awoken',
      '',
      'bite_contact' as SpriteKey,
      params.get('bite') === 'tele' ? 'bite_contact_down_0910' : 'bite_contact_up_0910',
    )
    // 2026-09-12: 当たる瞬間に噛み込み、踏み込みでも閉じた口を保つ比較候補。
    // 絵だけの差し替え。reco の拍・接触タグ・移動はそのまま。
    if ((params.get('bite') ?? 'reco') === 'reco' && params.get('biteMouth') !== 'open') {
      setSpriteFileOverride('crowned-king-awoken', '', 'bite_contact' as SpriteKey, 'bite_contact_closed_0912')
      setSpriteFileOverride('crowned-king-awoken', '', 'bite_step' as SpriteKey, 'bite_step_closed_0912')
    }
  }
}
// 花嫁の絵の案A (10-26 配布版の既定) は差し替えを当てて初めて効くので、配布版でもここで当てる (上の DEV の囲いは配布版で走らない・10-31)。
if (!import.meta.env.DEV) setBrideArtSample(null)

// 旧絵への切替は開発時だけ。通常起動・配布版は採用絵を使う。
if (import.meta.env.DEV && typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search)
  if (params.get('biteArt') === 'old') {
    for (const key of ['bite_contact', 'bite_step', 'bite_follow', 'bite_recover']) {
      setSpriteFileOverride('crowned-king-awoken', '', key as SpriteKey, null)
    }
  }
  if (params.get('wallFangs') === 'old') {
    for (const key of ['dash_crouch', 'dash_form', 'wall_kick', 'rush_overextend']) {
      setSpriteFileOverride('crowned-king-awoken', '', key as SpriteKey, null)
    }
  }
}

const FX_LIFETIME_SEC = 0.5
// 大暴れ第5案: 触れた瞬間の揺れ (px・秒)。蹴り出しは揺らさない (着く側だけ＝15秒間揺れっぱなしにしない)。仮値。
const RAMPAGE_CONTACT_SHAKE: Partial<Record<string, { px: number; sec: number }>> = {
  wall_land: { px: 3, sec: 0.12 }, ground_land: { px: 4, sec: 0.16 },
  slam: { px: 12, sec: 0.4 }, roar: { px: 8, sec: 0.5 }, collapse: { px: 5, sec: 0.25 },
}

// dev 検収用: 攻撃プールを1技へ固定する (介錯 技構成パック 2026-07-05)。
//   baseAttackIds 未登録の技 (B4/B5/C7/D8/D9 等) も直接出せる。null で解除。
//   phaseTransitionAttackId (HP閾値の1回技) は抑制しない = 検証中に混ざるのは仕様。
//   ★2026-07-30: 譜面 (strings) のバイパスをここへ集約した。以前は呼び出し側 (main.ts の
//     __soloAttack) が別途 setDebugBypassStrings を呼ぶ約束で、呼び忘れると単独化が黙って
//     効かなくなった。介錯へ譜面を入れた時に実際にそれが起きた (tests/solo_attack.test.ts)。
//     単独化と譜面バイパスは常に一対なので、分けて持たない。
let debugSoloAttackId: string | null = null
if (import.meta.env.DEV && typeof window !== 'undefined') {
  const requested = new URLSearchParams(window.location.search).get('soloAttack')
  if (requested && ATTACKS[requested]) { debugSoloAttackId = requested; setDebugBypassStrings(true) }
  // ?altAttacks=<id>,<id>: 技 (か連) を A→B→A→B… と順に出す見比べ用 (2026-10-08・boss.ts setDebugAltAttacks)。
  //   連を使うので単独化 (soloAttack) と違って譜面は外さない = 三連は3段とも出る。soloAttack と同時に書いたら altAttacks が優先。
  const alt = new URLSearchParams(window.location.search).get('altAttacks')
  if (alt) { debugSoloAttackId = null; setDebugBypassStrings(false); setDebugAltAttacks(alt.split(',').map((t) => t.trim())) }
}
export function setDebugSoloAttack(id: string | null): void {
  debugSoloAttackId = id
  setDebugBypassStrings(id !== null)
}

// 死の一拍のチューニング (Codex Medium: 残り攻撃尺+余白、 上限~1.15s)。
const DEATHBEAT_HOLD_MS = 180   // ボスのモーション完了後の静かな余白
const DEATHBEAT_MAX_MS = 1150   // 安全上限 (入力不能の待ちが長すぎないよう)
const DEATHBEAT_SLOW_MS = 200   // 開始直後だけ軽いスロー

// 🔴 廃止 (2026-09-06)＝ 相手から離れすぎない「縄」(leashToPartner)。
//   旧コメント (2026-07-27・Nine Sols 方式): 「世界の壁ではなく相手との距離で行き止まりを作る」。
//   撤去の理由＝ Nine Sols の根拠は最終ボス Eigong 戦 (壁の無い特殊な場) 限定で、通常ボス戦は
//   実壁で閉じていた (一般化を誤っていた)。本作の部屋 (最大840) は画面幅 (960) より狭く、
//   「二人が同時に画面外へ出る」事態は壁だけで構造的に起きない = 縄は壁と同じ仕事を
//   見えない形で二重にやっていただけ。実プレイでは「見えない壁に急に当たって死んだ」
//   理不尽として現れた。距離を保つ役目は壁とボスの歩き (全ボス148〜270px/s ＞ 主人公120px/s) で
//   引き継ぐ (何も足さない)。出所＝docs/candidates/2026-09-06-camera-smash-style-fable-design.md §4-2。

function isAttackingState(s: GameState['boss']['state']): boolean {
  return s === 'telegraph' || s === 'active' || s === 'comboGap' || s === 'recovery'
}
function deathBeatTimeScale(elapsedMs: number, execution = false): number {
  if (execution) {
    // 処刑死: 深いスロー → ゆっくり実速へ戻す (「うわ、やられた」の絶望を引き伸ばす)。
    //   elapsed は実 ms (timeScale 非依存) なので、 スローでも演技尺・上限は変わらない。
    if (elapsedMs < 420) return 0.32
    return Math.min(1, 0.32 + ((elapsedMs - 420) / 520) * 0.68)
  }
  return elapsedMs < DEATHBEAT_SLOW_MS ? 0.6 : 1
}

// 箱1 (2026-07-06): 次のボスに未見の戦闘前ADVがあれば preBattle へ、無ければ即 playing へ。
//   起点はこのファイル内2箇所のみ (タイトル「始める」/ 幕間完走後の次ボス進行)。
//   死亡後の retry (再演) は同じボスなので既に markSceneSeen 済み=自然に playing へ戻る (ここを通らない)。
//   playing へ直に入る時は battleEntryWaitMs=0 で一戦の絵を待つ (src/battle_asset_gate.ts battleEntryStep・11-03)。
function entryPhase(campaign: CampaignState): { phase: 'preBattle' | 'playing'; adv: AdvRuntime | null; battleEntryWaitMs: number | null } {
  const bossId = getBossDefinition(campaign.currentBossIndex).id
  const scene = getPreBattleScene(bossId, campaign)
  if (scene && !(campaign.seenScenes ?? []).includes(scene.id)) {
    return { phase: 'preBattle', adv: startScene(scene), battleEntryWaitMs: null }
  }
  return { phase: 'playing', adv: null, battleEntryWaitMs: 0 }
}

// タイトルへ戻る時は必ず state を作り直す。{...state} を返してはいけない
//   (稽古の残骸・削れたボスHPをそのまま持ち越すと欠陥B/Cになる。2026-07-26 稽古セーブ破壊修正 §5-3)。
//   呼び出し元は3箇所 (幕間メニュー / 稽古の致命完遂 / つづくカード後)。
//   ⚠️ titleEntered は呼び出し側が「元の挙動」をそのまま渡す。 このセーブ修正で画面の見え方を
//      変えないため (2026-07-26 ユーザー指摘「元がどうだったか分からない」= 直す用事の無い所を
//      黙って変えていた)。 元の挙動: 幕間メニュー経由=state のまま / 他2経路=ロゴ画面 (false)。
function returnToTitle(state: GameState, sfx: SfxId[] = [], titleEntered = false): GameState {
  // 下書き (稽古) の進行は捨てて保存済みの本物から。 本編の進行はここで保存してから引き継ぐ。
  const campaign = state.campaign.scratch ? (loadCampaign() ?? createCampaign()) : state.campaign
  saveCampaign(campaign) // GATE: return-to-title (scratch印つきなら persistence.ts の入口が自分で弾く)
  return {
    ...createInitialState(campaign),
    phase: 'title',
    titleEntered,
    sfx, fx: [], shake: decayShake(state.shake),
  }
}

// 一戦だけモードの「もう一度」。 勝った後・倒れた後・幕間メニューから、 いつでもここへ来る。
//   createInitialState(state.campaign) では solo 印・稽古なし・難易度が失われる (= 2周目から
//   別のゲームになる) ので、 入口と同じ createSoloState を通し直すのが唯一の正しい作り直し方。
// 撃破を「一度でも倒した」側 (消えない層) へ刻む。 周回リセットでもボス追加でも消えない。
//   下書き印つき (稽古・一戦だけモード) は saveCampaign と同じ理由で弾く =
//   人に渡したリンクで遊ばれても、その人の本編の記録は1ミリも動かない。
//   実績 (src/achievements.ts・2026-10-31) もここで解く = 同じ理由で、 稽古と一戦だけモードでは解かない。
function recordClearedEver(campaign: CampaignState, bossId: string): void {
  if (campaign.scratch) return
  const marked = markBossClearedEver(loadRecord(), bossId)
  const { rec, unlocked } = unlockAchievements(marked, achievementsOnBossCleared(bossId, lifetimeTotals(marked, campaign)))
  saveRecord(rec)
  reportAchievementsToSteam(unlocked)
}

function restartSolo(state: GameState, sfx: SfxId[] = []): GameState {
  const next = createSoloState(state.boss.id)
  // 入口で id を検証済みなので null にはならない。 それでも黙って壊れないよう元の経路へ落とす。
  if (!next) return createInitialState(state.campaign)
  // 死亡数は引き継ぐ (2026-10-09 夜・再挑戦の点検)。 作り直すと毎回 0 に戻り、 負け画面の間 (初演4回目以降の短縮・千秋楽3回目以降の案内)
  //   と感想欄の死亡回数が「直前の1回」しか数えなくなっていた。 下書きの進行なので本編の記録には混ざらない。
  const campaign = { ...next.campaign, deathsByBossId: state.campaign.deathsByBossId, totalDeaths: state.campaign.totalDeaths }
  return { ...next, campaign, sfx }
}

export function updateGame(
  state: GameState,
  input: Input,
  defeatTimingScale = 1,
): GameState {
  const next = updateGameStep(state, input, defeatTimingScale)
  if (import.meta.env.DEV && hudV2()) observeHudV2(next)
  return next
}

function updateGameStep(
  state: GameState,
  input: Input,
  defeatTimingScale: number,
): GameState {
  // バッファは defeat 専用。外部のDEVフック等で phase が変わった場合も次画面へ漏らさない。
  if (state.phase !== 'defeat' && state.defeatRetryBuffered) {
    state = { ...state, defeatRetryBuffered: false }
  }

  // 進捗リセット (T キー・DEV 限定) ─ どのフェーズでも有効
  // localStorage をクリアして boss 0 から再開。 開発用なので消えない記録ごと消す
  //   (プレイヤーには経路が無い = input.ts の KeyT は import.meta.env.DEV の中)。
  if (input.pressed.has('reset')) {
    resetEverything()
    return createInitialState()
  }

  // 会話場面を通らずに戦いへ入った頭: 一戦の絵が読めるまで黒のまま止める (src/battle_asset_gate.ts battleEntryStep・11-03)。
  //   読めていればこの手番のうちに外して、そのまま戦いを進める (待ちの1コマを作らない)。
  if (state.phase === 'playing' && state.battleEntryWaitMs != null) {
    const waited = battleEntryStep(state.battleEntryWaitMs, FIXED_DT * 1000, state.boss.id)
    if (waited != null) {
      return { ...state, battleEntryWaitMs: waited, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
    }
    state = { ...state, battleEntryWaitMs: null }
  }

  // 幕間メニュー: playing フェーズのみ・finisher/deathBeat 中は無視
  if (state.phase === 'playing' && !state.finisher && !state.deathBeat) {
    // パッド切断 (BT電池切れ等): 戦闘中に限り、幕間を自動で開く (棒立ち死の理不尽を防ぐ)。
    //   pause 押下と同じ経路 (トグルでなく常に開く=切断中に再操作できないため)。
    if (input.padDisconnected === true && !state.paused && !state.pausePanel) {
      // メニューを開く瞬間: 直前の方向入力を持ち込ませない (2026-07-25 §7-3)。
      consumeNav()
      return {
        ...state,
        paused: true,
        pauseIndex: 0,
        pausePanel: null,
        menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false },
        // 自分で押していないが画面が突然変わる = 変化の説明として決定音を鳴らす (第3段)。
        sfx: ['ui_confirm'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
      }
    }
    // サブパネルなしの時だけ上位トグルが発火する。
    // サブパネル中の Escape は handlePauseMenu 内で処理する。
    if (input.pressed.has('pause') && !state.pausePanel) {
      consume('pause')
      const opening = !state.paused
      if (opening) consumeNav()
      return {
        ...state,
        paused: opening,
        pauseIndex: 0,
        pausePanel: null,
        menuNav: opening ? { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false } : MENU_NAV_INITIAL,
        // 開く=決定音 / 閉じる=戻る音 (第3段)。 幕の中へ戻るのは「戻る」向き。
        sfx: [opening ? 'ui_confirm' : 'ui_cancel'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
      }
    }
    if (state.paused) return handlePauseMenu(state, input)
  }

  // DEV の説明だけ止める。閉じた押しは戦闘に渡さず、稽古の記録も変えない。
  if (import.meta.env.DEV && DEV_COLLAPSE_FOCUS?.active && state.boss.id === 'nameless-shade'
    && state.phase === 'playing' && !state.paused) {
    if (DEV_COLLAPSE_FOCUS.ms >= DEV_COLLAPSE_FOCUS.spec.minShowMs
      && (input.pressed.has('parry') || confirmPressed(input, ['attack']))) DEV_COLLAPSE_FOCUS.active = false
    DEV_COLLAPSE_FOCUS.ms += FIXED_DT * 1000
    consume('parry'); consume('attack'); consume('step'); consume('retry')
    return { ...state, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
  }

  // ===== TIPS チュートリアルカード (2026-07-12) =====
  // 「カードを読む → 閉じる → その場で実践 → クリア → 次のカード」。
  //   カード表示中は戦闘シムを完全に止める (ボスは動かない・時間も進めない) = 落ち着いて読める。
  //   閉じる入力 = 攻撃 (左クリック / R1)。カード内に促しを描く。
  if (state.phase === 'playing' && !state.finisher && !state.deathBeat && !state.paused && state.tutorial) {
    const cards = tipsCardsForBoss(state.boss.id)
    const pending = pendingTipsCardIndex(cards, state.tutorial.lesson, state.tutorial.cardCursor)
    // 「間」が明けるまではカードを出さず、戦闘を動かし続ける (下の通常処理へ落ちる)。
    //   = 課題クリアの余韻を見せてから紙が来る。cardHoldMs は通常処理側で進める。
    if (pending >= 0 && state.tutorial.cardHoldMs >= TIPS_CARD_HOLD_MS) {
      const advance = confirmPressed(input, ['attack'])
      if (advance) { consume('retry'); consume('attack') }
      const tutorial: TutorialState = advance
        // 次のカードが続けて出る場合は「間」を置かない (めくる感覚でテンポよく)
        ? { ...state.tutorial, cardCursor: state.tutorial.cardCursor + 1, cardEnterMs: 0, cardHoldMs: TIPS_CARD_HOLD_MS }
        : { ...state.tutorial, cardEnterMs: state.tutorial.cardEnterMs + FIXED_DT * 1000 }
      return {
        ...state,
        tutorial,
        sfx: [],
        fx: ageFx(state.fx, state.time),
        shake: decayShake(state.shake),
      }
    }
  }

  // ===== ボス名乗りの「間」 (2026-07-19) =====
  // 名乗りカードが読める間は戦闘シムを止める (ボスは動かない・時間も進めない)。
  //   旧実装はカードを描くだけで時間を止めておらず、 ボスは 0.69〜1.11 秒で間合いに入って
  //   初手を振っていた = 「心構えができていないのに殴られる」。 TIPS カードと同型の停止。
  //   攻撃ボタンでスキップ可 (リトライのたびに待たされないため)。
  if (!state.finisher && !state.deathBeat && !state.paused && bossIntroHolding(state)) {
    const skip = input.pressed.has('attack')
    if (skip) consume('attack')
    return {
      ...state,
      bossIntroMs: skip ? BOSS_INTRO_HOLD_MS : state.bossIntroMs + FIXED_DT * 1000,
      sfx: [],
      fx: ageFx(state.fx, state.time),
      shake: decayShake(state.shake),
    }
  }

  if (state.hitStopRemaining > 0) {
    // 止めの中で次の操作を押したら、止め明けにスローへ入らない (1014c・押しは止め明けまでバッファに残る)。
    if (state.phase === 'playing' && !state.finisher && !state.deathBeat && execSlowCutPressed(input)) execSlowCutNow(state.fx, state.time)
    const hitStopRemaining = Math.max(0, state.hitStopRemaining - FIXED_DT)
    return {
      ...state,
      hitStopRemaining,
      // 致命を弾いた時のスロー (既定・src/exec_parry_slow_fx.ts): 止めの最後のコマで次のコマからの速さを決める (止めの間は今のまま)。
      ...(hitStopRemaining <= 0 && state.phase === 'playing' && !state.finisher && !state.deathBeat
        ? { timeScale: execSlowTimeScale(state.fx, state.time, 0) } : null),
      sfx: [],
      fx: ageFx(state.fx, state.time),
      shake: decayShake(state.shake),
    }
  }

  // ===== 稽古の「止めて、照らして、教える」(比較版 DEV ?tutFocus=1|2|3・src/tut_focus.ts) =====
  //   10-11 から配布版の既定は 'every' (全部の課題で止める)。DEV ?tutFocus=0 の時だけ 'off' = ここは素通り (旧のカードの稽古)。
  //   止めている間は戦闘シムを完全に止める (カードと同じ止め方)。押して抜ける時、当たる直前の場面ならその押しをこのコマへ渡す
  //   (= 押した瞬間が受付の始まりになる)。崩れた瞬間の場面は押しを渡さない。
  if (tutFocusMode() !== 'off' && state.phase === 'playing' && !state.finisher && !state.deathBeat && !state.paused && state.tutorial) {
    const lessons = tutorialLessonsFor(getBossDefinition(state.campaign.currentBossIndex))
    const lesson = currentLesson(state.tutorial, lessons)
    const press = {
      parry: input.pressed.has('parry'), confirm: confirmPressed(input, ['attack']),
      step: input.pressed.has('step'), attack: input.pressed.has('attack'), moveX: input.moveX,
    }
    // 3 だけが読む事情 (仕上げか・相手のゲージが赤いか・回避が出せるか・床の波の帯)。赤の閾値は下の稽古の進行と同じ式。
    const b0 = state.boss
    const ctx: FocusContext = {
      inFinale: !!lessons && state.tutorial.lesson >= lessons.length,
      bossBreakReady: b0.maxPosture > 0 && b0.state !== 'staggered'
        && b0.posture >= breakReadyRatio(b0, parryGainHpMul(b0) * bossPostureGainMul(b0)) * b0.maxPosture,
      stepReady: (state.time + FIXED_DT) * 1000 - state.player.lastStepStartMs >= getStepCooldownMs(),
      hits: state.hits,
      walkSpeed: walkSpeedPxPerSec(),
      // 3段目の課題 (配布版の稽古に入る) が、体幹の戻りを止めた印 (posture_hold) を読む。
      fx: state.fx,
      time: state.time,
    }
    const step = stepTutorialFocus(state.tutorial, lesson, state.player, state.boss, press, FIXED_DT * 1000, ctx)
    if (step.kind === 'hold' || (step.kind === 'release' && !step.passPress)) {
      // 止めている間の押しは溜めない (動き出した後に遅れて出ない)。
      consume('parry'); consume('attack'); consume('step'); consume('retry')
      return { ...state, tutorial: step.tutorial, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
    }
    if (step.kind === 'release') {
      // 崩れ中に連打していても、この押しは必ず受け付ける (押し直しの間 470ms をここだけ空ける)。
      const player = state.player.state === 'stunned' ? { ...state.player, stunParryPressMs: undefined } : state.player
      state = { ...state, tutorial: step.tutorial, player }
    }
  }

  // トドメ演出中: 通常戦闘を止めてタイムラインだけ進める
  if (state.finisher) {
    // 撃破の時計 (新しい版 ?lunaFinisher=new はゆっくりを tick の数の1回だけに掛ける・src/luna_finisher.ts finisherClockStepMs)。
    //   最後の一撃 C (既定・src/luna_finisher.ts FIN_C) は止めが明けてからのゲームの ms を決め、拍の時計はその折れ線で進める (撃破まで約 6 秒)。
    const nextElapsed = finisherClockNext(state.finisher.elapsedMs, state.timeScale)
    // 一突きの版 (DEV ?lunaExec=pierce): ゆっくりにしない・光が昇りきるまで待ってから勝ちへ (src/luna_exec_swap.ts PIERCE)。
    const pierce = lunaExecPierceOn()
    if (pierce ? nextElapsed >= PIERCE.endFinisherMs : finisherDone(nextElapsed)) {
      // G-7: 稽古モードの完了は本編進行を進めない。 実セーブを復元してタイトルへ戻る。
      if (state.practice) {
        return returnToTitle(state)
      }
      const campaign = onBossDefeat(state.campaign, state.boss.id, state.time)
      // 一戦だけモード: 最終ボスでも 'cleared' (終幕の総括) へ行かせない。 出口は victory 1つだけ。
      const phase = (!state.solo && isFinalBossIndex(state.campaign.currentBossIndex)) ? 'cleared' : 'victory'
      saveCampaign(campaign) // GATE: boss-defeat-finisher
      recordClearedEver(campaign, state.boss.id)
      return { ...state, phase, campaign, finisher: null, timeScale: 1, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
    }
    // ビート境界で SFX を鳴らす (pull 突入=魂の引き抜き音、 absorb 突入=吸収のヒット音)
    const beatNow = finisherBeat(state.finisher.elapsedMs)
    const beatNext = finisherBeat(nextElapsed)
    const sfx: SfxId[] = []
    let aliceShake: ScreenShake | null = null
    if (finisherV2On()) {
      // 新しい版: 抜く瞬間の音と、名前が出る時の静かな1音 (見切り反撃の音 counter_hit の流用はやめた)。
      sfx.push(...finisherV2BeatSfx(state.finisher.elapsedMs, nextElapsed, finisherProfileFor(state.boss.id), T_SILENCE))
    } else if (lunaExecSwapOn()) {
      // 致命の入れ替えの比較 (DEV ?lunaExec=swap): 魂の音・見切りの音の流用はやめ、遅れて弾ける音1本だけ (揺れも弾けた時に1回)。
      if (aliceBurstCrossed(state.finisher.elapsedMs, nextElapsed)) {
        // 重みを足した版 (?lunaExec=swap3): 低い芯を厚くした弾けの音・揺れも重く長く。
        const heavy = lunaExecSwap3On()
        sfx.push(heavy ? 'luna_alice_burst3' : 'luna_alice_burst')
        aliceShake = heavy
          ? { remainingSec: 0.5, amplitude: 12, startAmplitude: 12, totalDur: 0.5, startSec: state.time }
          : { remainingSec: 0.42, amplitude: 9, startAmplitude: 9, totalDur: 0.42, startSec: state.time }
      }
    } else if (beatNow !== beatNext) {
      if (beatNext === 'pull') sfx.push('execute_soul')  // 系統③ 魂 (#12 案A 分離・⚠️仮placeholder)
      if (beatNext === 'absorb') sfx.push('counter_hit')
    }
    return {
      ...state,
      time: state.time + FIXED_DT,
      finisher: { ...state.finisher, elapsedMs: nextElapsed },
      timeScale: pierce ? 1 : finisherCTimeScaleOfClock(nextElapsed) ?? finisherTimeScale(nextElapsed),
      sfx,
      fx: ageFx(state.fx, state.time),
      shake: aliceShake && state.settings.shakeOn ? aliceShake : decayShake(state.shake),
    }
  }

  // 死の一拍 (death beat): ボスの致命でプレイヤーが倒れた時、 即 defeat にせず ボスの決まり手を演じきる。
  //   通常戦闘・入力は止め (finisher と同型)、 現攻撃モーションだけ進める。 ボスが攻撃を終え idle に戻ったら
  //   短い余白の後 defeat へ。 死亡記録/保存は完了時 (二重記録回避・Codex)。
  if (state.deathBeat) {
    const db = state.deathBeat
    const elapsed = db.elapsedMs + FIXED_DT * 1000
    const stillAttacking = isAttackingState(state.boss.state)
    let boss = state.boss
    let bossSprite = state.bossSprite
    // 攻撃モーション中だけ進める (idle へ戻ると AI が死体へ再攻撃しうるので止める)。
    if (stillAttacking && elapsed < DEATHBEAT_MAX_MS) {
      boss = updateBoss(state.boss, state.player, []).boss
      bossSprite = updateBossSpriteRuntime(state.bossSprite, boss, false, null, FIXED_DT)
    }
    const motionDoneAtMs = db.motionDoneAtMs ?? (isAttackingState(boss.state) ? null : elapsed)
    const held = motionDoneAtMs !== null && elapsed - motionDoneAtMs >= DEATHBEAT_HOLD_MS
    if (held || elapsed >= DEATHBEAT_MAX_MS) {
      const campaign = onPlayerDeath(state.campaign, state.boss.id, state.time)
      saveCampaign(campaign) // GATE: player-death
      return {
        ...state, phase: 'defeat', phaseElapsedSec: 0, deathBeat: null, campaign,
        // 死因 (P4): deathBeat が消える前に退避 (defeat 画面が消えるまで保持)。
        lastDeathCause: db.causeLabel ?? state.lastDeathCause ?? null,
        // 死因カテゴリ (チケットB'): 同様に退避。 セーブ非対象・セッション内のみ。
        lastDeathAttackId: db.causeAttackId ?? state.lastDeathAttackId ?? null,
        boss, bossSprite, time: state.time + FIXED_DT, timeScale: 1,
        sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
      }
    }
    return {
      ...state, boss, bossSprite, time: state.time + FIXED_DT,
      deathBeat: { elapsedMs: elapsed, motionDoneAtMs, execution: db.execution, causeLabel: db.causeLabel, causeAttackId: db.causeAttackId },
      timeScale: deathBeatTimeScale(elapsed, db.execution),
      sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
    }
  }

  if (state.phase !== 'playing') {
    // フェーズ進行に使った押下はバッファから消費する。 これが無いと 1 回の押下が
    //   入力バッファ (5フレーム) に残り、 次のフェーズまで連鎖で貫通する (実機で確認したバグ)。
    const consumeAdvancePresses = (): void => {
      consume('retry'); consume('attack'); consume('parry'); consume('step'); consume('pause')
    }

    // タイトル: 上下で「(続きから) / 最初から / 常夜燈の稽古 / 幕間の記録」を選び、 決定する。
    if (state.phase === 'title') {
      // 幕間の記録サブパネル = キー設定の表 (2026-10-31・handleControlsPanel)。 戻る (○/Esc) か「閉じる」で閉じる。
      if (state.pausePanel === 'records') {
        const base = { ...state, sfx: [] as SfxId[], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
        return handleControlsPanel(base, input, () => ({ ...base, pausePanel: null, menuNav: MENU_NAV_INITIAL, sfx: ['ui_cancel'] }))
      }
      // クレジット (2026-10-31)。 上下・ホイールで送り、 戻る・「閉じる」・枠の外のクリックで閉じる。
      if (state.pausePanel === 'credits') {
        const base = { ...state, sfx: [] as SfxId[], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
        return handleCreditsPanel(base, input)
      }
      // 「幕を選ぶ」(難易度選択): マウスで項目をクリック、またはパッドの上下で選び決定して本編へ。
      //   千秋楽=既存の高難度 / 初演=主人公HP2倍・体幹崩れにくく (difficulty.ts)。
      if (state.pausePanel === 'difficulty') {
        // 当たり矩形は「直前フレームに描画された」並びに合わせる (今tickの選択変更前の index を使う)。
        const rects = difficultyMenuRects(state.difficultyIndex)
        const nav = stepMenuNav(state.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
        let difficultyIndex = moveCursor(state.difficultyIndex, nav.move, 2, true)
        difficultyIndex = applyPointerHover(input, rects, difficultyIndex)
        const clickHit = pointerClickHit(input, rects)
        if (clickHit >= 0) difficultyIndex = clickHit
        // カーソル音 (第3段): 「入力があった」ではなく「index が実際に動いた」で鳴らす。
        //   = キー/パッド/マウスのホバーを1本にまとめられる + 端で止まる並びで空打ちしない。
        const moveSfx = menuMoveSfx(state.difficultyIndex, difficultyIndex)
        // 戻る (○/Esc): タイトルの縦メニューへ戻る (2026-07-25 新規・従来は戻る手段が無かった)
        //   「最初から」の印もここで落とす = 幕を決めるまでは何も消さない (2026-10-19)。
        if (cancelPressed(input)) {
          consume('step'); if (input.device !== 'pad') consume('pause')
          return { ...state, difficultyIndex, pausePanel: null, titleNewGame: false, menuNav: nav.next, sfx: ['ui_cancel'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
        }
        // 2026-07-26 ユーザー裁定: メニューの決定はkbm=左クリックのみ。
        if (confirmPressed(input, ['attack'])) {
          if (!confirmAllowedByPointer(input, clickHit)) {
            // クリックが項目の外だった: 決定しない (押下だけ消費する・2026-07-25 第2段)。
            //   決定していないので決定音も鳴らさない (第3段)。
            consumeAdvancePresses()
            return { ...state, difficultyIndex, menuNav: nav.next, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
          }
          consumeAdvancePresses()
          // 千秋楽はまだ開いていない: 決定しても動かない (初演を選び直させる・2026-10-09)。
          if (difficultyIndex === 0 && !state.senshurakuOpen) {
            return { ...state, difficultyIndex, menuNav: nav.next, sfx: ['ui_cancel'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
          }
          // 決定: 難易度を確定・永続化してから本編へ (始める と同じ entryPhase。 未見の戦闘前ADVは先に見せる)。
          const difficulty: Difficulty = difficultyIndex === 1 ? 'hatsuen' : 'senshuraku'
          setDifficulty(difficulty)
          const settings = { ...state.settings, difficulty }
          saveSettings(settings)
          // 「最初から」(2026-10-19): ここで初めて周回層 (save:v3) を消す。
          //   消す前に、 いまの周の死亡数・時間などを消えない記録へ畳む (周回数は増やさない)。
          //   残る物 = 消えない記録 (record:v1・千秋楽の扉・撃破の記録) と 音と揺れ・難易度 (settings:v1)。
          //   ボス・主人公・稽古の札まで最初の幕の物へ作り直すため、 state は createInitialState から組み直す。
          let base: GameState = state
          if (state.titleNewGame) {
            saveRecord(foldAbandonedRunIntoRecord(loadRecord(), state.campaign))
            resetCampaign()
            base = { ...createInitialState(createCampaign()), phase: 'title', titleEntered: true }
          }
          const entry = entryPhase(base.campaign)
          return {
            ...base, settings, difficultyIndex, pausePanel: null, titleNewGame: false,
            // setDifficulty 後に player を作り直す = 初演なら満タン=2倍HPで開幕 (localStorage 非依存)。
            //   起動時 player は千秋楽で作られているため、 ここで作り直さないと初戦だけ2倍が効かない。
            player: createPlayer(),
            phase: entry.phase, adv: entry.adv, battleEntryWaitMs: entry.battleEntryWaitMs, phaseElapsedSec: 0, menuNav: MENU_NAV_INITIAL,
            sfx: ['ui_confirm'], fx: [], shake: decayShake(state.shake),
          }
        }
        return { ...state, difficultyIndex, menuNav: nav.next, sfx: moveSfx, fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
      }
      // 「最初から始める」の確かめ (2026-10-19): 進み具合が保存されている時だけ挟む。
      //   0=始める (幕を選ぶへ進む・まだ消さない) / 1=やめる。 開いた時は必ず「やめる」にカーソル。
      if (state.pausePanel === 'newGameConfirm') {
        const rects = newGameConfirmRects()
        const nav = stepMenuNav(state.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
        let newGameConfirmIndex = moveCursor(state.newGameConfirmIndex, nav.move, 2, true)
        newGameConfirmIndex = applyPointerHover(input, rects, newGameConfirmIndex)
        const clickHit = pointerClickHit(input, rects)
        if (clickHit >= 0) newGameConfirmIndex = clickHit
        const moveSfx = menuMoveSfx(state.newGameConfirmIndex, newGameConfirmIndex)
        const backToTitle = (): GameState => ({
          ...state, newGameConfirmIndex, pausePanel: null, menuNav: nav.next,
          sfx: ['ui_cancel'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
        })
        if (cancelPressed(input)) {
          consume('step'); if (input.device !== 'pad') consume('pause')
          return backToTitle()
        }
        if (confirmPressed(input, ['attack'])) {
          consumeAdvancePresses()
          if (!confirmAllowedByPointer(input, clickHit)) {
            return { ...state, newGameConfirmIndex, menuNav: nav.next, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
          }
          if (newGameConfirmIndex === 1) return backToTitle()
          return openDifficultyPanel(state, input, true)
        }
        return { ...state, newGameConfirmIndex, menuNav: nav.next, sfx: moveSfx, fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
      }
      // ゲート段階 (ENDER LILIES 流): まだメニューを開いていない時は、 何かキーで「メニューを浮かべる」だけ。
      //   始める等の確定はしない (= 押した瞬間にゲーム開始しない / 一拍置いて選ばせる)。
      if (!state.titleEntered) {
        // 2026-07-26 ユーザー裁定: メニューの決定はkbm=左クリックのみ。
        if (confirmPressed(input, ['attack'])) {
          consumeAdvancePresses()
          consumeNav()
          return {
            ...state, titleEntered: true, menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false },
            // メニューが浮かぶ = 前へ進む操作なので決定音 (第3段)。
            sfx: ['ui_confirm'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          }
        }
        return { ...state, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
      }
      // 縦メニュー: W/S/↑↓ (moveY) で上下選択。 マウスのホバー/クリックでも選べる (2026-07-25 第2段)。
      //   項目は進み具合の有無で3つか4つ (menu_layout.ts titleMenuItems・2026-10-19)。
      //   数・当たり矩形・描画は同じ items から取る = 「続きから」が増えても押した物と動く物がずれない。
      const titleItems = titleMenuItems(hasCampaignProgress(state.campaign))
      const titleRects = titleMenuRects(titleItems.length)
      const nav = stepMenuNav(state.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
      const prevTitleIndex = Math.min(state.titleIndex, titleItems.length - 1)
      let titleIndex = moveCursor(prevTitleIndex, nav.move, titleItems.length, true)
      titleIndex = applyPointerHover(input, titleRects, titleIndex)
      const titleClickHit = pointerClickHit(input, titleRects)
      if (titleClickHit >= 0) titleIndex = titleClickHit
      const titleMoveSfx = menuMoveSfx(prevTitleIndex, titleIndex)
      // 戻る (○/Esc): 最上位の階層なので戻り先が無い = 何もしない (2026-07-25 §6-2)。
      //   何も起きない操作に音を付けると「効いた」と誤解させるので無音のまま (第3段)。
      if (cancelPressed(input)) {
        consume('step'); if (input.device !== 'pad') consume('pause')
        return { ...state, titleIndex, menuNav: nav.next, sfx: titleMoveSfx, fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
      }
      // 2026-07-26 ユーザー裁定: メニューの決定はkbm=左クリックのみ。
      if (confirmPressed(input, ['attack'])) {
        if (!confirmAllowedByPointer(input, titleClickHit)) {
          consumeAdvancePresses()
          return { ...state, titleIndex, menuNav: nav.next, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
        }
        consumeAdvancePresses()
        const titleItem = titleItems[titleIndex]!
        if (titleItem === 'records') {
          // 幕間の記録: 操作確認パネルを開く (タイトルを離れない)
          consumeNav()
          return {
            ...state, titleIndex, pausePanel: 'records', controlsIndex: 0, controlsCapturing: false, menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false },
            sfx: ['ui_confirm'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          }
        }
        if (titleItem === 'credits') {
          consumeNav()
          return {
            ...state, titleIndex, pausePanel: 'credits', creditsScroll: 0, menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false },
            sfx: ['ui_confirm'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          }
        }
        if (titleItem === 'practice') {
          // 常夜燈の稽古: 亡霊 (index0) を単独再戦。 下書き印つきの進行なので保存されない
          //   (2026-07-26 稽古セーブ破壊修正・完了で returnToTitle が本物のセーブから復元する)。
          //   state を作り直す経路なので、 決定音は明示的に載せ直す (第3段)。
          return { ...createInitialState(createScratchCampaign()), practice: true, sfx: ['ui_confirm'] }
        }
        if (titleItem === 'newGame' && titleItems.includes('continue')) {
          // 最初から (進み具合あり): 消してよいかを一度確かめる。 カーソルは「やめる」から。
          consumeNav()
          return {
            ...state, titleIndex, pausePanel: 'newGameConfirm', newGameConfirmIndex: 1,
            menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false },
            sfx: ['ui_confirm'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          }
        }
        // 続きから / 最初から (進み具合なし): まず「幕を選ぶ」(難易度選択) サブ画面を挟む。
        //   決定した後に entryPhase で本編へ (再演→ポーズ→タイトル→選び直し の導線もここ)。
        return openDifficultyPanel({ ...state, titleIndex }, input, titleItem === 'newGame')
      }
      return { ...state, titleIndex, menuNav: nav.next, sfx: titleMoveSfx, fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
    }

    // 選択フェーズ (先代撃破後・第2段階): 5秒カウントダウン。
    //   A/D でカーソル (0=残る / 1=降りる)、 決定 (kbm=左クリック・pad=✕) で確定。
    //   5秒で時間切れ → 自動的に Loop-2 (呑まれる) へ。 (ワークブック #8「第2段階: 選択フェーズ」)
    if (state.phase === 'choice') {
      const CHOICE_LIMIT_SEC = 5
      // 横並びの二択 (残る/降りる) なので巡回しない = 端で止める (押しすぎで分岐が変わらないように)。
      //   並びが横なので横キーだけで動かす (2026-07-25 第1段-b)。
      const choiceRects = endingChoiceRects()
      const nav = stepMenuNav(state.menuNav, menuAxisDir(input, 'horizontal'), menuAxisEdge(input, 'horizontal'), FIXED_DT * 1000)
      let choiceIndex = moveCursor(state.choiceIndex, nav.move, 2, false)
      choiceIndex = applyPointerHover(input, choiceRects, choiceIndex)
      const choiceClickHit = pointerClickHit(input, choiceRects)
      if (choiceClickHit >= 0) choiceIndex = choiceClickHit
      const choiceMoveSfx = menuMoveSfx(state.choiceIndex, choiceIndex)
      // elapsed はこの tick 分を先に足してから判定する (adv.ts の choice.timeoutMs と同じ「同tick内で境界を跨いだら即成立」流儀)。
      const elapsed = state.phaseElapsedSec + FIXED_DT
      // ?choiceTimer=off (11-04 開発版・adv_fix2.ts): 時間切れを外す比較。 外すと終幕その4 (loop2) へは行けない。
      const timedOut = choiceTimerOn() && elapsed >= CHOICE_LIMIT_SEC
      // 2026-07-26 ユーザー裁定: メニューの決定はkbm=左クリックのみ。
      const rawConfirm = !timedOut && state.phaseElapsedSec >= 0.5 && confirmPressed(input, ['attack'])
      if (rawConfirm && !confirmAllowedByPointer(input, choiceClickHit)) {
        // クリックが項目の外だった: 決定しない。 押下だけ消費する (2026-07-25 第2段)。
        //   ⚠️ 消費しないと、同じ押下がバッファに残って次tickで pointerPress 無しの
        //   confirmAllowedByPointer に素通しされ、門番を回避してしまう。
        consumeAdvancePresses()
        return {
          ...state, choiceIndex, menuNav: nav.next, sfx: [], fx: ageFx(state.fx, state.time),
          shake: decayShake(state.shake), phaseElapsedSec: elapsed,
        }
      }
      const confirm = rawConfirm && confirmAllowedByPointer(input, choiceClickHit)
      if (confirm || timedOut) {
        consumeAdvancePresses()
        const kind = resolveEnding(choiceIndex, state.campaign.awakening ?? 0, timedOut)
        return {
          ...state, phase: 'ending', phaseElapsedSec: 0, choiceIndex,
          endingChoice: kind,
          adv: startScene(getEndingScene(kind)), menuNav: MENU_NAV_INITIAL,
          // 時間切れは自分で押していない = 決定音を鳴らさない (第3段)。
          sfx: confirm ? ['ui_confirm'] : [], fx: [], shake: decayShake(state.shake),
        }
      }
      return {
        ...state, choiceIndex, menuNav: nav.next, sfx: choiceMoveSfx, fx: ageFx(state.fx, state.time),
        shake: decayShake(state.shake), phaseElapsedSec: elapsed,
      }
    }

    // 幕間 ADV: 完走するまで毎 tick 進める。 完走後の進行入力で次の幕/問いへ。
    //   anyAdvance ブロックの外 (毎 tick) に置く = beat の時間経過・timeout を正しく動かすため。
    if (state.phase === 'interlude') {
      const scene = getInterludeScene(state.boss.id)
      let rt = state.adv ?? startScene(scene)
      // 場面の頭の絵 (と先代の回想) が読めるまで、黒のまま始めない (src/battle_asset_gate.ts・上限あり)。
      //   待つ間は経過 (送りの 0.6 秒の守り) も進めない。
      const entry = holdAdvEntry(rt, scene, FIXED_DT * 1000)
      rt = entry.rt
      if (entry.held) {
        return { ...state, adv: rt, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
      }
      if (!rt.done) {
        const guardPassed = state.phaseElapsedSec >= 0.6
        const nav = stepMenuNav(state.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
        // マウス: 選択肢が出ている時だけ、 ホバーで「未選択」を抜け、 option内クリックで選んで確定する
        //   (第2段の applyPointerHover/pointerClickHit/confirmAllowedByPointer を流用・2026-07-25 第4段 §5-3)。
        let choiceClickHit = -1
        // 選択肢のカーソル音用 (第3段): tickAdv 前の位置を控える。 ホバー/クリック/方向キーの
        //   どれで動いても「index が変わった」1点で判定できる。
        const advChoiceIndexBefore = rt.choiceIndex
        const advChoiceOpen = !!scene.choice && rt.choosing && isChoiceInputOpen(rt)
        if (rt.choosing && scene.choice && isChoiceInputOpen(rt)) {
          const rects = input.advChoiceRects ?? []
          const hoverIdx = applyPointerHover(input, rects, rt.choiceIndex)
          if (hoverIdx !== rt.choiceIndex) rt = { ...rt, choiceIndex: hoverIdx }
          choiceClickHit = pointerClickHit(input, rects)
          if (choiceClickHit >= 0 && choiceClickHit !== rt.choiceIndex) rt = { ...rt, choiceIndex: choiceClickHit }
          if (!confirmAllowedByPointer(input, choiceClickHit)) {
            // クリックが option の外: 本文送りにもしない (選択中は送る先が無いため・§5-3)。
            //   押下だけ消費する (消費しないと、同じ押下がバッファに残って次tickで pointerPress
            //   無しの confirmAllowedByPointer に素通しされ、門番を回避してしまう・第2段と同じ罠)。
            consume('retry'); consume('attack'); consume('parry'); consume('step')
            return {
              ...state, adv: rt, menuNav: nav.next,
              sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
              phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
            }
          }
        }
        // ADV 進行: 入力を AdvInput へ翻訳。
        //   advance = 0.6s ガード後の任意アクション (誤爆防止)。 R タップ = 1行送り (即時)。
        //   skip = ✕/R 長押し(600ms)=早送り (選択の手前まで)。 choiceMove = stepMenuNav 経由 (2026-07-25 統一)。
        //   confirm = ✕ or 攻撃/パリィ (0.6s後) or 選択肢内クリック (2026-07-25 第4段)。 'step' (右クリック/○) は
        //   2026-07-25にメニューの「戻る」専用へ譲ったため ADV 進行からは外した (§6-3・意図的な非対称解消)。
        const decide = advDecidePressed(input, ['attack', 'parry'], guardPassed)
        // 2026-07-26: 選択肢が開いている間、 kbm の確定は「選択肢そのものをクリック」だけにする。
        //   ↑↓ を廃止して kbm からカーソルを動かす手段が無くなったため、 Space でも確定できると
        //   「読み進めるつもりの Space が、選べていない選択肢を確定させる」事故になる。
        //   この選択は awakening と終幕の分岐に効く = 一番やってはいけない誤爆。
        //   パッドは十字/スティックで動かせるので従来どおり ✕ で確定できる。
        //   時間切れは無い (adv_scripts に timeoutMs 無し) ので、 クリックするまで待つだけ。
        const kbmChoiceOpen = advChoiceOpen && input.device !== 'pad'
        const advInput: AdvInput = {
          advance: decide,
          skip: advSkipHeld(input),
          choiceMove: nav.move,
          confirm: (kbmChoiceOpen ? false : decide) || choiceClickHit >= 0,
        }
        const out = tickAdv(rt, scene, advInput, FIXED_DT * 1000)
        let campaign = state.campaign
        if (out.awakenDelta !== 0) campaign = addAwakening(campaign, out.awakenDelta)
        // 箱2: choice が「未確定→確定」に変わった瞬間を検出して、どちらを選んだかを記録する
        //   (options[0]=True/+1awaken, options[1]=Loop/+0awaken の並び規約に従う)。
        if (scene.choice && !rt.choiceResolved && out.rt.choiceResolved) {
          campaign = recordBossChoice(campaign, state.boss.id, out.rt.choiceIndex === 0 ? 'true' : 'loop')
        }
        if (out.rt.done) campaign = markSceneSeen(campaign, scene.id)
        // 操作音 (第3段): 選択肢の中でだけ鳴らす。 本文送りには付けない (1行ごとに鳴ると読書のリズムを壊す)。
        const advSfx: SfxId[] = advCueSfx(out.firedCue)
        // 2026-07-26 (C案): 選択肢が現れ始めた 1 tick だけ鳴らす。 友達FB「選択肢なんかあったな、
        //   飛ばしちゃった」への対策のうち「気づかせる」側。 ⚠️ 文章を読まないプレイヤーには
        //   音しか届かない (テスターの像 = docs/playtest/2026-07-26-friend-feedback-triage.md §9-3)。
        //   鳴らすのはフェードが始まる瞬間 = 画面に何かが出た瞬間 (入力が開く時刻ではない。
        //   連打している人へ「今なにか出た」を先に知らせるのが目的なので早い側で鳴らす)。
        //   この時刻は入力が閉じている区間なので、 confirm/move と同時に鳴ることはない。
        if (out.rt.choosing && choiceRevealJustStarted(rt.choiceElapsedMs, out.rt.choiceElapsedMs)) {
          advSfx.push('ui_choice_appear')
        }
        if (scene.choice && !rt.choiceResolved && out.rt.choiceResolved) advSfx.push('ui_confirm')
        else if (advChoiceOpen && out.rt.choiceIndex !== advChoiceIndexBefore) advSfx.push('ui_move')
        if (advInput.advance || advInput.confirm) {
          consume('retry'); consume('attack'); consume('parry'); consume('step')
        }
        return {
          ...state, adv: out.rt, campaign, menuNav: nav.next,
          sfx: advSfx, fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
        }
      }
      // 完走後: 進行入力で次へ。
      //   完走直後は done=true になったが入力消費済み = 次 tick で判定する。
      const guardPassed = state.phaseElapsedSec >= 0.6
      const advance = advDecidePressed(input, ['attack', 'parry'], guardPassed)
      if (advance) {
        consume('retry'); consume('attack'); consume('parry'); consume('step')
        if (isCampaignCleared(state.campaign)) {
          return {
            ...state, phase: 'choice', phaseElapsedSec: 0, choiceIndex: 0, adv: null,
            sfx: [], fx: [], shake: decayShake(state.shake),
          }
        }
        // 配布版の区切り (既定=覚醒獣 = campaign.ts DEMO_FINAL_BOSS_ID・11-01)。
        //   この先はまだ配らないので「つづく」で閉じる。
        //   🔴 2026-08-07 訂正: ~~「既定=騎士」~~ は 2026-07-24 の騎士↔花嫁 入替より前の記述。
        //   区切りの正は campaign.ts の定数1本。 ここに具体名を書くならそちらと同時に直す。
        if (isDemoBoundary(state.boss.id)) {
          return {
            ...state, phase: 'tsuzuku', phaseElapsedSec: 0, adv: null,
            sfx: [], fx: [], shake: decayShake(state.shake),
          }
        }
        // 次ボスへ進行。 未見の戦闘前ADVがあれば先に見せる (箱1)。
        const entry = entryPhase(state.campaign)
        return { ...createInitialState(state.campaign), phase: entry.phase, adv: entry.adv, battleEntryWaitMs: entry.battleEntryWaitMs, phaseElapsedSec: 0 }
      }
      // 完走後・入力待ち: 経過だけ進める
      return {
        ...state, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
        phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
      }
    }

    // 「つづく」カード (配布版の終わり)。 2枚組: 余韻 → 実務 → タイトルへ戻る。
    //   2枚に割る理由 = 余韻に業務連絡を混ぜると余韻が死ぬ / 1枚で止めると
    //   「バグった?」と迷わせる (票 `2026-07-20-tsuzuku-card-copy-3-options.md` §1)。
    //   急がせないので進行入力のガードは幕間と同じ 0.6 秒。
    if (state.phase === 'tsuzuku' || state.phase === 'tsuzukuNote') {
      // 2026-07-24 の✕統一以降、パッドは retry(✕) 以外で進めない。
      //   'pause'(Escape/Start)を即時進行キー扱いする従来コメントは事実と異なっていたため削除 (2026-07-25 §6-1)。
      const guardPassed = state.phaseElapsedSec >= 0.6
      const advance = confirmPressed(input, guardPassed ? ['attack', 'parry'] : [])
      if (advance) {
        consume('retry'); consume('pause'); consume('attack'); consume('parry'); consume('step')
        if (state.phase === 'tsuzuku') {
          return {
            ...state, phase: 'tsuzukuNote', phaseElapsedSec: 0,
            sfx: [], fx: [], shake: decayShake(state.shake),
          }
        }
        // 実務カードの後はタイトルへ。 進行 (campaign) は保持する = 遊び直せる。
        return returnToTitle(state)
      }
      return {
        ...state, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
        phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
      }
    }

    // 戦闘前 ADV (箱1): interlude と同じ形。 完走するまで毎tick進め、完走後の進行入力で戦闘へ。
    //   pre-battle シーンには選択肢が無い (workbook仕様) ので choiceMove/confirm は常に無効。
    if (state.phase === 'preBattle') {
      const scene = getPreBattleScene(state.boss.id, state.campaign)
      if (!scene) {
        // entryPhase が事前に弾くため通常は来ないが、保険として即 playing へ。
        return { ...state, phase: 'playing', phaseElapsedSec: 0, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
      }
      const entry = holdAdvEntry(state.adv ?? startScene(scene), scene, FIXED_DT * 1000)
      const rt = entry.rt
      if (entry.held) {
        return { ...state, adv: rt, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake) }
      }
      if (!rt.done) {
        const guardPassed = state.phaseElapsedSec >= 0.6
        const advInput: AdvInput = {
          advance: advDecidePressed(input, ['attack', 'parry'], guardPassed),
          skip: advSkipHeld(input),
          choiceMove: 0,
          confirm: false,
        }
        const out = tickAdv(rt, scene, advInput, FIXED_DT * 1000)
        if (advInput.advance) {
          consume('retry'); consume('attack'); consume('parry'); consume('step')
        }
        return {
          ...state, adv: out.rt,
          sfx: advCueSfx(out.firedCue), fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
        }
      }
      // 戦いへ抜ける途中: 曲が消えて画面が黒に落ちきってから戦いへ (main が曲を、 render が暗転を見る)。
      if (rt.exitMs != null) {
        const exitMs = rt.exitMs + FIXED_DT * 1000
        // 暗転が終わっても一戦の絵が読めていなければ、黒のまま待つ (src/battle_asset_gate.ts・上限あり)。
        if (battleExitDone(exitMs, ADV_BATTLE_EXIT_MS, state.boss.id)) {
          return {
            ...state, phase: 'playing', adv: null, campaign: markSceneSeen(state.campaign, scene.id),
            phaseElapsedSec: 0, sfx: [], fx: [], shake: decayShake(state.shake),
          }
        }
        return {
          ...state, adv: { ...rt, exitMs }, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
        }
      }
      const guardPassed = state.phaseElapsedSec >= 0.6
      // 暗転で終わる場面 (花嫁など) は、 黒のまま送り入力を待たずに戦いへ入る。
      //   (sceneId を見るのは、 確認用の ?advPreview が戦いの後の場面をこの分岐で閉じるため)
      const advance = (endsInBlackout(scene) && rt.sceneId === scene.id) || advDecidePressed(input, ['attack', 'parry'], guardPassed)
      if (advance) {
        consume('retry'); consume('attack'); consume('parry'); consume('step')
        return {
          ...state, adv: { ...rt, exitMs: 0 },
          phaseElapsedSec: state.phaseElapsedSec + FIXED_DT, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
        }
      }
      return {
        ...state, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
        phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
      }
    }

    // 終幕 (先代撃破後・第3段階): interlude と同型の ADV駆動。 本文+cue演出を流し、
    //   完走後の進行入力で「新しい再演」= まっさらにしてタイトルへ (全エンド共通)。
    //   ⚠️ スタッフロール画面/エンドC円環なしの専用演出は未実装 = 将来タスク。 機能上は全部タイトルへ。
    if (state.phase === 'ending') {
      const scene = getEndingScene(state.endingChoice ?? 'loop')
      const rt = state.adv ?? startScene(scene)
      if (!rt.done) {
        const guardPassed = state.phaseElapsedSec >= 0.6
        const advInput: AdvInput = {
          advance: advDecidePressed(input, ['attack', 'parry'], guardPassed),
          skip: advSkipHeld(input),
          choiceMove: 0,
          confirm: false,
        }
        const out = tickAdv(rt, scene, advInput, FIXED_DT * 1000)
        if (advInput.advance) { consume('retry'); consume('attack'); consume('parry'); consume('step') }
        return {
          ...state, adv: out.rt,
          sfx: advCueSfx(out.firedCue), fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
          phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
        }
      }
      // 完走後: 進行入力で新しい再演へ (タイトル・進行リセット)。
      const guardPassed = state.phaseElapsedSec >= 0.6
      const advance = advDecidePressed(input, ['attack', 'parry'], guardPassed)
      if (advance) {
        consumeAdvancePresses()
        // セーブ2層化 (2026-07-29・§8 問題1): 周を戻す前に、この周のぶんを消えない記録へ畳む。
        //   ここが唯一の畳み場所。 fold と resetCampaign は必ず対で呼ぶ (片方だけだと数が狂う)。
        //   下書き印つき (稽古・一戦だけモード) の進行はそもそもここへ来ないが、保険で弾く。
        if (!state.campaign.scratch) {
          let rec = foldRunIntoRecord(loadRecord(), state.campaign)
          if (state.endingChoice) rec = markEndingSeen(rec, state.endingChoice)
          const done = unlockAchievements(rec, achievementsOnRunCompleted(getDifficulty()))
          saveRecord(done.rec)
          reportAchievementsToSteam(done.unlocked)
        }
        resetCampaign()
        return { ...createInitialState(), phase: 'title' }
      }
      return {
        ...state, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
        phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
      }
    }

    // 敗北だけは再演ゲートを独立させる。再演ボタンの出始めと同じ時刻に門を開く。
    //   早すぎる押下は捨て、門の直前だけを保持して最初の tick で発火する。
    if (state.phase === 'defeat') {
      const hasNotice = false // 将来の「芝居の断片」通知実装はここへ接続する
      const deaths = state.campaign.deathsByBossId[state.boss.id] ?? 0
      const showDifficultyHint = defeatDifficultyHintVisible(state.settings.difficulty, deaths)
      const timeline = defeatOverlayTimeline(
        { deaths, showDifficultyHint, hasNotice },
        DEFEAT_OVERLAY_TIMING_SEC,
        defeatTimingScale,
      )
      const pressedNow = confirmPressed(input, ['attack', 'parry'])
      const nextElapsedSec = state.phaseElapsedSec + FIXED_DT
      if (pressedNow) consumeAdvancePresses()
      const insideEarlyInputWindow = state.phaseElapsedSec >= timeline.inputBufferOpenSec
      const buffered = insideEarlyInputWindow && (state.defeatRetryBuffered || pressedNow)
      if (buffered && nextElapsedSec >= timeline.gateSec) {
        if (state.solo) return restartSolo(state)
        return createInitialState(state.campaign)
      }
      return {
        ...state,
        defeatRetryBuffered: buffered,
        sfx: [],
        fx: ageFx(state.fx, state.time),
        shake: decayShake(state.shake),
        phaseElapsedSec: nextElapsedSec,
      }
    }

    // 勝利 / cleared の進行入力は従来どおり。パッド✕は即時、kbm は 0.6 秒後。
    const anyAdvance = confirmPressed(input, state.phaseElapsedSec >= 0.6 ? ['attack', 'parry'] : [])
    if (anyAdvance) {
      // 一戦だけモード (2026-07-28): 勝っても負けても、 行き先は「同じボスをもう一度」だけ。
      //   ここで止めないと victory が幕間ADVへ抜けて次のボスが出てしまう = リンクの約束が壊れる。
      if (state.solo) {
        consumeAdvancePresses()
        return restartSolo(state)
      }
      if (state.phase === 'victory') {
        // 勝利 → 幕間。 campaign はここで次ボスへ進めておく (boss は倒した役者のまま=幕間テキストの鍵)。
        //   進めた進行はその場で保存する (2026-07-26 欠陥D修正: 幕間を読んでいる間に閉じても
        //   撃破が保存されているように。 下書き印つきなら入口が自分で弾くので分岐不要)。
        consumeAdvancePresses()
        const campaign = advanceToNextBoss(state.campaign)
        saveCampaign(campaign) // GATE: victory-advance
        return {
          ...state, phase: 'interlude', phaseElapsedSec: 0,
          campaign,
          adv: startScene(getInterludeScene(state.boss.id)),
          sfx: [], fx: [], shake: decayShake(state.shake),
        }
      }
      if (state.phase === 'cleared') {
        // 最終ボス撃破の余韻画面 → 幕間 (その先で choice へ)
        consumeAdvancePresses()
        return {
          ...state, phase: 'interlude', phaseElapsedSec: 0,
          adv: startScene(getInterludeScene(state.boss.id)),
          sfx: [], fx: [], shake: decayShake(state.shake),
        }
      }
      // interlude / ending / defeat は各専用ブロックへ移動済み。ここには来ない。
    }
    // 勝敗画面: フェーズ経過を加算 (drawPhaseOverlay の「間→重く出現」演出に使う)
    return {
      ...state, sfx: [], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
      phaseElapsedSec: state.phaseElapsedSec + FIXED_DT,
    }
  }

  const now = state.time + FIXED_DT
  // 攻撃プール = 固定 baseAttackIds + 致命回数フェーズ解禁 (unlockByExecutes)。 旧継承は停止済 (Task1)。
  //   稽古モード (チュートリアル): 現在の稽古の1技だけを出題する。
  const bossDef = getBossDefinition(state.campaign.currentBossIndex)
  // 稽古の課題の表 (比較版 DEV ?tutFocus の時だけ並びが替わる・src/tut_focus.ts)。
  const tutorialLessons = tutorialLessonsFor(bossDef)
  // 「崩されて弾く」課題の間だけ、亡霊にも決め技を持たせる (src/exec_parry.ts)。課題の外・比較版の外では毎コマ外す。
  const lessonNow = currentLesson(state.tutorial, tutorialLessons)
  setTutorialFinisher(lessonNow?.finisherAttackId ? state.boss.id : null, lessonNow?.finisherAttackId)
  let attackPool = attackPoolForBoss(bossDef, state.boss.executesTaken)
  // 請われぬ介錯: 幕で解禁された骨格を、さらに現在の形態で絞る。幕1は刃固定。
  if (state.boss.exec) attackPool = executionerPool(state.boss.exec, state.boss.executesTaken)
  if (state.tutorial && tutorialLessons) {
    if (state.tutorial.lesson < tutorialLessons.length) {
      attackPool = [tutorialLessons[state.tutorial.lesson]!.attackId]
    } else {
      // 仕上げ (spec §2.4): 斬りだけ出し続ける。 パリィで削ってHPを削るほど体幹が実る経済をそのまま体験させる。
      attackPool = ['shadeSlash']
    }
  }
  if (debugSoloAttackId) attackPool = [debugSoloAttackId]   // dev 単独化 (稽古より優先・上記参照)

  // 突き当ての比較版 light (DEV ?jabFix=light): 千秋楽の時だけ重さを替える。指定なしでは何もしない。
  if (import.meta.env.DEV) syncJabFixDamage(getDifficulty())
  const player1 = updatePlayer(state.player, input, state.boss, now * 1000)
  // 振り音は命中結果ではなく、攻撃へ入った次tickに「まだ振る」と確定した時だけ鳴らす。
  // これなら振る前(<60ms)のパリィcancelでは鳴らず、完走時は接触まで3固定tick先行する。
  //   連撃を試す間 (DEV ?comboTrial=1) は溜めの長さが案ごとに違うので、当たりの窓の50ms前を跨いだ tick で鳴らす
  //   (配布版の1本の攻撃は窓60ms → 10ms = 従来どおり入った次tick)。
  const swingCueSec = Math.max(0, attackTimingOf(player1).activeStartMs - 50) / 1000
  const attackSwingSfx: SfxId[] = state.player.state === 'attacking'
    && player1.state === 'attacking'
    && player1.stateElapsed > state.player.stateElapsed
    && state.player.stateElapsed <= swingCueSec && swingCueSec < player1.stateElapsed
    ? [isHeavyComboStep(player1) ? 'attack_swing_heavy' : 'attack_swing'] : []
  // C-2検収の静止練習。主人公と描画は実際の更新を通し、ボスの行動だけ止める。
  const twinsSfx: SfxId[] = []
  const bossUpdate: ReturnType<typeof updateBoss> = import.meta.env.DEV && corePractice
    ? { boss: state.boss, enteredActive: false }
    // 鶏の「弾くほど加速」(src/rooster_rush.ts・配布版は案B): 遅れがあれば段の経過を先へ進める。
    // 千日手の軍配者たち (src/twins_fight.ts): 二人と装置はこの部品が動かし、boss は「いま斬れる所」の影になる。
    : twinsDriveThisTick(state.boss)
      ? { boss: twinsBossTick(state.boss, player1, now, twinsSfx), enteredActive: false }
      // 稽古では崩した連のやり直し (C・src/exec_bait.ts) をしない: 課題は1つの技を順に見せる段取りで、やり直すと次の課題とずれる。
      // 鶏の「焦り狂い」(配布版・src/rooster_frenzy.ts): 段で待機を詰め、連の頭で段に合わせて連を組み替える。
      : roosterFrenzyShape(state.boss, updateBoss(roosterFrenzyPreTick(roosterRushPreTick(state.tutorial && state.boss.stunEncore ? { ...state.boss, stunEncore: undefined } : state.boss)), player1, attackPool))
  // The base knight controller only names step/snap in its attack gate. Keep this
  // DEV proxy in idle if it selected a sweep on the same tick as an active glide.
  // 介錯が致命を弾かれたら、主人公の押し戻しと同じ時計で後ろへ下がる (10-21・src/exec_parried_slide.ts)。
  // 鶏の一戦の鬨ずらしの爪は、1発ごとに跳ぶ (時間で跳ぶ・src/rooster_claw_hop.ts)。
  const rawBoss1 = withRoosterClawHop(stepExecParriedSlide(bossUpdate.boss, player1))
  const boss1 = import.meta.env.DEV && rawBoss1.id === 'vigil-knight'
    && rawBoss1.state === 'telegraph' && rawBoss1.knightGait?.suri?.phase === 'glide'
    ? { ...state.boss, x: rawBoss1.x, facing: rawBoss1.facing,
      knightGait: rawBoss1.knightGait, stateElapsed: state.boss.stateElapsed + FIXED_DT }
    : rawBoss1
  if (import.meta.env.DEV) emitKnightSuriEvents(state.boss, boss1, now * 1000)
  // 歩きの床の砂 (既定 c = 寄せ足の擦り・10-01d・DEV `?knightStepDust=a|b|d` で比較・src/knight_step_dust.ts)。
  knightStepDust.emit(state.boss, boss1, now * 1000)
  knightFloorScrape.sync(state.boss, boss1, now * 1000)
  // 騎士の固有のとどめの壁ぎわの駆け抜け (10-12 K-4・src/exec_unique.ts): 背中側へ回られたら、崩れている主人公は騎士の方へ向き直る。
  const playerAfterBoss = execUniqueFaceStunned(bossUpdate.player ?? player1, boss1)

  const r1 = resolvePlayerAttack(playerAfterBoss, boss1, now)
  const rExec = resolveExecuteHit(r1.player, r1.boss, now)

  let player2 = rExec.player
  let boss2 = rExec.boss
  let sfx = [...attackSwingSfx, ...twinsSfx, ...r1.sfx, ...rExec.sfx]
  const fxFromCombat = [...r1.fx, ...rExec.fx]
  // 請われぬ介錯のステップは travel に入ったtickだけ鳴らす。風は前進だけに出す。
  const previousStep = state.boss.exec?.step ?? null
  const travelStep = boss1.exec?.step ?? null
  const enteredTravel = travelStep?.phase === 'travel' && previousStep?.phase !== 'travel'
  if (enteredTravel) {
    sfx.push(execBodySfx('step') ?? 'step')
  }
  if (enteredTravel && travelStep?.kind === 'forward') {
    const step = travelStep
    const deltaX = step.toX - step.fromX
    fxFromCombat.push({
      kind: 'step_gust',
      x: step.fromX,
      y: state.boss.y,
      t: now,
      dir: deltaX < 0 ? -1 : 1,
      lengthPx: Math.abs(deltaX),
      mode: step.style === 'shunpo' ? 'path' : 'behind',
    })
  }
  // 介錯の一歩の蹴り出し・着地の土煙 (描くだけ・前の版＝DEV ?stepWeight=now・src/exec_step_weight.ts)。
  fxFromCombat.push(...stepWeightDustFx(state.boss, boss1, now))
  // 騎士の踏み込み: 蹴り出しの砂埃と床の擦り跡 (描くだけ・2026-09-27 R-2)。
  fxFromCombat.push(...knightLungeDustFx(state.boss, boss1, now))
  // 騎士の固有の致命の突進 (10-12 から配布版・src/exec_unique.ts): 走り出し・一歩ごとの蹴り出し (壁ぎわの駆け抜けも)、当たって滑る擦り跡 (描くだけ)。
  fxFromCombat.push(...knightChargeDustFx(state.boss, boss1, now))
  // 致命を弾いて押されている間の足元の土煙 (DEV ?execPush=new・src/exec_parry.ts)。描くだけ。
  fxFromCombat.push(...execPushDustFx(state.player, player1, now))
  // 介錯が下がる時、体の後ろの刃先が床をこする擦り跡と土煙 (10-21・src/exec_parried_slide.ts)。描くだけ。
  fxFromCombat.push(...execParriedSlideDustFx(state.boss, boss1, player1, now))
  // 大きく押し飛ばされた時の足の滑りと土煙・滑る音 (前の版＝DEV ?knockSkid=now・src/exec_knock_skid.ts)。描くだけ。
  //   音は仮 (騎士のすり足の床の擦り)。本番の音は音の専用セッションへ頼む。
  fxFromCombat.push(...knockSkidFx(state.player, player1, now))
  // 両手で刺して引き抜く版 (配布版・指定なし): 青い光は刺す時でなく剣が抜ける瞬間に、配布版の刺す時と同じ光 (luna_crack) を出す (11-04 作者「前の致命で出ていた青い光」)。
  if (pullOutCrossed(state.player, player1)) {
    const w = execWoundPoint(player1, boss1)
    fxFromCombat.push({ kind: 'luna_crack', x: w.x + pullBossJoltPx(PULL.pullOutMs) * w.dir, y: w.y, t: now - lampExecLightLeadSec(), dir: w.dir })
  }
  // 介錯に押された時は介錯の音の滑る音 (10-29・src/exec_sound.ts)。off の時は前の仮の音。
  const execSkid = state.boss.id === 'the-executioner' ? execBodySfx('skid') : null
  if (execSkid) { if (knockSkidStarted(state.player, player1)) sfx.push(execSkid) } else knockSkidSound(state.player, player1)
  // 組み変わりの始まりと押しのけの瞬間の土煙・仮の音 (前の版＝DEV ?knockSkid=now・src/exec_knock_skid.ts)。描くだけ。
  const morphHitAt = (turn: boolean | null) => executionerMorphTiming({ morphTurnRequired: turn }).shoveHitAtMs
  fxFromCombat.push(...morphFx(state.boss, boss1, now, morphHitAt))
  // 組み変わりの音 (10-29・src/exec_sound.ts): 始まりに鉄の板が滑って噛み合う音、押しのけに小さい振りと一歩。
  //   前の仮の音は主人公の重い振り (attack_swing_heavy) で、ボスの音を下げる側に入っていた。off の時だけ前の音。
  const execMorph = execBodySfx('morph')
  if (execMorph && boss1.exec?.morph === 'morphing' && boss1.exec.morphElapsedMs > 0
    && (state.boss.exec?.morph !== 'morphing' || state.boss.exec.morphElapsedMs === 0)) sfx.push(execMorph)
  if (morphShoveStarted(state.boss, boss1, morphHitAt)) {
    if (execMorph) sfx.push(execActiveSfx('exec_maulJab')!, execBodySfx('step')!)
    else sfx.push('attack_swing_heavy', 'step')
  }
  const hitStopMs = Math.max(r1.hitStopMs, rExec.hitStopMs)
  let shakeFromCombat = pickStrongerShake(r1.shake, rExec.shake)

  // ボス → telegraph 遷移: 攻撃を「目撃」記録 + kind別予兆SE + 凍結ゾーンのスポーン
  let campaign = state.campaign
  let hits = state.hits
  if (twinsFightOn(boss1)) hits = [...hits, ...twinsTakeHits()]
  const enteredTelegraph = bossUpdate.boss.state === 'telegraph' && state.boss.state !== 'telegraph'
  if (enteredTelegraph) {
    const atk = bossUpdate.boss.currentAttack
    if (atk?.hazardSpawns) {
      // ゾーン座標はこの瞬間に固定 (spec §5.4: 回り込みで前後が裏返らない)。
      // chargeMs: 譜面の chargeOverrideMs 対策 (2026-09-03 第4便) = 実効の溜め時間を渡し、
      //   spawnZoneHits 側で hazardSpawns の telegraphMs をその差だけ補正する。
      hits = [...hits, ...spawnZoneHits(atk, {
        bossX: bossUpdate.boss.x, bossFacing: bossUpdate.boss.facing, playerX: player1.x,
        chargeMs: bossUpdate.boss.currentString?.beats[bossUpdate.boss.beatIndex]?.chargeOverrideMs ?? atk.chargeMs,
      })]
    }
    if (atk) {
      // 攻撃kindで予兆音を変える (耳でも判別できる)。
      //   亡霊(nameless-shade)限定: kind を問わず冷たい霊気の吐息(telegraph_ghost)に差し替え(チケットG3・獣の唸りは他ボス専用)。
      //   ?bossSfx=v1: 鶏・剣舞・軍配者たちの予告は下の bossSfxTellDue だけが鳴らす (体の予告は無音・10-30 作者の決まり)。
      if (bossSfxOwnsTell(state.boss.id)) { /* src/boss_sfx_v1.ts */ }
      else if (state.boss.id === 'nameless-shade') sfx.push('telegraph_ghost')
      // 花嫁 裾乱れ(veilFlurry) の看板 ため予告 = 教会の鐘4連(三全音不協和)。 ため初めに鳴らし、
      //   4連が鳴り終わって一泊 → たん の設計 (2026-07-10 ユーザー確定・素材1.5s < charge1600ms)。
      else if (state.boss.id === 'bride' && atk.id === 'veilFlurry') sfx.push('telegraph_bell')
      else if (state.boss.id === 'vigil-knight' && knightTellSfx(atk.id)) sfx.push(knightTellSfx(atk.id)!)
      else if (state.boss.id === 'dream-hound' && houndTellSfx(atk.id)) sfx.push(houndTellSfx(atk.id)!)
      else if (state.boss.id === 'the-executioner' && execTellSilent(atk.id)) { /* ?execSound=d|e: 担ぐ予告・地揺らしの溜め (e は刺突・払いの予告も) は音なし (10-30 作者) */ }
      else if (state.boss.id === 'the-executioner' && execTellSfx(atk.id)) sfx.push(execTellSfx(atk.id)!)
      else if (state.boss.id === 'crowned-king-awoken' && awokenTellSfx(atk.id)) sfx.push(awokenTellSfx(atk.id)!)
      // 鶏の鬨ずらし: 鳴き声そのものが予告 (声の拍＝爪の拍・src/rooster_toki.ts・仮の音 10-30)。
      else if (isRoosterFrenzyAttack(atk.id)) { /* 焦り狂いの段0・段1 の鳴きは下の roosterFrenzyTellSfx が鳴らす */ }
      else if (atk.id === 'tokiZurashiShort') sfx.push('rooster_crow_short')
      else if (atk.id === 'tokiZurashiLong') sfx.push('rooster_crow_long')
      // 床技4つ (騎士の石突・花嫁の茨・先代の照明と緞帳) の新しい予告。既定 = 新しい音、?floorTell=old で共通の whirr (src/floor_tell_sound.ts)。
      else if (floorTellSfx(atk.id)) sfx.push(floorTellSfx(atk.id)!)
      else if (atk.kind === 'physical') sfx.push('telegraph_growl')
      else if (atk.kind === 'projectile' || atk.kind === 'magic' || atk.kind === 'area') sfx.push('telegraph_whirr')
      else sfx.push('telegraph_start')
      // 花嫁の速い返しは、共通の物理予告を残したまま短い絹の張力音を重ねる。
      // ワープ分岐は reappear 側で一度だけ鳴らすため、ここでは二重発火させない。
      if (state.boss.id === 'bride' && atk.id === 'veilSweepLink'
        && state.boss.currentString?.id !== 'bride-blink-single') sfx.push('bride_veil_snap')
      // 騎士の短縮された連撃拍は、共通予告を残したまま槍金具の短い張力音を重ねる。
      // 初段/単発は従来音のまま。2拍目以降の薙ぎ・突きだけを耳でも識別できるようにする。
      if (bossUpdate.boss.id === 'vigil-knight'
        && (bossUpdate.boss.beatIndex ?? 0) > 0
        && (atk.id === 'lanceSweep' || atk.id === 'lanceThrust')) {
        sfx.push('knight_combo_tension')
      }
      // 裁定C: 弾けない攻撃は予兆で「危険」警告音も鳴らす (赤黒い呪いオーラと1セットの二重冗長)
      if (atk.unblockable) sfx.push('danger')
      campaign = markAttackSeen(campaign, state.boss.id, atk.id)
    } else {
      sfx.push('telegraph_start')
    }
  }
  // 据えの一打 → 据えの突きの切り替わり (予兆 → 予兆) は上の enteredTelegraph を通らないので、ここで危険音を1回鳴らす
  //   (2026-10-09 まで鳴っていなかった不具合・ユーザー「今の版でもすぐ鳴らす」・tests/exec_brace_thrust.test.ts)。
  //   v3 (10-09 採用・既定) は、ここで突きの絵も組み直す (危険音は同じ1回・二重に鳴らさない)。旧 (DEV ?braceThrust=old) は音だけ。
  if (braceThrustSwitched(state.boss, bossUpdate.boss)) {
    const v3Sfx = onBraceThrustSwitch(state.boss)
    sfx.push(...(v3Sfx.length > 0 ? v3Sfx : ['danger' as const]))
  }
  // active 突入 (連撃の各段含む): 腕砲は飛翔体、それ以外は従来のmeleeをスポーン。
  // 大暴れ第5案: 台本が数えた怨念をこのtickで出す (450msごと)。噛みつき4本は active 突入時にまとめて出す。
  const spiritBase = state.boss.choreo?.emitted ?? 0
  for (let i = 0; i < spiritsDue(state.boss, boss1); i++) hits = [...hits, ...spawnCue(boss1, player1, spiritBase + i)]
  // 採用済みの壁跳ね: 帰りを蹴り出した tick に、蹴った壁 (前tickの王) へ大暴れの怨念を3つ残す。
  if (wallHuntSpiritsDue(state.boss, boss1)) hits = [...hits, ...spawnWallHuntSpirits(state.boss, player1)]
  // 大暴れ第5案の光る合図: 赤 (弾けない床技) は危険音、白 (締めの噛み) は通常の予兆音。
  const glint = glintStarted(state.boss, boss1)
  if (glint) sfx.push(glint === 'red' ? 'danger' : 'telegraph_start')
  // 鶏の宙廻り (ラボ専用): 降りる直前に目が白く光る瞬間も通常の予兆音 (覚醒王の白いピカンと同じ扱い)。
  else if ((roosterGlintStarted(state.boss, boss1) || roosterDropGlintStarted(state.boss, boss1)) && !bossSfxOwnsTell(boss1.id)) sfx.push('telegraph_start')
  // 鶏の暁呼び (src/rooster_vertical.ts): 羽を狙う秒を越えた tick に、主人公の今の位置へ羽の帯を置く。
  for (const offsets of roosterFeathersDue(state.boss, boss1)) {
    hits = [...hits, ...spawnZoneHits(roosterFeatherAttack(offsets), { bossX: boss1.x, bossFacing: boss1.facing, playerX: player1.x })]
    sfx.push(bossSfxOn(boss1.id) ? 'bsfx_v1_rooster_feathers' : 'telegraph_whirr')
  }
  // ?bossSfx=v1: 鶏・剣舞の予告 (鬨・投げナイフ) を溜めの決まった拍で鳴らす (溜めに入った tick は前の拍 = -1)。
  if (boss1.state === 'telegraph' && boss1.currentAttack) {
    const sameTell = state.boss.state === 'telegraph' && state.boss.currentAttack?.id === boss1.currentAttack.id && !enteredTelegraph
    const tell = bossSfxTellDue(boss1.id, boss1.currentAttack.id, sameTell ? state.boss.stateElapsed * 1000 : -1, boss1.stateElapsed * 1000)
    if (tell) sfx.push(tell)
    // 焦り狂いの段0・段1 の鳴き (配布版): 短い鳴きは声ごとに「コッ」、長い鳴きは配布版と同じ音。
    sfx.push(...roosterFrenzyTellSfx(boss1.currentAttack.id, sameTell ? state.boss.stateElapsed * 1000 : -1, boss1.stateElapsed * 1000,
      bossSfxOn(boss1.id) ? 'bsfx_v1_rooster_tell_crow_long' : 'rooster_crow_long'))
  }
  if (bossUpdate.enteredActive && boss1.currentAttack?.choreography === 'awokenRampageV5') {
    hits = [...hits, ...spawnChoreoBites(boss1.currentAttack)]
  }
  // 大暴れ第5案: 体が壁・床に触れた瞬間の揺れ・粒・音 (09-21 総評「接触の痕跡がゼロ」)。判定には関わらない。
  //   音は既存の低い踏み音 (step) の再利用 (専用SEは作らない裁定のまま)。揺れは着く側だけ・叩きつけと雄叫びは大きく。
  for (const c of rampageContacts(state.boss, boss1)) {
    fxFromCombat.push({ kind: 'rampage_contact', variant: c.kind, x: c.x, y: c.y, t: now, dir: c.dir })
    const amp = RAMPAGE_CONTACT_SHAKE[c.kind]
    if (amp) {
      shakeFromCombat = pickStrongerShake(shakeFromCombat,
        { remainingSec: amp.sec, amplitude: amp.px, startAmplitude: amp.px, totalDur: amp.sec, startSec: now })
    }
    if (c.kind !== 'roar') sfx.push('step')
    else { const v = awokenRampageRoarSfx(); if (v) sfx.push(v) }
  }
  // 覚醒王の「灰を食む」(DEV ?awokenDevour・src/awoken_devour.ts): 見せの噛みが床を噛んだ瞬間に、口の前の床で灰が跳ね、
  //   低い踏み音が鳴り、画面が小さく揺れる (当たりは無い)。飛び込みの踏み切りでも後ろ足の床が鳴る (「今」の合図)。
  //   灰 = 大暴れの床の土煙 (rampage_contact) をそのまま使う。重い顎の専用音は無いので低い踏み音 (step) で代用。
  {
    const plan = boss1.state === 'telegraph' ? boss1.currentAttack?.devour : undefined
    if (plan) {
      const prevMs = state.boss.state === 'telegraph' && state.boss.currentAttack?.devour === plan ? state.boss.stateElapsed * 1000 : -1
      const nowMs = boss1.stateElapsed * 1000
      const dir = player1.x >= boss1.x ? 1 : -1
      for (const _k of awokenDevourClosesCrossed(plan, prevMs, nowMs)) {
        fxFromCombat.push({ kind: 'rampage_contact', variant: 'ground_land', x: boss1.x + dir * AWOKEN_DEVOUR_FLOOR_MOUTH_PX, y: boss1.y, t: now, dir })
        shakeFromCombat = pickStrongerShake(shakeFromCombat,
          { remainingSec: 0.12, amplitude: 2.5, startAmplitude: 2.5, totalDur: 0.12, startSec: now })
        sfx.push('step')
      }
      // ?awokenDevour=gladius (跳び噛み2回の版・src/awoken_devour_pounce.ts): 跳びの着地ごとに足が床を打つ音と小さな揺れ (当たりは無い)。
      //   顎を閉じる専用の音は無い (音のセッションへの依頼は docs/research/2026-10-09-awoken-devour-gladius-status.md)。
      for (const _k of awokenPounceLandsCrossed(plan, prevMs, nowMs)) {
        shakeFromCombat = pickStrongerShake(shakeFromCombat,
          { remainingSec: 0.08, amplitude: 1.5, startAmplitude: 1.5, totalDur: 0.08, startSec: now })
        sfx.push('step')
      }
      if (prevMs < plan.lungeStartMs && nowMs >= plan.lungeStartMs) {
        fxFromCombat.push({ kind: 'rampage_contact', variant: 'ground_kick', x: boss1.x - dir * 60, y: boss1.y, t: now, dir })
        sfx.push('step')
      }
    }
  }
  // 怨念が放たれた瞬間 (留まりが終わったtick) に、飛び道具の予兆音を鳴らす (総評 A-2「発射の瞬間に合図がない」)。
  if (hits.some(h => h.spirit && !h.spirit.wave && !h.reflected && h.launchDelayMs !== undefined
    && h.elapsedMs < h.launchDelayMs && h.elapsedMs + FIXED_DT * 1000 >= h.launchDelayMs)) sfx.push('telegraph_whirr')
  // 介錯の榴弾が床に落ちた瞬間 (予告の印が終わって当たりに入るコマ・10-29・src/exec_sound.ts)。3列が同じコマに落ちても1回。
  const execBlast = state.boss.id === 'the-executioner' ? execBodySfx('blast') : null
  if (execBlast && hits.some(h => h.attackId === 'exec_cannonMortar' && h.telegraphMs > 0
    && h.elapsedMs < h.telegraphMs && h.elapsedMs + FIXED_DT * 1000 >= h.telegraphMs)) sfx.push(execBlast)
  // 鶏の宙廻り ('roosterAerialRoam') は active から普通の近接に乗るので、ここで共通の近接ヒットを出す。
  if (bossUpdate.enteredActive && boss1.currentAttack && boss1.currentAttack.choreography !== 'awokenRampageV5') {
    const sweepWeight = getKnightSweepWeight()
    const sweepSound = boss1.id === 'vigil-knight'
      ? knightSweepSfx(boss1.currentAttack.id, boss1.beatIndex ?? 0, boss1.currentString?.beats.length ?? 1) : null
    if (sweepSound) sfx.push(sweepSound)
    const execActive = boss1.id === 'the-executioner' ? execActiveSfx(boss1.currentAttack.id) : null
    if (execActive) sfx.push(execActive)
    const v1Active = bossSfxActive(boss1.id, boss1.currentAttack.id, boss1.comboHitIndex, boss1.currentAttack.comboHits ?? 1)
    if (v1Active) sfx.push(v1Active)
    const houndRoarVoice = boss1.id === 'dream-hound' ? houndActiveSfx(boss1.currentAttack.id) : null
    if (houndRoarVoice) sfx.push(houndRoarVoice)
    const awokenRoarVoice = boss1.id === 'crowned-king-awoken' ? awokenActiveSfx(boss1.currentAttack.id) : null
    if (awokenRoarVoice) sfx.push(awokenRoarVoice)
    if (boss1.id === 'vigil-knight' && boss1.currentAttack.id === 'lanceSweep' && (sweepWeight === 'scrape' || sweepWeight === 'sound')) {
      if (!sweepSound) sfx.push('knight_sweep_scrape')
      const dir = boss1.facing === 'right' ? 1 : -1
      if (sweepWeight === 'scrape') fxFromCombat.push({ kind: 'knight_sweep_scrape', x: boss1.x + dir * 91, y: boss1.y, dir, t: now })
    }
    const projectileDef = boss1.currentAttack.castProjectile
    const projectile = spawnCastProjectile(
      boss1.currentAttack,
      boss1.comboHitIndex,
      boss1,
      {
        x: boss1.x,
        y: boss1.y - (projectileDef?.spawnOffsetY ?? BOSS.height / 2),
      },
    )
    if (projectile) hits = [...hits, projectile]
    if (boss1.id === 'crowned-king-awoken' && boss1.currentAttack.id === 'feralPocketSpin') sfx.push('step')
    const spawnedMelee = projectile ? null : spawnMeleeHit(boss1.currentAttack, boss1.comboHitIndex)
    // 切り下がりの当たりは 10-01 から騎士と一緒に動く (踏み込んで払う・跳び下がりの前に消える)。旧は跳び始めの位置に残していた。
    // hazardHitOncePerCast の技は、本体の一撃も同じ回の床の帯と束ねる (2026-10-02 AI点検
    //   「地割り1回で2発」＝叩きつけ 24＋床 14 が 0.1 秒差で両方入っていた)。帯は telegraph 突入で先に出ている。
    const castGroup = spawnedMelee && boss1.currentAttack.hazardHitOncePerCast
      ? latestCastGroup(hits, boss1.currentAttack.id) : undefined
    const melee = spawnedMelee && castGroup !== undefined ? { ...spawnedMelee, groupId: castGroup } : spawnedMelee
    // 請われぬ介錯: 形態倍率は技定義を書き換えず、発生時にだけ掛ける。
    if (melee && boss1.exec) {
      const m = mulsFor(boss1.exec)
      hits = [...hits, { ...melee,
        damage: Math.round(melee.damage * m.damageMul),
        postureDamage: Math.round(melee.postureDamage * m.postureMul) }]
    } else if (melee) hits = [...hits, melee]
    if (boss1.currentAttack.id === 'lanceCross') {
      const dir = boss1.facing === 'right' ? 1 : -1
      fxFromCombat.push({ kind: 'knight_leap_slash', x: boss1.x, y: boss1.y, t: now, dir, leapPx: boss1.knightLeapTotalPx ?? 180, lungePx: boss1.knightCrossLungePx ?? 0 })
    }
    // 振り下ろし 弧FX (2026-08-20): active 突入で刃先スメア＋足元の炸裂を出す。
    //   190ms に絵が2枚しかなく「振った軌跡が残らない」(ユーザー実機) ため。
    //   票 = docs/candidates/2026-08-20-executioner-downswing-arc-fx-ticket.md
    //   ⚠️ x は boss1.x ではなく lungeTargetX (active 突入時に確定済みの着地位置)。
    //     active 中に lungeDistance ぶん踏み込むため、開始位置に置くと当たる頃に弧が後ろへ置き去りになる。
    if (boss1.currentAttack.id === 'exec_maulDrop') {
      const dir = boss1.facing === 'right' ? 1 : -1
      fxFromCombat.push({ kind: 'downswing_arc', x: boss1.lungeTargetX, y: boss1.y - 50, t: now, dir, tone: 'steel' })
    }
    // 裾乱れ 各ヒットの布斬撃弧 (2026-07-10 V-5): 静止絵hold+スメア無しで「判定が無モーションで来る」
    //   問題の可視化 = 弧が危険。 hit7(フェイント=ノーダメの釣り)は出さない (止まった読みを壊さない)。
    //   hit8 は slam=true で縦の叩きつけ弧。
    if (boss1.currentAttack.id === 'veilFlurry' && boss1.comboHitIndex !== 7) {
      const dir = boss1.facing === 'right' ? 1 : -1
      fxFromCombat.push({ kind: 'veil_slash_arc', x: boss1.x, y: boss1.y - 50, t: now, dir,
        slam: boss1.comboHitIndex === 8,
        // hit0-6 = 回り込みアーク (hitIndex を回転角に使う)。 hit8 は slam=縦叩きつけ。
        spin: boss1.comboHitIndex <= 6 ? boss1.comboHitIndex : undefined })
    }
    // ワープ3撃派生: 裾乱れの既存銀弧を3方向へ1巡だけ再利用する。新規画像は足さない。
    if (boss1.currentAttack.id === 'veilBlinkTriple') {
      const dir = boss1.facing === 'right' ? 1 : -1
      fxFromCombat.push({
        kind: 'veil_slash_arc', x: boss1.x, y: boss1.y - 50, t: now, dir,
        spin: boss1.comboHitIndex,
      })
    }
    // 裾乱れ だん (hit8) = 床への叩きつけ。 命中に依らずボス側で「着地の揺れ」を出す
    //   (2026-07-10 ユーザー要望「最後の一撃で揺れる表現」)。 命中時は hits.ts の被弾シェイクと
    //   pickStrongerShake で強い方が残る。 settings.shakeOn は下流の mergeShake が尊重。 ⬜暫定 (amp/dur)。
    if (boss1.currentAttack.id === 'veilFlurry' && boss1.comboHitIndex === 8) {
      const slamShake: ScreenShake = {
        remainingSec: 0.36, amplitude: 14, startAmplitude: 14, totalDur: 0.36, startSec: now,
      }
      shakeFromCombat = pickStrongerShake(shakeFromCombat, slamShake)
    }
  }
  if (player1.state === 'stepping' && state.player.state !== 'stepping') {
    sfx.push('dodge')  // 回避(さっ)= ドッジ開始の whoosh。 見切り成立時は perfect_dodge が上に重なる
  }
  // 宵渡りの再出現: 音でも必ず知らせる (フェアネス鉄則・専用SEが入るまで whirr を借用)
  if (act2BlinkVisual(boss1)?.kind === 'reappear' && act2BlinkVisual(state.boss)?.kind !== 'reappear') sfx.push('telegraph_whirr')
  if (boss1.state === 'reappear' && state.boss.state !== 'reappear') {
    sfx.push('telegraph_whirr')
    if (boss1.id === 'bride' && boss1.currentString?.id === 'bride-blink-single') sfx.push('bride_veil_snap')
    if (boss1.id === 'bride' && boss1.currentString?.id === 'bride-blink-triple') sfx.push('bride_triple_chime')
  }
  // 致命に入った瞬間、ボスの床の攻撃・飛び道具を消す (2026-09-29 ユーザー「床と飛び道具も消す」)。
  //   致命中は当たらずに残り続け、致命明けの最初の tick に当たり得たため。弾き返した弾は主人公の弾なので残す。
  if (player2.state === 'executing' && state.player.state !== 'executing') {
    hits = hits.filter(h => h.reflected)
  }
  // 主人公が崩れて、王が大暴れ (壁走り) を打ち切って致命へ移った時 (src/stun_cut.ts) も、王の怨念 (弾・床波) を消す
  //   (下の「大暴れを崩したら消す」と同じ決まり)。残すと致命の 0.5 秒後に残った怨念が当たり、崩れ→致命→被弾と一続きに削られていた (10-12 シム)。
  if (stunCutOn() && boss1.currentAttack?.bossFinisher && !state.boss.currentAttack?.bossFinisher
    && (state.boss.currentAttack?.choreography || state.boss.wallHunt?.spirits)) {
    hits = hits.filter(h => !h.spirit || h.reflected)
  }
  // ヒット解決 (melee + 凍結ゾーン統合・spec 2026-06-11 hit-timeline)
  const dtMs = FIXED_DT * 1000
  const rH = updateHits(player2, boss2, hits, dtMs, now)
  player2 = rH.player
  boss2 = rH.boss
  hits = rH.hits
  sfx.push(...rH.sfx)
  // 騎士の固有のとどめ (突進) と弾かれた花嫁の音 (10-12・src/exec_unique_sound.ts)。弾かれた印は updateHits が立てるので、その後で数える。
  sfx.push(...execUniqueSfx(state.boss, boss2))
  // ?bossSfx=v1: 鶏・剣舞・軍配者たちの技が弾かれた音 (弾きの火花が持つ技の id から・src/boss_sfx_v1.ts)。
  {
    const spark = rH.fx.find(f => (f.kind === 'parry_spark' || f.kind === 'parry_down') && f.attackId)
    const parried = spark && 'attackId' in spark && spark.attackId ? bossSfxParried(boss2.id, spark.attackId) : null
    if (parried) sfx.push(parried)
  }
  // 大暴れを途中で崩したら、王の怨念 (弾・床波) を消す (09-21 ユーザー裁定「崩した瞬間に全部消す」)。
  //   崩した直後に残弾で被弾すると「止めてやった」が取り消されるため。弾き返した黄緑は主人公の弾なので残す。
  //   DEV 壁跳ね新版の帰りに残した怨念も同じ決まりに従う (蹴り出し〜隙の間に崩したら消す)。
  if (boss2.state === 'staggered' && state.boss.state !== 'staggered'
    && (state.boss.currentAttack?.choreography || state.boss.wallHunt?.spirits)) {
    hits = hits.filter(h => !h.spirit || h.reflected)
  }
  // 獣比較 (bodyModel=beast): 噛みが当たった/受けられた攻撃は空振りではない = 通り過ぎない。
  if ((beastBody(boss2) || boss2.id === 'crowned-king-awoken') && boss2.currentAttack && rH.sfx.some(id => id === 'hit_player' || id === 'guard_player' || id === 'parry')) {
    if (beastBody(boss2)) {
      const { whiffCarry: _carry, ...rest } = boss2
      boss2 = { ...rest, attackConnected: true }
    } else boss2 = { ...boss2, attackConnected: true }
    if (boss2.id === 'crowned-king-awoken') boss2 = { ...boss2, awokenSpinStreak: 0 }
  }
  fxFromCombat.push(...rH.fx)
  // 致命を弾ける仕組み (既定・旧は DEV ?execParry=off・src/exec_parry.ts) の合図: 致命の溜めに入った瞬間だけ一瞬止める。
  //   溜めの速さ (当たるまでの時間) は変えない＝押す時機の手がかりを壊さない (設計書 §2 の3)。
  //   覚醒王の「灰を食む」(DEV ?awokenDevour) は溜めの頭ではなく、本命の溜めの 200ms 目 (紫が灯る時) に止める。
  const devourPlan = boss1.state === 'telegraph' ? boss1.currentAttack?.devour : undefined
  //   騎士と花嫁の固有の致命 (DEV ?execUnique=1・src/exec_unique.ts) は溜めの頭ではなく、紫の止まりの入りで止める。
  const uniquePlan = boss1.state === 'telegraph' ? boss1.currentAttack?.uniqueExec : undefined
  //   剣舞の手拍子の致命 (src/blade_finisher_v2.ts・既定・前の版は DEV ?bladeFinisher=v1) は手拍子の後、V 字に開く所 (紫が灯る時) で止める。
  const clapPlan = boss1.state === 'telegraph' ? boss1.currentAttack?.bladeClap : undefined
  const clapPrevMs = clapPlan && state.boss.state === 'telegraph' && state.boss.currentAttack?.bladeClap === clapPlan ? state.boss.stateElapsed * 1000 : -1
  if (clapPlan) for (let i = bladeClapsCrossed(clapPlan, clapPrevMs, boss1.stateElapsed * 1000); i > 0; i--) sfx.push(bladeClapSfx())
  const finisherTelegraphStarted = execParryEnabled() && boss1.state === 'telegraph'
    && !!(boss1.currentAttack?.bossFinisher || boss1.currentAttack?.playerLethal)
    && (clapPlan
      ? bladeClapSignalCrossed(clapPlan, clapPrevMs, boss1.stateElapsed * 1000)
      : uniquePlan
      ? execUniqueSignalCrossed(uniquePlan,
        state.boss.state === 'telegraph' && state.boss.currentAttack?.uniqueExec === uniquePlan ? state.boss.stateElapsed * 1000 : -1,
        boss1.stateElapsed * 1000)
      : devourPlan
      ? awokenDevourSignalCrossed(devourPlan,
        state.boss.state === 'telegraph' && state.boss.currentAttack?.devour === devourPlan ? state.boss.stateElapsed * 1000 : -1,
        boss1.stateElapsed * 1000)
      : !(state.boss.state === 'telegraph' && state.boss.currentAttack?.id === boss1.currentAttack?.id))
  const hitStopMsAll = Math.max(hitStopMs, rH.hitStopMs, finisherTelegraphStarted ? EXEC_PARRY.signalFreezeMs : 0)
  shakeFromCombat = pickStrongerShake(shakeFromCombat, rH.shake)
  // 軍配者たちの3部屋目で、落ちてきた装置が床を割った揺れ (比較版 C・src/twins_fight.ts)。
  shakeFromCombat = pickStrongerShake(shakeFromCombat, takeTwinsRevealShake(now))

  // ジャスト検出: パリィ吸収の一次情報はパリィ火花 FX の isJust (hits.ts の parry_spark)。
  //   sfx 'parry' は just/通常を区別しないため、 このtickで生まれた rH.fx から拾う (main.ts の
  //   パリィ音強度検出と同じ手法)。 使い先は2つ = 戦績 (すぐ下) と稽古の課題判定 (updateTutorial)。
  const justParry = rH.fx.some((f) => f.kind === 'parry_spark' && f.isJust === true)

  // sfx から戦績を反映 (ジャストだけは sfx に出ないので別引数で渡す)
  campaign = applyCombatStats(campaign, state.boss.id, sfx, justParry)
  // 剣舞のアルレ版 (10-29 配布版の既定・?bladeArle=0 で外す): よく弾かれた連の後、待機へ戻る所で剣舞が拍手する (src/blade_dancer_clap.ts)。
  boss2 = applyBladeClap(state.boss, boss2, sfx)

  player2 = regenPlayerPosture(player2)
  boss2 = regenBossPosture(boss2)
  // 千日手の軍配者たち: 削りを二人 (装置) へ割り振り、崩れ・膝つき・致命への入りを整える。
  if (twinsFightOn(boss2)) { boss2 = twinsAfterHits(state.boss, boss2, player2, now, hits, staggerBoss, sfx); hits = twinsFilterHits(hits) }
  // 鶏の「弾くほど加速」(配布版は案B・DEV ?roosterRush=on で案A): 弾き・ひるみで遅れを足す。案A は遅れを体幹の欄へ映し、連の頭で崩す。
  if (boss2.roosterRush || boss2.id === 'inverted-jester') {
    const rush = roosterRushAfterHits(state.boss, boss2, sfx, r1.boss.hp < boss1.hp, staggerBoss)
    boss2 = rush.boss
    sfx.push(...rush.sfx)
    // 焦り狂い (配布版): 弾き・被弾を数え、連の終わりで段を動かす。段3 を弾き切ったら息切れ。
    const frenzy = roosterFrenzyAfterHits(state.boss, boss2, sfx)
    boss2 = frenzy.boss
    sfx.push(...frenzy.sfx)
  }

  // ===== 稽古モード進行 (チュートリアル・tutorialLessons を持つボスのみ) =====
  let tutorial = state.tutorial
  if (tutorial && tutorialLessons) {
    // 決め技を弾き損ねた回数 (比較版の「崩されて弾く」課題だけ・続けて外したらもう一度止めて見せる)。
    if (lessonNow?.goal === 'exec_parry') {
      const missed = sfx.includes('hit_player') && !!(boss1.currentAttack?.bossFinisher || boss2.currentAttack?.bossFinisher)
      if (missed) tutorial = { ...tutorial, execMisses: (tutorial.execMisses ?? 0) + 1 }
    }
    const execParried = rH.fx.some((f) => f.kind === 'parry_spark' && f.exec === true)
    // 続けて損ねた回数 (比較版 DEV ?tutFocus=3 だけ・それ以外は素通り)。課題が進む前の課題で数える。
    tutorial = tallyFocusOutcome(tutorial, lessonNow, tutorial.lesson >= tutorialLessons.length, {
      hitPlayer: sfx.includes('hit_player'), parried: sfx.includes('parry'), guarded: sfx.includes('guard_player'),
      dodged: sfx.includes('perfect_dodge'), countered: sfx.includes('counter_hit'),
      counterExpired: state.player.counterWindow > 0 && player2.counterWindow <= 0 && !sfx.includes('counter_hit'),
      bossStaggered: boss2.state === 'staggered' && state.boss.state !== 'staggered', execParried,
    })
    tutorial = updateTutorial(tutorial, tutorialLessons, {
      sfx,
      enteredTelegraph,
      returnedToIdle: boss1.state === 'idle' && state.boss.state === 'recovery',
      // 殴って崩した瞬間 (この直後に staggered→idle へ強制リセットされるため、 ここで拾わないと進行停止)
      bossStaggered: boss2.state === 'staggered',
      justParry,
      execParried,
      // 3段目が当たって体幹の戻りを止めた (combat.ts の posture_hold の印・DEV ?combo3rd=off の時だけ出ない)。
      postureHold: r1.fx.some((f) => f.kind === 'posture_hold'),
      // 補助案内 (続けて損ねてもう一度止めた場面) を受けた技の間は、成功に数えない (2026-10-12 ユーザー・src/tut_focus.ts isAssistedAttack)。
      assisted: isAssistedAttack(tutorial, state.boss),
    })
    // ① (DEV ?tut6 だけ): 抜けた課題の印が埋まった姿を一拍見せる (render.ts drawTutorialPrompts)。
    if (tutSix(1) && tutorial.lesson > (state.tutorial?.lesson ?? 0) && (state.tutorial?.lesson ?? 0) < tutorialLessons.length) {
      tutorial = { ...tutorial, cleared: { lesson: state.tutorial!.lesson, at: now } }
    }
    if (tutorial.lesson < tutorialLessons.length) {
      // 稽古中はボスを崩させない (致命は仕上げ専用)。 崩れても静かに立ち直らせる。
      //   (パリィ3回で体幹60が満ちる / HP床1で殴ると力尽きる、 の両ルートを封じる)
      if (boss2.state === 'staggered') {
        boss2 = { ...boss2, state: 'idle', stateElapsed: 0, posture: 0 }
        sfx = sfx.filter((id) => id !== 'stagger')
      }
      // 稽古の間は、相手の体幹のゲージを「赤く光る手前」で止める (2026-10-10 ユーザー答え shade-practice-break=A)。
      //   溜まりはするが満ちない = 赤も崩れも見ないまま、仕上げで初めて赤→崩れ→致命を見る (最後のカード「赤く光ったら、パリィで崩れる」と順番が合う)。
      //   赤く光る閾値は HUD と同じ定義 (boss_hud_view.ts breakReadyRatio・render.ts と同じ倍率) をそのまま使う。
      //   赤の手前から次のパリィ1回では満ちないので、上の「崩れても静かに立ち直らせる」は連続弾きの上乗せで届いた時の保険として残る。
      if (boss2.state !== 'staggered' && boss2.maxPosture > 0) {
        const redAt = breakReadyRatio(boss2, parryGainHpMul(boss2) * bossPostureGainMul(boss2)) * boss2.maxPosture
        const holdAt = Math.max(0, redAt - 0.01)
        if (boss2.posture > holdAt) boss2 = { ...boss2, posture: holdAt }
      }
      // ⑤ (DEV ?tut6 だけ): 壁際に追い込まれた主人公の前から、構えている亡霊が歩いて下がる (src/tut_six.ts)。
      //   亡霊自身の「遠ければ詰める」歩きを打ち消して下がるよう、歩きの2倍で動かす。
      if (tutSix(5) && boss2.state === 'idle') {
        const x = tutWallRoomX(boss2.x, player2.x, arenaBoundsFor(boss2.id), BOSS.walkSpeed * 2 * FIXED_DT)
        if (x !== boss2.x) boss2 = { ...boss2, x }
      }
    } else if (boss2.hp > 0 && boss2.state === 'staggered') {
      // 仕上げ (2026-07-05 リワーク・spec §2.4): 崩れは本物の経済 (hits.ts の isJust && posture>=max) に
      //   任せる。 崩れたら起き上がらせず保持する (staggerMs を消費させない)。
      // 🔴 2026-07-28: 旧実装は stateElapsed を **0 へ戻して**いた。 その結果
      //    drawStaggerSpotlight の立ち上がり (rise = 経過 / STAGGER_SPOT.inSec) が永久に 0 のままで、
      //    **稽古でだけ「舞台照明が絞られる = 致命が入る」合図が一度も出ていなかった**
      //    (友達が最初に触る場所なのに、そこだけ本編と違う絵になっていた)。
      //    そこで時計は普通に進め、**引き (fall) が始まる手前で頭打ちにする** = 立ち上がり切った
      //    明るさのまま保持する。 0 でも満了直前でもダメ (前者は点かない・後者は暗転が始まる)。
      const holdSec = BOSS.staggerMs / 1000 - STAGGER_SPOT.outSec
      boss2 = { ...boss2, stateElapsed: Math.min(boss2.stateElapsed, holdSec) }
    }
    // 次のカードが控えている間だけ「間」を進める。明けたら上のゲートがカードを出す。
    //   ここで戦闘を止めないのが肝 = 課題クリアの余韻 (閃光/ヒットストップ/構えに戻る) が見える。
    const cards = tipsCardsForBoss(state.boss.id)
    if (pendingTipsCardIndex(cards, tutorial.lesson, tutorial.cardCursor) >= 0
        && tutorial.cardHoldMs < TIPS_CARD_HOLD_MS) {
      tutorial = { ...tutorial, cardHoldMs: tutorial.cardHoldMs + FIXED_DT * 1000 }
    }
  }

  // 開発版 ?bladeOnly=quick：剣舞の速い連だけの練習では倒れない (src/blade_quick_mannequin.ts)。
  if (import.meta.env.DEV && boss2.maxPosture > 0) {
    boss2 = holdBladeQuickPracticeBoss(boss2, breakReadyRatio(boss2, parryGainHpMul(boss2) * bossPostureGainMul(boss2)) * boss2.maxPosture)
  }
  let phase: GameState['phase'] = 'playing'
  let finisher: GameState['finisher'] = state.finisher
  let deathBeat: GameState['deathBeat'] = state.deathBeat

  // 見切りの「効いた」は時間スロー (旧 Witch Time) でなく hitStop + 火花 + 音で出す。
  //   スローは人間の体感だと処理落ちに感じる & このゲームの静かな緊張の美学と逆 (撤去 2026-06-13)。
  //   例外 = ボスの致命を弾いた時だけ (2026-10-14 ユーザー答え「白黒で接点に寄ってスローにできない？」・src/exec_parry_slow_fx.ts):
  //   止め明けから押し返される動きを短くスローで見せる (止めの間・止めが入るコマは 1)。旧は DEV ?execParryFx=old。
  //   ゆっくりの間に攻撃・パリィ・回避を押したら、その場で普通の速さへ戻す (1014c)。このコマで生まれた弾き (fxFromCombat) は
  //   いま押したパリィそのものなので数えない = 前のコマまでの弾き (state.fx) だけを見る。
  if (execSlowCutPressed(input)) execSlowCutNow(state.fx, state.time)
  let timeScale = execSlowTimeScale([...state.fx, ...fxFromCombat], now, hitStopMsAll)
  if (player2.hp <= 0) {
    // 即 defeat にせず「死の一拍」へ。 ボスの決まり手を演じきってから YOU DIED (Codex)。
    //   死亡記録/保存は death beat 完了時 (上の early block) で行う = 二重記録回避。
    //   execution = 処刑(playerLethal または bossFinisher)で殺されたか。 render が処刑シネマティックを出す/スロー深掘り。
    deathBeat = {
      elapsedMs: 0, motionDoneAtMs: null,
      execution: !!(boss2.currentAttack?.playerLethal || boss2.currentAttack?.bossFinisher),
      // 死因 (P4): 致命ヒットの attackId 優先、 無ければ現攻撃の label にフォールバック。
      causeLabel: rH.killedByAttackId
        ? getAttackLabel(rH.killedByAttackId)
        : boss2.currentAttack?.label,
      // 死因カテゴリ (チケットB'): defeat 画面の心得一行の判定に使う attackId。 技名は出さない。
      causeAttackId: rH.killedByAttackId,
    }
    hits = []  // 死の一拍中に死体へ再ヒットしない
    timeScale = 1
  } else if (boss2.hp <= 0 && rExec.lethal) {
    finisher = { elapsedMs: 0, bossX: boss2.x, bossY: boss2.y }
    hits = []  // トドメ演出中はヒットを消す
  } else if (boss2.hp <= 0) {
    campaign = onBossDefeat(campaign, state.boss.id, now)
    // 一戦だけモード: 上の finisher 経路と同じ理由で 'cleared' へ行かせない。
    phase = (!state.solo && isFinalBossIndex(state.campaign.currentBossIndex)) ? 'cleared' : 'victory'
    hits = []  // 撃破遷移後に飛行中の travel 弾や床ハザードを勝敗画面へ残さない
    saveCampaign(campaign) // GATE: boss-defeat-instant
    recordClearedEver(campaign, state.boss.id)
  } else if (sfx.length > 0 && sfx.some(isStatEvent)) {
    // 戦績更新時もこまめに永続化
    saveCampaign(campaign) // GATE: stat-event
  }

  // 設定: 画面揺れOFFの場合は新規シェイクを無視し既存を減衰させるだけ
  const effectiveShake = state.settings.shakeOn ? shakeFromCombat : null
  const nextShake = effectiveShake
    ? mergeShake(state.shake, effectiveShake)
    : decayShake(state.shake)

  // スプライト状態 (crossfade用) を更新。通常攻撃の接触意味はcombat結果から直接渡し、
  // SFX名から浅い/深い/受けを逆算しない。
  const parryJustHappened = sfx.includes('parry')
  let bossSprite = updateBossSpriteRuntime(state.bossSprite, boss2, parryJustHappened, r1.playerAttackContact, FIXED_DT)
  // phase≠playing では更新タイマーが凍結するため、接触リアクションを勝敗画面へ持ち越さない。
  if (phase !== 'playing') {
    bossSprite = { ...bossSprite, shallowHitReactRemainingSec: 0, deepHitReactRemainingSec: 0, playerHitReactionDir: 0 }
  }

  return {
    ...state,
    phase,
    phaseElapsedSec: 0,   // playing 中 or 遷移した瞬間=0。 以降は非playingブロックで加算
    time: now,
    player: player2,
    boss: boss2,
    campaign,
    sfx,
    fx: ageFx([...state.fx, ...fxFromCombat], now),
    hitStopRemaining: hitStopMsAll > 0 ? hitStopMsAll / 1000 : 0,
    shake: nextShake,
    bossSprite,
    finisher,
    deathBeat,
    timeScale,
    hits,
    tutorial,
  }
}

// ===== 稽古モード (チュートリアル) の進行判定 =====
// 成功条件は課題の goal 明示で判定する (2026-07-05 リワーク・攻撃defからの二重導出は廃止):
//   - parry      → 通常パリィ成功 ('parry' sfx。 ジャストも通常も鳴るので just_parry とは別扱い)
//   - just_parry → ジャストパリィ成功 (justParry イベント。 通常パリィの 'parry' sfx だけでは増えない)
//   - guard      → 長押しガードで弾ける近接を受ける ('guard_player' = hits.ts の guarding && parryable && follow==='boss')
//   - counter    → 躱して反撃を当てる ('counter_hit' = 回避→反撃の完走)
//   - zone_evade → 攻撃1サイクル (telegraph→idle) を無傷で凌ぐ
// lesson.count (省略時 TUTORIAL.successesPerLesson) 回成功で次の稽古へ。 失敗 (被弾) でカウントは減らない (優しい教室)。
export type TutorialEvents = {
  sfx: SfxId[]
  enteredTelegraph: boolean
  returnedToIdle: boolean
  // ゾーン稽古の進行不能バグ修正 (2026-06-13): ボスを殴って崩すと game.ts が staggered→idle へ
  //   強制リセットし、 recovery→idle の自然遷移 (returnedToIdle) が消えて soft-lock していた。
  //   崩した瞬間も「サイクルを (無傷で) 凌いだ」とみなして進行させるためのシグナル。
  bossStaggered: boolean
  // ジャストパリィ成立 (2026-07-05 追加): parry_spark FX の isJust から検出 (game.ts 側で配線)。
  justParry: boolean
  // ボスの決め技 (致命) を崩れ中のパリィで弾いた (parry_spark の exec 印・比較版 DEV ?tutFocus の課題 exec_parry だけが使う)。
  execParried?: boolean
  // 連撃の3段目が当たって、相手の体幹の戻りを止めた (combat.ts の posture_hold の印・課題 combo3 だけが使う)。
  postureHold?: boolean
  // 補助案内を受けた技の間か (true の間の成功は数えない・サイクルの印 cycleClean は普通に進める)。
  assisted?: boolean
}
export function updateTutorial(
  tut: TutorialState, lessons: TutorialLesson[], ev: TutorialEvents,
): TutorialState {
  if (tut.lesson >= lessons.length) return tut
  const lesson = lessons[tut.lesson]!
  let successes = tut.successes
  let cycleClean = tut.cycleClean
  if (ev.enteredTelegraph) cycleClean = true
  if (ev.sfx.includes('hit_player')) cycleClean = false
  // 補助案内を受けた技の成功は数えない (10-12 ユーザー)。数える所は全部この1つの足し算を通す = 課題の種類が増えても漏れない。
  const credit = ev.assisted ? 0 : 1
  if (lesson.goal === 'parry') {
    if (ev.sfx.includes('parry')) successes += credit
  } else if (lesson.goal === 'just_parry') {
    if (ev.justParry) successes += credit
  } else if (lesson.goal === 'guard') {
    if (ev.sfx.includes('guard_player')) successes += credit
  } else if (lesson.goal === 'exec_parry') {
    if (ev.execParried) successes += credit
  } else if (lesson.goal === 'combo3') {
    if (ev.postureHold) successes += credit
  } else if (lesson.goal === 'zone_evade') {
    // サイクル完了 = 自然な recovery→idle、 または 殴って崩した瞬間 (どちらも無傷=cycleClean が前提)。
    //   後者を足さないと「ゾーン攻撃を殴ると進行停止」(staggered→idle 強制リセットで recovery→idle が消える)。
    if ((ev.returnedToIdle || ev.bossStaggered) && cycleClean) {
      successes += credit
      cycleClean = false
    }
  } else {
    // 'counter'
    if (ev.sfx.includes('counter_hit')) successes += credit
  }
  const needed = lesson.count ?? TUTORIAL.successesPerLesson
  if (successes >= needed) {
    // ⚠️ spread 必須: cardCursor (TIPSカード進行) を落とさない。
    //   cardHoldMs = 0 にリセット = クリアの余韻を見せてから次のカードを出す (即出しはバグに見える)。
    return { ...tut, lesson: tut.lesson + 1, successes: 0, cycleClean: false, cardEnterMs: 0, cardHoldMs: 0 }
  }
  return { ...tut, successes, cycleClean }
}

// sfxイベントから戦績を加算。
//   justParry だけは sfx に現れない (通常パリィと同じ 'parry' が鳴る) ので、 呼び出し側が
//   parry_spark FX から判定した真偽値を渡す。 ジャスト1回 = parrySuccess +1 かつ justParry +1。
function applyCombatStats(c: CampaignState, bossId: string, sfx: SfxId[], justParry: boolean): CampaignState {
  let next = c
  for (const id of sfx) {
    if (id === 'parry') next = recordParrySuccess(next, bossId)
    else if (id === 'hit_player') next = recordParryFail(next, bossId)
    else if (id === 'perfect_dodge') next = recordDodge(next, bossId)
    else if (id === 'counter_hit') next = recordCounter(next, bossId)
    else if (id === 'guard_player') next = recordGuard(next, bossId)
  }
  if (justParry) next = recordJustParry(next, bossId)
  return next
}

function isStatEvent(id: SfxId): boolean {
  return id === 'parry' || id === 'hit_player' || id === 'perfect_dodge' || id === 'counter_hit'
    || id === 'guard_player'
}

function ageFx(fx: FxEvent[], now: number): FxEvent[] {
  // 弾き崩し・受けたの光 (2026-10-05 作り直し) は尾と砂が 0.5 秒より長いので、この2種だけ長く残す。
  //   致命を弾いた光の長い残り (exec_parry_glow・DEV ?execPush) は約0.7秒 (SEKIRO の動画の測定)。
  //   連撃3段目の比較版 (DEV だけ出る・src/player_combo3_power.ts): 帯の白い残りは一拍＋縮む間、体幹の止まりの印は止める秒だけ残す。
  //   幕の灯の消え (lamp_snuff) は玉の消え (1.6 秒) と体力の満ち (1 秒) を見せる間だけ残す (src/hud_v2.ts lampSnuffLifeSec)。
  return fx.filter((f) => now - f.t < (f.kind === 'parry_break' || f.kind === 'player_guard_impact'
    ? PARRY_FAMILY_FX_LIFE_SEC : f.kind === 'exec_parry_glow' ? EXEC_PARRY_GLOW.endMs / 1000
      : f.kind === 'heavy_bar_ghost' ? HEAVY_BAR_GHOST.holdSec + HEAVY_BAR_GHOST.drainSec
        : f.kind === 'posture_hold' ? f.sec + 0.1 : f.kind === 'luna_exec' ? execFxLifeSec() : f.kind === 'luna_crack' ? lunaNormalFxLifeSec(CRACK.lifeSec)
          : f.kind === 'parry_spark' && !f.exec ? tehonSparkFxLifeSec() : f.kind === 'lamp_snuff' ? lampSnuffLifeSec() : FX_LIFETIME_SEC))
}

function decayShake(s: ScreenShake): ScreenShake {
  if (s.remainingSec <= 0) return noShake()
  const remaining = Math.max(0, s.remainingSec - FIXED_DT)
  const ratio = s.totalDur > 0 ? remaining / s.totalDur : 0
  return {
    ...s,
    remainingSec: remaining,
    amplitude: s.startAmplitude * ratio * ratio,
  }
}

function pickStrongerShake(...shakes: (ScreenShake | null)[]): ScreenShake | null {
  let best: ScreenShake | null = null
  for (const s of shakes) {
    if (!s) continue
    if (!best || s.startAmplitude > best.startAmplitude) best = s
  }
  return best
}

function mergeShake(curr: ScreenShake, incoming: ScreenShake): ScreenShake {
  if (incoming.startAmplitude >= curr.amplitude) return incoming
  return curr
}

// メニューのカーソル方向を「画面の並びと同じ軸」だけから読む (2026-07-25 第1段-b)。
//   縦に並んだメニューは縦キーだけ / 横に並んだ選択肢は横キーだけで動かす。
//   見た目の並びと動かす方向がズレていると操作感が壊れる (ユーザー指摘)。
type MenuAxis = 'vertical' | 'horizontal'
function menuAxisDir(input: Input, axis: MenuAxis): -1 | 0 | 1 {
  const v = axis === 'vertical' ? (input.moveY ?? 0) : input.moveX
  return v < 0 ? -1 : v > 0 ? 1 : 0
}
function menuAxisEdge(input: Input, axis: MenuAxis): -1 | 0 | 1 {
  return (axis === 'vertical' ? input.navEdgeY : input.navEdgeX) ?? 0
}

// 「決定/進む」入力。パッドは✕(retry)のみ (2026-07-24 ユーザー裁定「✕以外で決定できるのは誤操作」)。
//   kbmはR/Enter(retry)を見ず、左クリック等 extraKbm のみで決定する (2026-07-26 ユーザー裁定
//   「決定はkbm=左クリック/パッド=✕に揃える」)。ADV専用の advDecidePressed と同じ形。
function confirmPressed(input: Input, extraKbm: InputAction[]): boolean {
  if (input.device === 'pad') return input.pressed.has('retry')
  return extraKbm.some((a) => input.pressed.has(a))
}

// 「戻る/閉じる」入力。 パッド=○(step) / kbm=Esc(pause) のみ。
//   ✕(retry) は決定専用なのでここには入れない (2026-07-24 の✕統一と対称・2026-07-25 新設)。
//   ⚠️ kbm の右クリック(step)は 2026-07-25 ユーザー実機裁定で撤去した
//   (「画面に書いていないし、その機能はいらない」)。 画面に出していない隠し操作を作らない、が理由。
//   パッドの ○ は画面に「{step} で閉じる」と明示しているので残す。
//   ⚠️ 呼び出しは state.paused===true か state.phase==='title' の枝の中だけに限る。
//   戦闘中 (playing かつ !paused) から呼ぶと ○=回避 と衝突する。
function cancelPressed(input: Input): boolean {
  if (input.device === 'pad') return input.pressed.has('step')
  return input.pressed.has('pause')
}

// ホバー中の項目へカーソルを移す (2026-07-25 第2段)。 マウスがたまたま項目の上に
//   置かれているだけでキーボード操作が巻き戻らないよう、 実際に動いた tick でだけ拾う。
function applyPointerHover(input: Input, rects: ReturnType<typeof titleMenuRects>, idx: number): number {
  if (!input.pointer?.moved) return idx
  const hit = hitIndex(rects, input.pointer.x, input.pointer.y)
  return hit >= 0 ? hit : idx
}

// メニューのカーソル音 (2026-07-25 第3段)。
//   「入力があったか」ではなく「index が実際に動いたか」で鳴らす。 これで
//     ・キー / パッド / マウスのホバー を1本の条件にまとめられる
//     ・端で止まる並び (終幕の二択) で、 押しても動かない時に空鳴りしない
//   になる。 押しっぱなしの自動リピートは index が毎回動くので1つずつ鳴る。
function menuMoveSfx(before: number, after: number): SfxId[] {
  return before === after ? [] : ['ui_move']
}

// タイトルから「幕を選ぶ」(難易度選択) を開く。 続きから・最初から・確かめの「始める」の3か所が通る。
//   newGame=true は「幕を決めた時に周回層を消す」印を立てるだけ (この時点では何も消さない・2026-10-19)。
//   千秋楽の印は開く時に読み直す (終幕を通した直後でも、 DEV で切り替えた直後でも合う)。
function openDifficultyPanel(state: GameState, input: Input, newGame: boolean): GameState {
  consumeNav()
  const senshurakuOpen = isSenshurakuOpen()
  return {
    ...state, pausePanel: 'difficulty', titleNewGame: newGame, senshurakuOpen,
    difficultyIndex: state.settings.difficulty === 'senshuraku' && senshurakuOpen ? 0 : 1,
    menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false },
    sfx: ['ui_confirm'], fx: ageFx(state.fx, state.time), shake: decayShake(state.shake),
  }
}

// 左クリックが押された位置の項目 index (無ければ -1)。
function pointerClickHit(input: Input, rects: ReturnType<typeof titleMenuRects>): number {
  return input.pointerPress ? hitIndex(rects, input.pointerPress.x, input.pointerPress.y) : -1
}

// 「クリックした位置と関係なく決定される」誤爆を塞ぐ門番 (2026-07-25 第2段)。
//   このtickに左クリックが無かった (pointerPress 無し) 画面は素通し (キーボード/パッドの決定に影響しない)。
//   左クリックがあった場合、 それが項目の中 (clickHit>=0) なら許可。 項目の外だった場合、
//   同tickに retry(パッド✕のみ) や parry(kbm) など「クリック以外の決定入力」も来ていれば
//   そちらの正当な決定を巻き込まないよう許可する。 残る「クリックだけ・項目の外」だけを拒む。
function confirmAllowedByPointer(input: Input, clickHit: number): boolean {
  if (!input.pointerPress) return true
  if (clickHit >= 0) return true
  // retry(✕) はパッドの決定入力のときだけ通す (2026-07-26: kbmのretryはもう決定に使わないため、
  // kbm側でこの例外を残す意味が無い)。
  if (input.device === 'pad' && input.pressed.has('retry')) return true
  if (input.device !== 'pad' && input.pressed.has('parry')) return true
  return false
}

// ADV(幕間/戦闘前/終幕)専用の「進む/決定」判定。2026-07-24 ユーザー裁定:
//   kbmはクリック(等)で進む。Rキー(retry)はADVの進行・選択確定には使わない
//   (パッドは従来どおり✕(retry)のみ・変更なし)。guardPassed=false の間 kbm も無効なのは
//   従来と同じ (直前画面のクリック残留が誤発火しないように)。
//   ※早送り(skip)は advSkipHeld で判定 (pad=✕長押し / kbm=クリック長押し・下記)。
function advDecidePressed(input: Input, extraKbm: InputAction[], guardPassed: boolean): boolean {
  if (input.device === 'pad') return input.pressed.has('retry')
  return guardPassed && extraKbm.some((a) => input.pressed.has(a))
}

// ADV早送り(skip)の hold 判定。2026-07-24 ユーザー裁定の続き:
//   進行(advDecidePressed)と同じ入力面に早送りを揃える。pad=✕(retry)長押し / kbm=クリック(attack)長押し。
//   これで kbm から Rキーが ADV(進行・早送りとも)から完全に消え、「Rタップは無反応なのにR長押しは効く」
//   という非対称な隠し挙動が解消する (pad の ✕ tap=1行送り / ✕ hold=早送り と対称)。
//   ※holdMs は全 InputAction を毎フレーム加算・離すと0リセット済み (input.ts) なので holdMs.attack で
//     左クリック長押し時間をそのまま測れる (配線追加は不要)。
function advSkipHeld(input: Input): boolean {
  const key: InputAction = input.device === 'pad' ? 'retry' : 'attack'
  return (input.holdMs?.[key] ?? 0) >= 600
}

// ===== 幕間メニュー =====
// メイン項目 (pauseIndex 0-4):
//   0: 幕へ戻る / 1: 常夜燈の稽古 / 2: 幕間の記録 / 3: 音と揺れ / 4: タイトルへ戻る
//   一戦だけモード (2026-07-28) は 1=はじめから に差し替え・4 は無し (menu_layout の pauseMainItems)。
// 所作の記録 = キー設定の表 (2026-10-31 作者「キー設定はブラウザ版に先に」「コントローラーも対応して」)。
//   kbm: 欄をクリック → 次に押したキー/マウスのボタンを割り当てる (Esc でやめる)。
//   パッド: 上下で行を選び ✕ → 次に押したボタンを割り当てる (OPTIONS でやめる)。 ○/Esc で閉じる。
//   受付そのもの (キーを読む・入れ替え・保存) は input.ts。 ここは「どの欄を受け付けるか」だけを決める。
// クレジットの画面 (タイトルから)。 文を送るだけで、 選ぶ物は「閉じる」1つ。
const STEAM_BUILD = import.meta.env.MODE === 'steam'
function handleCreditsPanel(base: GameState, input: Input): GameState {
  const consumeAll = (): void => { consume('attack'); consume('parry'); consume('retry'); consume('step'); consume('pause') }
  const close = (): GameState => { consumeAll(); return { ...base, pausePanel: null, creditsScroll: 0, menuNav: MENU_NAV_INITIAL, sfx: ['ui_cancel'] } }
  if (cancelPressed(input)) return close()
  const nav = stepMenuNav(base.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
  const maxScroll = creditsMaxScroll(creditLines(STEAM_BUILD))
  const step = nav.move * CREDITS_PANEL.scrollStep + (input.wheelY ?? 0) * CREDITS_PANEL.scrollStep
  const creditsScroll = Math.max(0, Math.min(maxScroll, (base.creditsScroll ?? 0) + step))
  if (confirmPressed(input, ['attack'])) {
    const p = input.pointerPress
    if (input.device === 'pad' || !p) return close()
    const r = creditsCloseRect(ARENA.width)
    const onClose = p.x >= r.x && p.x <= r.x + r.w && p.y >= r.y && p.y <= r.y + r.h
    const px = creditsPanelX(ARENA.width)
    const inside = p.x >= px && p.x <= px + CREDITS_PANEL.w && p.y >= CREDITS_PANEL.y && p.y <= CREDITS_PANEL.y + CREDITS_PANEL.h
    if (onClose || !inside) return close()
    consumeAll()
  }
  return { ...base, creditsScroll, menuNav: nav.next }
}

function handleControlsPanel(base: GameState, input: Input, close: () => GameState): GameState {
  const consumeAll = (): void => { consume('attack'); consume('parry'); consume('retry'); consume('step'); consume('pause') }
  if (keyCaptureView()) {
    consumeAll()
    return { ...base, controlsCapturing: true }
  }
  if (base.controlsCapturing) {
    // 受付が終わった (割り当てた・やめた) tick。 その押しは表の操作に使わない。
    consumeAll()
    return { ...base, controlsCapturing: false, sfx: ['ui_confirm'] }
  }
  const closeNow = (): GameState => { cancelKeyCapture(); consumeAll(); return close() }
  const cur = base.controlsIndex ?? 0
  const nav = stepMenuNav(base.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
  let idx = moveCursor(cur, nav.move, CONTROLS_ITEM_COUNT, true)
  idx = applyPointerHover(input, controlsItemRects(), idx)
  const moveSfx = menuMoveSfx(cur, idx)
  const next = { ...base, controlsIndex: idx, menuNav: nav.next }
  if (cancelPressed(input)) return closeNow()
  const startCapture = (row: number, kind: 'kbm' | 'pad'): GameState => {
    const r = CONTROLS_ROWS[row]!
    if (kind === 'kbm') beginKeyCapture({ kind: 'kbm', action: r.kbm })
    else if (r.pad) beginKeyCapture({ kind: 'pad', action: r.pad })
    else return next
    consumeAll()
    return { ...next, controlsIndex: row, controlsCapturing: true, sfx: ['ui_confirm'] }
  }
  const resetAll = (): GameState => {
    setKeyBindings(DEFAULT_KEY_BINDINGS)
    consumeAll()
    return { ...next, sfx: ['ui_confirm'] }
  }
  if (input.device !== 'pad' && input.pointerPress && input.pressed.has('attack')) {
    consume('attack')
    const hit = controlsHitAt(input.pointerPress.x, input.pointerPress.y)
    if (hit?.kind === 'cell') return startCapture(hit.row, hit.col)
    if (hit?.kind === 'reset') return resetAll()
    if (hit?.kind === 'close') return closeNow()
    // 表の外のクリック = 閉じる (前の「どこでもクリックで閉じる」の名残を表の外にだけ残す)。
    if (!controlsInsidePanel(input.pointerPress.x, input.pointerPress.y)) return closeNow()
    return { ...next, sfx: moveSfx }
  }
  if (input.device === 'pad' && input.pressed.has('retry')) {
    consume('retry')
    if (idx < CONTROLS_ROWS.length) return startCapture(idx, 'pad')
    if (idx === CONTROLS_RESET_INDEX) return resetAll()
    if (idx === CONTROLS_CLOSE_INDEX) return closeNow()
  }
  return { ...next, sfx: moveSfx }
}

// サブパネル (pausePanel):
//   'records': 所作の記録 (操作一覧) / 'settings': 音と揺れトグル
const PAUSE_SETTINGS_COUNT = 3

function handlePauseMenu(state: GameState, input: Input): GameState {
  const base = {
    ...state,
    sfx: [] as typeof state.sfx,
    fx: ageFx(state.fx, state.time),
    shake: decayShake(state.shake),
  }

  // 設定サブパネル
  if (state.pausePanel === 'settings') {
    const settingsRects = pauseSettingsRects()
    const nav = stepMenuNav(state.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
    let idx = moveCursor(state.pauseIndex, nav.move, PAUSE_SETTINGS_COUNT, true)
    idx = applyPointerHover(input, settingsRects, idx)
    const settingsClickHit = pointerClickHit(input, settingsRects)
    if (settingsClickHit >= 0) idx = settingsClickHit
    const moveSfx = menuMoveSfx(state.pauseIndex, idx)
    // 戻る (○/Esc): 1段戻って幕間メインへ (2026-07-25: Escape専用→cancelPressed共通化)
    if (cancelPressed(input)) {
      consume('step'); if (input.device !== 'pad') consume('pause')
      return { ...base, pausePanel: null, pauseIndex: 3, menuNav: nav.next, sfx: ['ui_cancel'] }
    }
    // トグル (2026-07-26 ユーザー裁定: メニューの決定はkbm=左クリックのみ)
    if (confirmPressed(input, ['attack'])) {
      if (!confirmAllowedByPointer(input, settingsClickHit)) {
        consume('retry'); consume('attack'); consume('parry')
        return { ...base, pauseIndex: idx, menuNav: nav.next }
      }
      consume('retry'); consume('attack'); consume('parry')
      let s = state.settings
      if (idx === 0) s = { ...s, bgmOn: !s.bgmOn }
      else if (idx === 1) s = { ...s, seOn: !s.seOn }
      else if (idx === 2) s = { ...s, shakeOn: !s.shakeOn }
      saveSettings(s) // 起動をまたいで保持 (localStorage)
      // ⚠️ SEを切った tick は main.ts が seOn=false を見て再生を止める = 無音になる (仕様として許容・票 §4)。
      return { ...base, pauseIndex: idx, settings: s, menuNav: nav.next, sfx: ['ui_confirm'] }
    }
    return { ...base, pauseIndex: idx, menuNav: nav.next, sfx: moveSfx }
  }

  // 所作の記録サブパネル = キー設定の表 (2026-10-31・handleControlsPanel)。
  if (state.pausePanel === 'records') {
    return handleControlsPanel(base, input, () => ({ ...base, pausePanel: null, pauseIndex: 2, menuNav: MENU_NAV_INITIAL, sfx: ['ui_cancel'] }))
  }

  // メインメニューナビゲーション
  const pauseItemCount = pauseMainItems(state.solo).length
  const pauseRects = pauseMainRects(pauseItemCount)
  const nav = stepMenuNav(state.menuNav, menuAxisDir(input, 'vertical'), menuAxisEdge(input, 'vertical'), FIXED_DT * 1000)
  let idx = moveCursor(state.pauseIndex, nav.move, pauseItemCount, true)
  idx = applyPointerHover(input, pauseRects, idx)
  const pauseClickHit = pointerClickHit(input, pauseRects)
  if (pauseClickHit >= 0) idx = pauseClickHit
  const moveSfx = menuMoveSfx(state.pauseIndex, idx)

  // 戻る (○/Esc): メニューを閉じて幕(戦闘)へ戻る = 「幕へ戻る」と同じ (2026-07-25 新規)
  if (cancelPressed(input)) {
    consume('step'); if (input.device !== 'pad') consume('pause')
    return { ...base, paused: false, pauseIndex: 0, pausePanel: null, menuNav: nav.next, sfx: ['ui_cancel'] }
  }

  // 確定 (2026-07-26 ユーザー裁定: メニューの決定はkbm=左クリックのみ)
  if (confirmPressed(input, ['attack'])) {
    if (!confirmAllowedByPointer(input, pauseClickHit)) {
      // クリックが項目の外だった: 決定しない (2026-07-25 第2段。 実測で「幕間の記録」の位置を
      //   クリックしたのに「常夜燈の稽古」が始まる誤爆を確認済み)。
      consume('retry'); consume('attack'); consume('parry')
      return { ...base, pauseIndex: idx, menuNav: nav.next }
    }
    consume('retry'); consume('attack'); consume('parry')
    switch (idx) {
      case 0: // 幕へ戻る
        // 項目としては決定だが、 やっていることはメニューを閉じる = 戻る音 (第3段。 ○/Esc と同じ結果に同じ音)。
        return { ...base, paused: false, pauseIndex: 0, pausePanel: null, menuNav: nav.next, sfx: ['ui_cancel'] }
      case 1:
        // 一戦だけモード: 「はじめから」= 同じボスをもう一度 (稽古＝本編の教室へは行かせない)。
        if (state.solo) return restartSolo(state, ['ui_confirm'])
        // 常夜燈の稽古。 下書き印つきの進行なので保存されない (2026-07-26 稽古セーブ破壊修正)。
        return { ...createInitialState(createScratchCampaign()), practice: true, sfx: ['ui_confirm'] }
      case 2: // 幕間の記録
        // サブパネルを開く瞬間: 押しっぱなしの時間を持ち越さない (2026-07-25 第1段-b §5-4)。
        //   nav.next のままだと repeated:true が残っていた場合、開いた先が 400ms 待たずに動く。
        consumeNav()
        return { ...base, pauseIndex: 0, pausePanel: 'records', controlsIndex: 0, controlsCapturing: false, menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false }, sfx: ['ui_confirm'] }
      case 3: // 音と揺れ
        consumeNav()
        return { ...base, pauseIndex: 0, pausePanel: 'settings', menuNav: { dir: menuAxisDir(input, 'vertical'), heldMs: 0, repeated: false }, sfx: ['ui_confirm'] }
      case 4: // タイトルへ戻る
        // 2026-07-26 稽古セーブ破壊修正: 稽古中の残骸/削れたボスHPを持ち越さないよう作り直す。
        //   titleEntered は元の {...state} と同じ値を渡す = 見え方は従来のまま。
        return returnToTitle(state, ['ui_confirm'], state.titleEntered)
    }
  }

  return { ...base, pauseIndex: idx, menuNav: nav.next, sfx: moveSfx }
}
